export default {
    "en": {
        "common": {
            "about_course": "About the course",
            "active": "Active",
            "add": "Add",
            "all_invoices": "All invoices",
            "analyze": "In Analysis",
            "and": "and",
            "anonymous": "Anônimo",
            "apply": "Apply",
            "at": "at",
            "attach": "Attach",
            "attention": "Attention!",
            "back": "Back",
            "billet": "Billet",
            "blocked": "Blocked",
            "blog": "Blog",
            "browser_support_file": "The browser does not support this type of file",
            "buy": "Buy",
            "bind_processing": "Binding students to the classroom... Check the notification for more information.",
            "bind_successfull": "Students bound successfully!",
            "bind_failure": "Error binding students to the classroom!",
            "cancel": "Cancel",
            "canceled": "Canceled",
            "cart": "Cart",
            "chat": "Chat",
            "close": "Close",
            "config": "Settings",
            "confirm": "Confirm",
            "confirm_action": "Confirm action?",
            "contact": "Contact",
            "content": "Content",
            "continue": "Continue",
            "course": "Course",
            "courses": "Courses",
            "create": "Create",
            "created_success": "Created successfully",
            "credit_card": "Credit card",
            "dashboard": "Panel",
            "days": "Days",
            "debit_card": "Debit card",
            "description": "Description",
            "details": "Details",
            "document": "Document",
            "document_type": "Document type",
            "download_file": "Download file",
            "due": "Due date",
            "due_invoices": "Invoices due",
            "duration": "Duration",
            "edit": "Edit",
            "email": "Email",
            "empty_alert": "There are unanswered questions",
            "empty_exercises": "You haven't answered all the questions, do you really want to continue?",
            "empty_survey": "There are no polls at the moment",
            "exercise": "Exercise",
            "exercises": "Exercises",
            "expand": "Expand",
            "expired": "Expired",
            "final_content": "Final content",
            "final_grade": "Grades",
            "financial": "Financial",
            "forum": "Forum",
            "free": "Free",
            "generate_invoice": "Generate Invoice",
            "geolocation_block": "Location not allowed",
            "geolocation_permission": "Enable browser geolocation to log in",
            "geolocation_unsupported": "This browser does not support geolocation",
            "inactive": "Inactive",
            "information": "Information",
            "installments": "Installments",
            "invalid_format": "Invalid format",
            "invoices": "View invoices",
            "issue_date": "Purchase date",
            "justify_answer": "Justify your answer",
            "lesson": "Lesson",
            "lessons": "Lessons",
            "listing": "Listing",
            "load_more_content": "Load more content",
            "location": {
                "addresses": "Addresses",
                "address": "Address",
                "city": "City",
                "number": "Number",
                "neighborhood": "Neighborhood",
                "state": "State",
                "zip_code": "Zip Code",
                "info": "Complement"
            },
            "gamification": "Gamification",
            "module": "Module",
            "modules": "Modules",
            "my_plans": "My plans",
            "name": "Name",
            "new": "New",
            "no_forum": "No forums found",
            "notifications": "Notifications",
            "of": "of",
            "open": "Open",
            "overview": "Overview",
            "paid": "Paid",
            "paid_date": "Pay day",
            "paid_invoices": "Invoices paid",
            "paid_value": "Amount paid",
            "password": "Password",
            "payment_error": "Checkout failed! The transaction could not be processed, please review the data provided and try again.",
            "payment_method": "Payment method",
            "plan": "Plan",
            "plans": "Plans",
            "print_billet": "Print Bill",
            "processing": "Processing",
            "products": "Products",
            "profile": "Profile",
            "public": "Public",
            "receipt": "Receipt",
            "recurrence": "Revenues",
            "register": "Register",
            "remove": "Remove",
            "required_field": "Required field",
            "response": {
                "success": "Sent with success",
                "error": "There was an error, please try again."
            },
            "results": "Result",
            "save": "Save",
            "saved": "Saved",
            "search": "Search",
            "see_less": "View less",
            "select_one": "Select at least one option",
            "send": "Send",
            "showing": "Showing",
            "start": "Start",
            "status": "Status",
            "store": "Plans",
            "support_material": "Support material",
            "tickets": "Tickets",
            "title": "Title",
            "to": "to",
            "to_due": "To due",
            "topics": "Polls",
            "type_search": "Type to search the country",
            "unavailable": "Unavailable",
            "unique_invoice": "Single invoice",
            "upload_error": "Could not send file",
            "value": "Value",
            "views": "Views",
            "zip_error": "Could not load zip code information.",
            "zip_not_found": "An address with this zip code was not found.",
            "loading": "Loading...",
            "error_accessing_content": "Error accessing content."
        },
        "order": {
            "order": "Payment",
            "thanks": "Thank you very much for purchasing our content!",
            "info": "Payment Information",
            "recurrence_question": "Do you want to link this recurrence to a payment method?",
            "value": "Total Payment Amount",
            "yes_link": "Yes, I want to link",
            "no_link": "No",
            "go_to_dashboard": "Go to dashboard",
            "link_recurrence": "Link recurring payment for content"
        },
        "notification": {
            "title": "Notifications",
            "all": "All Notifications"
        },
        "billing": {
            "billing": "Revenues",
            "invoice": {
                "created_at": "Invoice creation date",
                "buy_again": "Buy again",
                "hash": "Invoice number",
                "descrition": "Invoice Description",
                "invoice": "Invoice",
                "invoices": "Invoices",
                "show": "View invoice",
                "pay": "Pay invoice",
                "duplicate": {
                    "title": "Duplicate",
                    "generate": "Generate duplicate"
                },
                "total": "Final invoice amount",
                "fee": "Fine",
                "interest": "Interest",
                "payed": "This invoice has already been paid",
                "processing": "Processing payment",
                "expiry": "Invoice Due Date",
                "expiry_duplicate": "Second Copy Expiration Date",
                "goto_payment": "Go to payment",
                "canceled": "Invoice has been canceled",
                "interest_per_days": "The day after the first invoice is due",
                "billet": {
                    "show": "Show billet",
                    "expirated": "Expirated invoice"
                },
                "status": {
                    "title": "Status",
                    "paid": "Paid",
                    "pending": "Pending",
                    "canceled": "Canceled",
                    "processing": "Processing",
                    "expired": "Expired"
                }
            },
            "recurrence": {
                "status": "Status",
                "recurrence": "Recurrence",
                "subscription": "Subscription",
                "invoices": "Recurrence Invoices",
                "hash": "Recurrence Number",
                "description": "Recurrence Description",
                "due": "Next Expiration",
                "view": "View Recurrence",
                "payment_type": "Linked Payment Method",
                "info": "Recurrence Information",
                "name": "Recurrence Name",
                "plan": "Recurrence Plan",
                "value": "Recurrence Value",
                "cicle": "Cycles",
                "linked_payment": "This recurrence is linked with payment method ",
                "no_linked_payment": "This recurrence is not linked to any payment method",
                "link_payment": "Link Payment Method",
                "unlink_payment": "Unlink Payment Method",
                "null_recurring_payment": "No linked payment methods",
                "no_payment_available": "There are no recurrence payment method avaliable.",
                "status_codes": [
                    "Deactivate",
                    "Activate",
                    "Canceled",
                    "Processing"
                ]
            }
        },
        "glossary": {
            "title": "Glossary",
            "subtitle": "Look up the terms and concepts of your courses.",
            "search": "Search term",
            "all": "All",
            "category": "Category",
            "all_categories": "All categories",
            "course": "Course",
            "general": "General glossary",
            "empty": "No terms found.",
            "examples": "Usage examples",
            "synonyms": "Synonyms",
            "related": "See also",
            "back": "Back to glossary",
            "disabled": "The glossary is not available on this platform.",
            "not_found": "Term not found.",
            "preview_notice": "Student view: this is how students see the glossary.",
            "menu": "Glossary"
        },
        "tags": {
            "id": "Code",
            "year": "Year",
            "month": "Month",
            "next": "Next",
            "previous": "Previous"
        },
        "certificate": {
            "title": "Certificate",
            "description": "Certificate of completion, click on the trophy to get the certificate",
            "print": "Print",
            "download": "Downloadr",
            "validate": "Link to validate the Certificate",
            "code": "Enter the certificate code to validate",
            "validate_button": "Validate",
            "success": "This certificate is valid, check below",
            "error": "Please enter a valid certificate code",
            "validate_description": "Validate Certificate",
            "progress": "You have reached {studentProgress}% of progress, but to be eligible for the certificate, it is necessary to achieve {certificateProgress}% of progress",
            "state": {
                "valid": "Valid certificate",
                "expired": "Expired certificate",
                "not_found": "Certificate not found",
                "disabled": "Public validation is off for this certificate",
                "valid_text": "This certificate was issued by the platform and is authentic.",
                "expired_text": "This certificate exists, but its validity date has passed.",
                "not_found_text": "We did not find a certificate with this code. Check the code and try again.",
                "disabled_text": "The certificate owner has not enabled public validation."
            },
            "summary": {
                "student": "Student",
                "content": "Content",
                "emitted_at": "Issued on",
                "valid_until": "Valid until",
                "code": "Code"
            },
            "validate_at": "Validate at"
        },
        "captcha": {
            "title": "Captcha verification error!",
            "none": "Captcha not created yet.",
            "image": "The selected image is incorrect.",
            "audio": "The letter or number is incorrect.",
            "incomplete": "You must complete the captcha.",
            "wait": "Too many attempts, please wait ",
            "frontend": {
                "accessibilityAlt": "Sound Icon",
                "accessibilityTitle": "Accessibility Option: listen to a question and answer it!",
                "accessibilityDescription": "Write down the <strong> answer </strong> to what you hear. Numbers or words:",
                "explanation": "Click or tap<strong>ANSWER</strong>",
                "refreshAlt": "Reload icon",
                "refreshTitle": "Reload: get new images and accessibility option!"
            },
            "images": {
                "Airplane": "Airplane",
                "Balloons": "Balloons",
                "Camera": "Camera",
                "Car": "Car",
                "Cat": "Cat",
                "Chair": "Chair",
                "Clip": "Clip",
                "Clock": "Clock",
                "Cloud": "Cloud",
                "Computer": "Computer",
                "Envelope": "Envelope",
                "Eye": "eye",
                "Flag": "Flag",
                "Folder": "Folder",
                "Foot": "Foot",
                "Graph": "Graph",
                "House": "House",
                "Key": "Key",
                "Leaf": "Leaf",
                "Light Bulb": "Lamp",
                "Lock": "Lock",
                "Magnifying Glass": "Magnifying Glass",
                "Man": "Man",
                "Music Note": "Musical note",
                "Pants": "Pants",
                "Pencil": "Pencil",
                "Printer": "Printer",
                "Robot": "Robot",
                "Scissors": "Scissors",
                "Sunglasses": "Glasses",
                "Tag": "Tag",
                "Tree": "Tree",
                "Truck": "Truck",
                "T-Shirt": "Shirt",
                "Umbrella": "Umbrella",
                "Woman": "Woman",
                "World": "Planet"
            }
        },
        "lesson": {
            "tabs": {
                "overview": "Overview",
                "polls": "Survey",
                "forum": "Forum"
            },
            "live": {
                "unavailable": "Live lesson not available",
                "start_at": "Start"
            },
            "conference": {
                "unavailable": "Videoconference not available",
                "start_at": "Start"
            },
            "answer_placeholder": "Write your answer",
            "finish_exercise": "End exercise",
            "redo": "Redo",
            "upload_empty": "The upload field cannot be empty",
            "answer_download": "Download answer",
            "exercise_waiting": "Exercise awaiting correction.",
            "exercise_revised": "Corrected exercise.",
            "obs": "Brokers note:",
            "revised_by": "Revised by:",
            "approved": "Approved exercise",
            "reproved": "Failed exercise",
            "conference_lesson": "Lesson: You can participate only as a listener",
            "conference_discussion": "Debate: you can interact, select the camera and microphone",
            "corrected_on": "Corrected in",
            "scorm": {
                "no_entry_sco": "SCORM package has no entry SCO.",
                "init_error": "Error starting SCORM session."
            },
            "publish": {
                "schedule": "This lesson will be released between the dates: ",
                "schedule_end": "This lesson ended on the date: "
            }
        },
        "profile": {
            "secondary": {
                "title": "Secondary Login",
                "created": "Secondary Login Created",
                "deleted": "Secondary Login Deleted",
                "create": "Create Secondary Login",
                "delete": "Delete Secondary Login",
                "warning": "After deletion the email will completely lose its association with your account!",
                "new_secondary": "Create new user",
                "new_secondary_over_limit": "Secondary user limit reached"
            },
            "info": "Profile Information",
            "owner": "Main Login",
            "photo": "Profile picture",
            "additional_info": "Additional Information",
            "category": "Category",
            "document_not_unique": "There is already a student with the document registered"
        },
        "financial": {
            "sales_limit_exceeded": "Sales limit exceeded.",
            "create_coupon": "Create coupon",
            "create_plan": "Create plan",
            "invoices": {
                "attachment_success": "Attachment saved successfully",
                "attachment_failed": "Failed to save attachment",
                "status": {
                    "paid": "Paid",
                    "open": "Open",
                    "overdue": "Overdue",
                    "past_due": "Past Due",
                    "pending": "Processing",
                    "analysing": "In Analysis",
                    "canceled": "Canceled",
                    "deleted": "Deleted"
                }
            },
            "deposit": {
                "title": "Deposit Details",
                "button": "Submit Proof"
            },
            "recurrences": {
                "subscription": "Subscription",
                "access_until": "Access for",
                "monthly": "Monthly",
                "bimonthly": "Bimonthly",
                "quarterly": "Quarterly",
                "semiannual": "Semiannual",
                "yearly": "Yearly",
                "month": "1 month",
                "year": "1 year",
                "months": "{months} months",
                "years": "{years} years",
                "cycles": {
                    "cycles": "Cycles",
                    "infinite": "Infinite",
                    "infinite_description": "Recurrence will be generated indefinitely, or until the student cancels the plan",
                    "custom": "Custom",
                    "custom_description": "Recurrence will be generated for a specified time, with a maximum of 20 times",
                    "month": "1 month",
                    "year": "1 year",
                    "months": "{months} months",
                    "years": "{years} years",
                    "days": "{days} days"
                }
            },
            "stripe": {
                "redirecting": "We are generating your registration, please wait..."
            }
        },
        "pdf": {
            "invoice_generated": "Generated Invoice",
            "invoice_number": "Invoice Number",
            "issue_date": "Emission",
            "due_date": "Due Date",
            "plan_name": "Plan",
            "items": "Items",
            "value": "Value",
            "total": "Total"
        },
        "topic": {
            "topic_title": "Topic title",
            "post": "Post",
            "title": "title",
            "await": "Waiting for approval",
            "question": "topical content",
            "new_moderated": "This forum is moderated by the administrator, your topic will appear in the listing when it is approved.",
            "needs_login": "Log in or create an account to interact on the topic"
        },
        "students": {
            "field_exits": "There is already a student with the value \"{value}\" in the {name} field.",
            "plan": {
                "remove": "Attention! When removing a plan associated with a student's account, it will lead to the loss of progress reports. If this plan has an associated recurrence, it will need to be removed manually. Do you want to proceed with the deletion of this student's plan?",
                "change_status": "Attention! When performing this action, the status of the plan for the student will be updated. If the \"Situation\" of the plan is updated to \"Activated\" it will unlock access for the student and if it is updated to \"Deactivated\" it will block access for the student. If this plan has an associated recurrence, it should be changed manually. Do you want to proceed with the change of this student's plan status?"
            }
        },
        "gamification": {
            "gamification_status": "Gamification Status",
            "gamification_my_points": "My Points",
            "gamification_points": "Points",
            "gamification_content_without_progress": "No progress has been made on this plan",
            "gamification_ranking": "Overall Ranking",
            "gamification_without_ranking": "No one has scored on the platform",
            "gamification_show_hole_progress": "Show all progress",
            "gamification_plan_name": "Plan Name: {plan}",
            "gamification_total_points": "Total Points: {points}",
            "gamification_content_name": "Content Name",
            "gamification_finish_date": "Completion Date",
            "gamification_score": "Score",
            "course_title": "Course",
            "course_rule": "Course Rule",
            "course_rule_goal": "Course Goal",
            "course_rule_points": "Course Points",
            "module_title": "Module",
            "module_rule": "Module Rule",
            "module_rule_goal": "Module Goal",
            "module_rule_points": "Module Points",
            "lesson_title": "Lesson",
            "lesson_rule": "Lesson Rule",
            "lesson_rule_goal": "Lesson Goal",
            "lesson_rule_points": "Lesson Points",
            "exercise_title": "Exercise",
            "exercise_rule": "Exercise Rule",
            "exercise_rule_goal": "Exercise Goal",
            "exercise_rule_points": "Exercise Points",
            "survey_title": "Survey",
            "survey_rule": "Survey Rule",
            "survey_rule_goal": "Survey Goal",
            "survey_rule_points": "Survey Points",
            "certificate_title": "Certificate",
            "certificate_rule": "Certificate Rule",
            "certificate_rule_goal": "Certificate Goal",
            "certificate_rule_points": "Certificate Points",
            "attendance_title": "Attendance",
            "attendance_rule": "Attendance Rule",
            "attendance_rule_goal": "Attendance Goal",
            "attendance_rule_points": "Attendance Points"
        },
        "notification_templates": {
            "APP_TICKET_CREATED": {
                "name": "New Ticket Created",
                "body": "The administrator [[$user_name]] created ticket #[[$ticket_id]]."
            },
            "APP_TICKET_REPLY": {
                "name": "Ticket Answered",
                "body": "New administrator response [[$user_name]] on the ticket #[[$ticket_id]]."
            },
            "APP_TOPIC_REPLY": {
                "name": "New Forum Topic Reply",
                "body": "New topic reply [[$topic_name]] in the content forum [[$content_name]]."
            },
            "APP_TOPIC_REPLY_APPROVED": {
                "name": "Reply Approved on Forum Topic",
                "body": "Your answer in the topic [[$topic_name]] of the content [[$content_name]] was approved."
            },
            "APP_INVOICE_PAID": {
                "name": "Invoice Paid",
                "body": "Invoice payment #[[$invoice_id]] in the amount of [[$invoice_value]] referring to the plan [[$plan_name]] successfully approved."
            },
            "APP_INVOICE_DUE_DATE": {
                "name": "Overdue Invoice",
                "body": "We detected that the invoice #[[$invoice_id]] in the amount of [[$invoice_value]], due on date [[$invoice_due_date]] click for more information."
            },
            "APP_CORRECTED_EXERCISE": {
                "name": "Corrected Exercise",
                "body": "The exercise [[$exercise_name]] has been corrected check your note."
            },
            "APP_NEW_EXERCISE": {
                "name": "New Exercise",
                "body": "The exercise [[$exercise_name]] has been added to plan content [[$plan_name]]."
            },
            "APP_SUSPENDED_PLAN": {
                "name": "Suspended Plan",
                "body": "The plan [[$plan_name]] has been suspended due to pending payments. Click for more information."
            },
            "APP_NEW_MODULE": {
                "name": "New Module",
                "body": "The module [[$module_name]] has been added to the [[$course_name]] of the [[$plan_name]] plan."
            },
            "APP_NEW_LESSON": {
                "name": "New Class",
                "body": "The class [[$lesson_name]] has been added to plan [[$plan_name]] content."
            }
        },
        "exercise": {
            "time": {
                "title": "Response timeout exercise",
                "description": "After starting the exercise, the sending must happen until the time limit expires, otherwise the sending will be automatic",
                "rules": "Once started, the timer will not stop even if the page is reloaded or a content change occurs",
                "remaining": "Time left",
                "limit": "Timeout exercise"
            },
            "validate": {
                "check_error": "Check some alternative",
                "some_question_no_anwser": "Answer all questions"
            },
            "publish": {
                "schedule": "This exercise will be released on: "
            }
        },
        "login": {
            "signin": "Log in",
            "signout": "Log out",
            "register": "Create an account",
            "new_account": "Create a new account",
            "continue": "Continue",
            "continue_user": "Continue as",
            "name": "Name",
            "email": "Email",
            "email_confirmation": "Confirm Email",
            "email_reset": "Reset Email",
            "email_change": "Change Email",
            "domain_invalid": "Incompatible email domain for selected category",
            "document": "Document",
            "document_type": "Document Type",
            "login_type": "Login form",
            "remember": "Remember Login",
            "disconnect_users": "Disconnect devices",
            "device_limit_hint": "Connected device limit reached. You can disconnect the other devices and continue on this one.",
            "disconnect_and_signin": "Disconnect other devices and sign in",
            "validation": {
                "email": "Email is required",
                "password": "Password is required"
            },
            "messages": {
                "update_password": "Update your password to continue",
                "success": "Update your password to continue",
                "error": "Invalid credentials"
            },
            "recovery": {
                "success": "You will receive an email with the link to reset your password",
                "error": "Email not found"
            },
            "password": {
                "title": "Password",
                "confirm": "Confirm the Password",
                "change": {
                    "title": "Change Password",
                    "success": "Password Changed!",
                    "error": "Error changing password"
                },
                "forgot": "Forgot password?",
                "reset": "Reset password"
            },
            "account_created": "Account created successfully! Redirecting...",
            "email_already_exists": "Email already has a registered account",
            "document_type_required": "Document is required",
            "subscribe_message": "Create your account to access",
            "has_account": "Already have an account?",
            "access_here": "Access here."
        },
        "chat": {
            "you_are_banned": "You have been banned from this chat, see your administrator for more information",
            "you_are_accept": "Your chat interaction has been granted",
            "cannot_approve": "You do not have permission to approve chat messages",
            "cannot_ban": "You do not have permission to ban a user",
            "send_placeholder": "Enter your message ...",
            "message_waiting": "Message sent. Wait for moderation.",
            "pending": "Awaiting approval",
            "message_sent_error": "Error sending message",
            "end": "Chat ended",
            "needs_login": "Log in or create an account to interact in chat"
        },
        "wiki": {
            "my_wikis": "My wikis",
            "title": "Wiki",
            "subtitle": "Build the content together with your class.",
            "empty": "You are not part of any wiki yet.",
            "course": "Course",
            "classroom": "Class",
            "relation": {
                "general": "General",
                "plan": "Plan: {name}",
                "course": "Course: {name}"
            },
            "open": "Open wiki",
            "status": {
                "not_started": "Opens on {date}",
                "editing": "Editing",
                "closed": "Closed"
            },
            "deadline": {
                "ends_in": "Due in {days} day|Due in {days} days",
                "ends_today": "Due today",
                "over": "Deadline over",
                "none": "No deadline",
                "not_started": "Opens on {date}"
            },
            "closed_notice": "Editing of this wiki has ended. You can still read it and browse the history.",
            "not_started_notice": "This wiki opens for editing on {date} at {time}. Until then, you can read the content.",
            "read_more": "Read full description",
            "read_less": "Collapse description",
            "participants": "participants",
            "contributions": "contributions",
            "last_update": "Last update",
            "today_at": "today at {time}",
            "yesterday": "yesterday",
            "pages": "Pages",
            "search_page": "Search page",
            "new_page": "New page",
            "new_page_title": "Page title",
            "parent_page": "Parent page (optional)",
            "no_parent": "No parent page",
            "create": "Create page",
            "cancel": "Cancel",
            "page_created": "Page created.",
            "page_locked": "Page locked by the teacher.",
            "locked_short": "Locked",
            "no_pages": "No pages yet.",
            "no_results": "No page found.",
            "select_page": "Pick a page to read.",
            "tabs": {
                "read": "Read",
                "edit": "Edit",
                "history": "History",
                "discussion": "Discussion"
            },
            "last_edit": "Last edit: {user}, {date}",
            "editor": {
                "bold": "Bold",
                "italic": "Italic",
                "heading": "Heading",
                "list": "List",
                "table": "Table",
                "link": "Link",
                "link_url": "Link address",
                "insert": "Insert",
                "summary": "Change summary (optional)",
                "summary_placeholder": "Describe what you changed.",
                "save": "Save change",
                "being_edited": "{user} is editing this page…",
                "cannot_edit": "You cannot edit this page.",
                "conflict_title": "The page was changed by someone else",
                "conflict_text": "Your text was kept below. Compare it with the current version and save again once adjusted.",
                "conflict_mine": "My draft",
                "conflict_theirs": "Current version",
                "use_current": "Discard my draft and load the current version",
                "keep_mine": "Keep my draft",
                "unsaved": "You have unsaved changes on this page. Leave without saving?"
            },
            "files": {
                "send": "Upload file",
                "hint": "Images show up in the text; PDF, PPTX, DOCX, XLSX show up as a downloadable file. Up to 25 MB.",
                "sent": "File uploaded.",
                "invalid": "File not allowed. Upload PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX or XLSX up to 25 MB.",
                "uploading": "Uploading…",
                "remove": "Remove",
                "removed": "File removed."
            },
            "file_download": "Download",
            "history": {
                "version": "Version {number}",
                "by": "by {user}",
                "view": "View version",
                "back": "Back to history",
                "current": "Current",
                "empty": "No versions.",
                "teacher_only": "Restoring versions is up to the teacher."
            },
            "discussion": {
                "title": "Discussion",
                "type": "Type",
                "types": {
                    "question": "Question",
                    "suggestion": "Suggestion",
                    "justification": "Justification",
                    "debate": "Debate"
                },
                "write": "Write your comment",
                "publish": "Publish",
                "reply": "Reply",
                "replying_to": "Replying to {user}",
                "empty": "No comments yet. Start the discussion.",
                "teacher": "TEACHER",
                "closed": "The discussion of this wiki is closed. You can read the comments but not post."
            },
            "feed": {
                "title": "Latest changes",
                "created": "created the page {page}",
                "edited": "{summary} on {page}",
                "commented": "commented on {page}",
                "empty": "No changes yet."
            },
            "version_created": "Page created",
            "version_edited": "Change",
            "version_restored": "Version {number} restored",
            "version_teacher": "Teacher change",
            "cannot_create": "You cannot create pages in this wiki.",
            "cannot_edit": "You cannot edit this page.",
            "conflict": "The page was changed by someone else while you were editing.",
            "saved": "Change saved.",
            "comment_published": "Comment published.",
            "error": "Could not complete. Try again."
        },
        "empty": {
            "unique_invoice_title": "No invoices to show",
            "unique_invoice_subtitle": "Here all your unique invoices will appear.",
            "recurrence_title": "No recurrences to show.",
            "recurrence_subtitle": "Here all your recurrences will appear.",
            "filter_title": "Your search returned no results",
            "filter_subtitle": "Try again with new parameters",
            "topic_title": "No topics found"
        },
        "auth": {
            "failed": "Invalid credentials",
            "device": "Device limit connected with this account reached",
            "userselect": "Select your user to continue",
            "terms_accept": "You must accept the terms of use before continuing",
            "deactivated": "Student is suspended from the platform!"
        },
        "form": {
            "address": {
                "country": "Country",
                "state": "State",
                "city": "City",
                "address": "Address",
                "number": "Number",
                "neighborhood": "Neighborhood",
                "info": "Complement",
                "cep": "Zip code",
                "invalid_zip": "Invalid zip code",
                "fill_zip": "Fill in the zip code field"
            }
        },
        "content": {
            "course_content": "Course content",
            "lesson_content": "Lesson Content",
            "description": "Description",
            "download_content": "Downloadable content",
            "lock": {
                "PLAN_EXPIRED": "This plan has expired",
                "PLAN_UNAVAILABLE": "Plan unavailable",
                "SCHEDULE": "Scheduled content {details}",
                "SCHEDULE_SALE": "Released after {details}",
                "PROGRESS": "Minimum {details} progress not achieved",
                "GRADE": "Minimum grade {details} not reached",
                "AVAILABLE": "Available content",
                "UNAVAILABLE": "Unavailable content",
                "VIEWS_LIMIT": "View limit reached",
                "WAITING_AUTHORIZATION": "Awaiting authorization",
                "WAITING_EXTERNAL_STATUS": "Unconfirmed enrollment",
                "NOT_FREE_AFTER_CONTENT": "It is necessary to wait for {details} days until you release this class or unlock the previous content."
            },
            "uploads": {
                "url": "Url",
                "open_link": "Open file",
                "upload": "Upload",
                "title": "Uploads",
                "create": "Send Files",
                "edit": "Edit file",
                "files": "Files",
                "file": "File",
                "various_files": "Misc Files",
                "unsupported_preview": "No preview available",
                "name": "Name",
                "clear_list": "Clear queue",
                "description": "Description",
                "send_file": "Send file",
                "send_image": "Send image",
                "send_media": "Send files",
                "message": "Drag and drop your file here",
                "info": "Or",
                "remove": "Remove File",
                "cancel": "Cancel upload",
                "confirm": "Are you sure you want to cancel the submission?",
                "unsupported": "Your browser does not support sending by dragging the file",
                "fallback": "Please use the form to send the file",
                "type": "It is not possible to send files with this format",
                "exceeded": "Submit at most",
                "once": "once",
                "error": "Failed to upload file.",
                "canceled": "Sending canceled",
                "validate": "Select a file",
                "created_at": "Send date",
                "sent": "Sent",
                "size": "Size",
                "change": "Send file",
                "attachment": "Attachment",
                "docs": "Documents",
                "images": "Images",
                "videos": "Videos",
                "audios": "Audios",
                "all": "All files",
                "select": "Select",
                "use": "Select",
                "media_gallery": "Media Gallery",
                "rules_failed": "You have reached the maximum download limit",
                "instruction": "Drop your file here or click to select",
                "warning": "Do not close the window until the download is complete",
                "max_size": "Maximum file size: 10GB"
            },
            "exercise": {
                "exercise": "Exercise",
                "questions": "Questions:",
                "utilization": "Utilization",
                "error": {
                    "no_connection": "Impossible to connect to the server. Please try again later.",
                    "upload": "Error sending file, check the size and format of the file or try again later."
                }
            },
            "lesson": {
                "video": "Video Content",
                "video_n": "Video",
                "upload": "Support file",
                "public_lesson": "Public Lesson",
                "watch_now": "Watch Now"
            },
            "type": {
                "live": "Live",
                "file": "File"
            },
            "open": {
                "new_tab": "New tab"
            }
        },
        "cart": {
            "recurrence": {
                "title": "Recurrences",
                "monthly": "Monthly",
                "bimonthly": "Bimonthly",
                "quarterly": "Quarterly",
                "semiannual": "semiannual",
                "yearly": "Yearly",
                "custom": "Charged every",
                "days": "Days",
                "change_payment": "Choose the recurrence payment method",
                "cpf": "CPF",
                "holder_cpf": "Holder CPF",
                "area_code": "Area code",
                "phone_number": "Telephone number",
                "name": "Name",
                "holder": "Holder",
                "card_holder": "Card Holder Name (as written on the card)",
                "gerencia_net": "Net Management",
                "birth": "Date of birth",
                "credit_card_brand": "Card banner",
                "credit_card_number": "Card Number",
                "card_number": "Número do cartão",
                "credit_card_cvv": "CVV",
                "credit_card_expiration_month": "Card Expiration Month",
                "credit_card_expiration_year": "Card Expiration Year",
                "payment_alert": "Only 1 item of the recurring type in the cart is allowed if the payment method is GerenciaNet",
                "approve_text": "Approve Recurrence",
                "have_recurrence": "Attention, you already have an item in your cart, to add a recurring item you must complete the purchase or clean the cart",
                "recurrence": "Informações adicionais para pagamento com recorrência",
                "invalid_birthdate": "Data de nascimento inválida",
                "invalid_phone_number": "Número de telefone inválido",
                "invalid_checkout": "Fill in additional information for recurring payment"
            },
            "coupon": {
                "has_coupon": "Have a discount coupon?",
                "placeholder": "CODE",
                "apply": "To apply",
                "discount_coupon": "Discount coupon",
                "coupon": "Coupon",
                "add": "Apply a discount coupon"
            },
            "add_item": {
                "failed": "Failed to add item to cart",
                "recurrence_failed": "Recurring item already added to cart"
            },
            "pay": "Make Payment",
            "change_payment": "Fill in the payment details",
            "cart": "Shopping cart",
            "go_to_cart": "Go to Cart",
            "subscribe": "Sign up",
            "add_to_cart": "Add to cart",
            "access_plan": "Access Plan",
            "plan_info": "Plan information",
            "payment_type": "Form of payment",
            "product": "Product",
            "price": "Price",
            "checkout": "Payment",
            "type": "Plan Period",
            "type_recurrence": "Recurring Payment",
            "type_unique": "Single Payment",
            "discount": "Discount",
            "total": "Total: ",
            "finish": "Finish",
            "empty": "Your cart is empty",
            "empty_message": " Before going to checkout you must add some product to your cart.",
            "empty_button": "Keep buying",
            "currency": "Currency",
            "filter": "Filter",
            "filter_by": "Filter by",
            "remove_failed": "Trying to remove item from cart failed",
            "admin_message": "It was not possible to make the purchase, make sure you are logged in as a student",
            "plans": {
                "types": "Types of Plans",
                "public": "Public",
                "free": "Free",
                "single_purchase": "Single Payment",
                "recurrence": "Recurrent",
                "value": "Plan Amount"
            },
            "min_price": "Lowest price",
            "max_price": "Biggest price",
            "clean_filters": "Clear Filters",
            "clear": "Limpar o Carrinho",
            "item_added": "Item added to cart!",
            "code": "Code",
            "code_empty": "Mandatory code",
            "free_item_add": "Enrolled successfully!",
            "free_item_wait": "Plan added to your account, wait for authorization for your subscription",
            "deleted": "Cart item successfully removed!",
            "item": {
                "added": "Item added to cart!",
                "removed": "Item removed from cart",
                "exists": "Product already added to cart"
            },
            "obs": "Obs:",
            "obs_message": "Payment can take up to 72 hours to be approved.",
            "billet_bank": "To make payment with ",
            "billet_bank_redirect": "click on the button below and you will be redirected to the bank slip printing page.",
            "billet_dare": "To issue the DARE payment slip, click the button below and you will be redirected to the DARE slip printing page.",
            "paypal_message": "To make the payment with Paypal, click on the button below and you will be redirected to the Paypal website.",
            "stripe_message": "To make the payment with Stripe Checkout, click on the button below and you will be redirected to the Stripe website.",
            "stripe_message_no_recurrency": "Recurring payments are not yet available for Stripe. Please choose another payment method.",
            "checkout_stripe": "Checkout Stripe",
            "payment_intent_stripe": "Stripe",
            "stripe": {
                "card_number": "Card Number",
                "card_expiry": "Expiration",
                "card_cvc": "CVC",
                "card_already_registered": "You already have a registered card!",
                "card_last_digits": "Last Card Digits",
                "card_brand": "Card Brand",
                "card_status": "Status",
                "remove_payment_method": "Remove Payment Method",
                "payment_method": "Payment Method ",
                "card_exp_month": "Expiration Month",
                "card_exp_year": "Expiration Year",
                "create_token": "Create Payment Method",
                "update_token": "Update Payment Method"
            },
            "pagseguro_message": "To make the payment with PagSeguro, click on the button below and you will be redirected to the PagSeguro website.",
            "credit_card_message": "To make the payment with the credit card, click on the button below and you will be redirected to make the payment.",
            "credit_card_installments_message": "To make the payment with the credit card, choose the number of installments and click the button below to be redirected to the payment page.",
            "credit_card_obs": "Payment can take up to 48 hours to be approved.",
            "paypal_obs": "Payment can take up to 24 hours to be approved.",
            "stripe_obs": "Payment can take up to 24 hours to be approved.",
            "paypal": "Paypal",
            "pagseguro": "PagSeguro",
            "pagseguro_billet_message": "To make the payment with PagSeguro, click on the button below and you will be redirected to the PagSeguro website.",
            "pagseguro_billet_generate": "Generate Boleto",
            "pagseguro_billet_pdf": "Download Boleto",
            "pix": "Pix",
            "pix_message": "To make the payment with Pix, click on the button below and you will be redirected to the Pix payment page.",
            "pix_key": "Pix Key",
            "pix_copy": "Copy Pix Key",
            "dare": "DARE",
            "credit_card": "Credit Card",
            "deposit": "Bank deposit",
            "deposit_message": "To make the payment with an electronic transfer of values, click on the button below and after that you will be redirected to the page with the bank details and the field of attachment of the proof of payment.",
            "make_payment": "Make Payment with ",
            "finish_payment": "Thank you for your purchase!",
            "plan_activate": "Your plan will be activated once the payment is completed.",
            "address": {
                "address": "address",
                "insert": "Please, register an address",
                "invalid": "Sorry, we were unable to save the address"
            },
            "checkout_errors": {
                "brand_not_identified": "We could not identify the card brand. Check the card number or select the brand manually.",
                "brand_not_accepted": "The {brand} brand is not accepted by this payment method.",
                "pending_invoice_multiple": "There is already an open invoice for one of the cart items. Pay the invoice under Financial or remove the item to continue.",
                "payment_reversed": "The card charge was automatically cancelled and no amount will be debited.",
                "payment_not_reversed": "The charge could not be cancelled automatically. Please contact support with the time of the purchase."
            }
        },
        "blog": {
            "share": "Share",
            "share_on": "Share on: social",
            "copy_url": "Copy url",
            "posts": {
                "by": "Published by",
                "views": "Views",
                "search": "Search publication",
                "latest": "Latest publications",
                "no_data": "No posts"
            },
            "comments": {
                "title": "Comments",
                "reply_to": "Answer to: author",
                "no_replies": "No answer",
                "show_replies": "Show replies",
                "login_comment": "Log in and leave your comment",
                "form_title": "leave a comment",
                "no_data": "No comments yet",
                "send": "Submit",
                "reply": "Reply",
                "replies": "Replies",
                "load_more": "View more comments"
            },
            "categories": {
                "title": "categories",
                "more": "Show more"
            },
            "tags": {
                "see_more": "See more about:"
            }
        },
        "header": {
            "cart": {
                "empty": "Your shopping cart is empty."
            },
            "profile": {
                "title": "Profile",
                "logout": "Log out",
                "welcome": "Welcome",
                "notifications": "Notifications",
                "cart": "Cart",
                "menus": "Menus"
            },
            "notifications": {
                "you_have": "You have",
                "notification": "notification.",
                "notifications": "notifications.",
                "all": "View All",
                "ago": "ago",
                "marker_all_read": "Mark all as read"
            }
        },
        "class": {
            "back_to_plan": "Back to plan",
            "course_content": "Course content",
            "forum": "Forum",
            "hasnt_forum": "Has not a forum",
            "description": "Description",
            "certificate_without_progress": "Progresso suficiente não atingido para receber certificado"
        },
        "support": {
            "submit": "Submit contact",
            "support_form": "Contact Form",
            "label": "Subject matter",
            "invalid_email": "Invalid email.",
            "sent_success": "Contact email sent successfully!",
            "title": "Support",
            "show_more": "Show more",
            "chat": {
                "title": "Chat",
                "search": "Search",
                "write_message": "Write a message",
                "send": "Send",
                "finish": "Finish Chat Interactions",
                "last_interaction": "Last interaction",
                "interaction_finish": "Interaction finished",
                "attendant": "Attendant",
                "send_placeholder": "Enter your message ..."
            },
            "forum": "Forum",
            "forum_answer": "Answers",
            "forums": {
                "title": "Forum",
                "type": "Forum Type",
                "moderated": "Moderated",
                "number_topics": "Number of Topics",
                "view_topics": "View Topics",
                "inactive": "Disable Forum",
                "active": "Activate Forum",
                "remove": "Remove Forum",
                "remove_forum_warning": "When removing the forum, all topics and replies will be deleted. Are you sure you want to proceed?",
                "topics": {
                    "title": "Topics",
                    "name": "Topic Name",
                    "number_answers": "Number of Interactions",
                    "status": "Status",
                    "user": "Topic Creator",
                    "created_date": "Creation Date",
                    "answers": "Answers",
                    "edit": "Edit Topic",
                    "remove": "Remove Topic",
                    "update_name": "Update Topic Name"
                },
                "create": "Create Forum",
                "waiting_for_approval": "Waiting for Approval",
                "updated_at": "Updated Date"
            },
            "forum_answers": {
                "view": "View Answers",
                "title": "Topic Interactions",
                "reply_placeholder": "Write a Reply...",
                "topic_edit_placeholder": "Editing the text..."
            },
            "settings": {
                "title": "Support Settings",
                "email": "Email",
                "labels": "Subjects",
                "label": "Subject",
                "add_label": "Add Label",
                "remove_label": "Remove Label",
                "enable_ticket": "Ticket Support",
                "email_title": "Email",
                "ticket_title": "Ticket",
                "chat_title": "Chat",
                "enable_email": "Email Support",
                "enable_chat": "Chat Support",
                "support_form": "Support Contact Form"
            },
            "tickets": {
                "ticket": "Ticket",
                "tickets": "Tickets",
                "create": "New Ticket",
                "title": "Subject",
                "search": "Search by ID or Ticket Title",
                "content": "Reply Message",
                "send": "Send",
                "plan": "Plan",
                "send_success": "Message sent successfully",
                "resolved": "Ticket resolved",
                "delete_many": "Remove Ticket(s)",
                "delete": "Remove Ticket",
                "operator": "Operator",
                "change_operator": "Change Operator",
                "student": "Subscriber",
                "department": "Department",
                "created_at": "Created at",
                "last_reply": "Last Interaction",
                "waiting_time": "{user} is waiting for a response for {time}",
                "status": "Status",
                "some": "a ticket",
                "view": "View Ticket",
                "id": "ID",
                "all": "All",
                "reply": "Message",
                "reply_error": "Failed to send response",
                "close": "Close Ticket",
                "situation": {
                    "OPEN": "Open",
                    "WAITING_STUDENT": "Waiting for Subscriber",
                    "WAITING_OP": "Waiting for Operator",
                    "CLOSED": "Closed",
                    "RESOLVED": "Resolved",
                    "IN_PROCESS": "In Progress"
                },
                "number_ticket": "Ticket No."
            },
            "labels": {
                "labels": "Departments",
                "manager": "Manage Departments",
                "find": "Type to search for departments"
            },
            "map": {
                "contact_info": "Contact Information",
                "telephone": "Phone",
                "address": "Address"
            }
        },
        "course": {
            "tabs": {
                "wiki": "Class wiki",
                "glossary": "Glossary",
                "overview": "Overview",
                "content": "Content",
                "forum": "Forum"
            },
            "start": "Start",
            "continue": "Continue",
            "modules": "Modules",
            "lessons": "Lessons",
            "exercises": "Exercises",
            "topics": "Topics",
            "show_more": "Show more",
            "module_no_content": "This module has no content",
            "course_no_content": "There is no content available for viewing at the moment",
            "publish": {
                "schedule": "This course will be released between the dates: ",
                "schedule_end": "This course ended on the date: "
            }
        },
        "module": {
            "publish": {
                "schedule": "This module will be released between the dates: ",
                "schedule_end": "This module ended on date: "
            }
        },
        "payment_erros": {
            "stripe": {
                "account_closed": "The customer’s bank account has been closed.",
                "account_country_invalid_address": "The country of the business address provided does not match the country of the account. Businesses must be located in the same country as the account.",
                "account_error_country_change_requires_additional_steps": "Your account has already onboarded as a Connect platform. Changing your country requires additional steps. Please reach out to Stripe support for more information.",
                "account_information_mismatch": "Some account information mismatches with one another. For example, some banks might require that the business_profile.name must match the account holder name.",
                "account_invalid": "The account ID provided as a value for the Stripe-Account header is invalid. Check that your requests are specifying a valid account ID.",
                "account_number_invalid": "The bank account number provided is invalid (e.g., missing digits). Bank account information varies from country to country. We recommend creating validations in your entry forms based on the bank account formats we provide.",
                "acss_debit_session_incomplete": "The ACSS debit session is not ready to transition to complete status yet. Please try again the request later.",
                "alipay_upgrade_required": "This method for creating Alipay payments is not supported anymore. Please upgrade your integration to use Sources instead.",
                "amount_too_large": "The specified amount is greater than the maximum amount allowed. Use a lower amount and try again.",
                "amount_too_small": "The specified amount is less than the minimum amount allowed. Use a higher amount and try again.",
                "api_key_expired": "The API key provided has expired. Obtain your current API keys from the Dashboard and update your integration to use them.",
                "application_fees_not_allowed": "The proposed money movement could not be completed due to regulatory reasons.",
                "authentication_required": "The payment requires authentication to proceed. Please authenticate or try a different payment method.",
                "balance_insufficient": "The transfer or payout could not be completed because the associated account does not have a sufficient balance available. Create a new transfer or payout using an amount less than or equal to the account’s available balance.",
                "balance_invalid_parameter": "Invalid parameter was provided in the balance method object. Check our API documentation or the returned error message for more context.",
                "bank_account_bad_routing_numbers": "The bank account is known to not support the currency in question.",
                "bank_account_declined": "The bank account provided can not be used to charge, either because it is not verified yet or it is not supported.",
                "bank_account_exists": "The bank account provided already exists on the specified Customer object. If the bank account should also be attached to a different customer, include the correct customer ID when making the request again.",
                "bank_account_restricted": "The customer’s account cannot be used with the payment method.",
                "bank_account_unusable": "The bank account provided cannot be used. A different bank account must be used.",
                "bank_account_unverified": "Your Connect platform is attempting to share an unverified bank account with a connected account.",
                "bank_account_verification_failed": "The bank account cannot be verified, either because the microdeposit amounts provided do not match the actual amounts, or because verification has failed too many times.",
                "billing_invalid_mandate": "The Subscription or Invoice attempted payment on a PaymentMethod without an active mandate. In order to create Subscription or Invoice payments with this PaymentMethod, it must be confirmed on-session with a PaymentIntent or SetupIntent first.",
                "billing_policy_remote_function_response_invalid": "A billing policy remote function endpoint response returned invalid data.",
                "billing_policy_remote_function_timeout": "A billing policy remote function timed out.",
                "billing_policy_remote_function_unexpected_status_code": "A billing policy remote function returned an invalid status code.",
                "billing_policy_remote_function_unreachable": "There was an error while executing a billing policy remote function.",
                "bitcoin_upgrade_required": "This method for creating Bitcoin payments is not supported anymore. Please upgrade your integration to use Sources instead.",
                "capture_charge_authorization_expired": "The charge cannot be captured as the authorization has expired. Refer to the payment method’s documentation to learn more.",
                "capture_unauthorized_payment": "The charge you’re attempting to capture has not been authorized for capturing payment.",
                "card_decline_rate_limit_exceeded": "This card has been declined too many times. You can try to charge this card again after 24 hours. We suggest reaching out to your customer to make sure they have entered all of their information correctly and that there are no issues with their card.",
                "card_declined": "The card has been declined. When a card is declined, the error returned also includes the decline_code attribute with the reason why the card was declined. Refer to our decline codes documentation to learn more.",
                "cardholder_phone_number_required": "You must have a phone_number on file for Issuing Cardholders who will be creating EU cards. You cannot create EU cards without a phone_number on file for the cardholder. See the 3D Secure Documenation for more details.",
                "charge_already_captured": "The charge you’re attempting to capture has already been captured. Update the request with an uncaptured charge ID.",
                "charge_already_refunded": "The charge you’re attempting to refund has already been refunded. Update the request to use the ID of a charge that has not been refunded.",
                "charge_disputed": "The charge you’re attempting to refund has been charged back. Check the disputes documentation to learn how to respond to the dispute.",
                "charge_exceeds_source_limit": "This charge would cause you to exceed your rolling-window processing limit for this source type. Please retry the charge later, or contact us to request a higher processing limit.",
                "charge_expired_for_capture": "The charge cannot be captured as the authorization has expired. Auth and capture charges must be captured within a set number of days (7 by default).",
                "charge_invalid_parameter": "One or more provided parameters was not allowed for the given operation on the Charge. Check our API reference or the returned error message to see which values were not correct for that Charge.",
                "charge_not_refundable": "Attempt to refund a charge was unsuccessful because the charge is no longer refundable.",
                "clearing_code_unsupported": "The clearing code provided is not supported.",
                "country_code_invalid": "The country code provided was invalid.",
                "country_unsupported": "Your platform attempted to create a custom account in a country that is not yet supported. Make sure that users can only sign up in countries supported by custom accounts.",
                "coupon_expired": "The coupon provided for a subscription or order has expired. Either create a new coupon, or use an existing one that is valid.",
                "customer_max_payment_methods": "The maximum number of PaymentMethods for this Customer has been reached. Either detach some PaymentMethods from this Customer or proceed with a different Customer.",
                "customer_max_subscriptions": "The maximum number of subscriptions for a customer has been reached. Contact us if you are receiving this error.",
                "customer_tax_location_invalid": "The customer location information cannot be used to accurately determine tax rates. Verify that address fields such as country, state, and postal code have been added correctly. See the supported address formats.",
                "debit_not_authorized": "The customer has notified their bank that this payment was unauthorized.",
                "email_invalid": "The email address is invalid (e.g., not properly formatted). Check that the email address is properly formatted and only includes allowed characters.",
                "expired_card": "The card has expired. Check the expiration date or use a different card.",
                "financial_connections_account_inactive": "Data cannot be refreshed on inactive Financial Connections accounts.",
                "financial_connections_no_successful_transaction_refresh": "Transaction data can only be retrieved for accounts that have at least one successful transaction refresh.",
                "forwarding_api_inactive": "The vault and forward API is currently not accessible with this account and/or config. Please contact us if you are receiving this error.",
                "forwarding_api_invalid_parameter": "Invalid parameter was provided in the vault and forward API. Check our API documentation or the returned error message for more context.",
                "forwarding_api_upstream_connection_error": "Stripe did not receive a response from the destination endpoint.",
                "forwarding_api_upstream_connection_timeout": "The request to the destination endpoint timed out.",
                "idempotency_key_in_use": "The idempotency key provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.",
                "incomplete_name": "Yor name is incomplete. Check the name and try again.",
                "incorrect_address": "The address is incorrect. Check the address and try again.",
                "incomplete_address": "The address provided is incomplete.",
                "invalid_expiry_year_past": "The card’s expiration year is in the past. Check the expiration date or use a different card.",
                "incomplete_cvc": "The card’s security code is incomplete. Check the card’s security code or use a different card.",
                "incomplete_expiry": "The card’s expiration date is incomplete. Check the expiration date or use a different card.",
                "incorrect_expiry_month": "The card’s expiration month is incorrect. Check the expiration date or use a different card.",
                "incorrect_expiry_year": "The card’s expiration year is incorrect. Check the expiration date or use a different card.",
                "incorrect_cvc_length": "The CVC provided is invalid (e.g., it is the wrong length). Check the CVC and try again.",
                "incorret_boleto_tax_id": "The tax ID provided is invalid. Check the tax ID and try again.",
                "incorrect_cvc": "The card’s security code is incorrect. Check the card’s security code or use a different card.",
                "incorrect_number": "The card number is incorrect. Check the card’s number or use a different card.",
                "incorrect_zip": "The card’s postal code is incorrect. Check the card’s postal code or use a different card.",
                "incomplete_number": "The card number is incomplete. Check the card’s number or use a different card.",
                "instant_payouts_config_disabled": "This connected account is not eligible for Instant Payouts. Ask the platform to enable Instant Payouts.",
                "instant_payouts_currency_disabled": "This connected account is not eligible for Instant Payouts in this currency. Ask the platform to enable Instant Payouts in this currency.",
                "instant_payouts_limit_exceeded": "You have reached your daily processing limits for Instant Payouts.",
                "instant_payouts_unsupported": "This card is not eligible for Instant Payouts. Try a debit card from a supported bank.",
                "insufficient_funds": "The customer’s account has insufficient funds to cover this payment.",
                "intent_invalid_state": "Intent is not in the state that is required to perform the operation.",
                "intent_verification_method_missing": "Intent does not have verification method specified in its PaymentMethodOptions object.",
                "invalid_card_type": "The card provided as an external account is not supported for payouts. Provide a non-prepaid debit card instead.",
                "invalid_characters": "This value provided to the field contains characters that are unsupported by the field.",
                "invalid_charge_amount": "The specified amount is invalid. The charge amount must be a positive integer in the smallest currency unit, and not exceed the minimum or maximum amount.",
                "invalid_cvc": "The card’s security code is invalid. Check the card’s security code or use a different card.",
                "invalid_expiry_month": "The card’s expiration month is incorrect. Check the expiration date or use a different card.",
                "invalid_expiry_year": "The card’s expiration year is incorrect. Check the expiration date or use a different card.",
                "invalid_number": "The card number is invalid. Check the card details or use a different card.",
                "invalid_source_usage": "The source cannot be used because it is not in the correct state (e.g., a charge request is trying to use a source with a pending, failed, or consumed source). Check the status of the source you are attempting to use.",
                "invalid_tax_location": "The specified location is invalid. Check the Supported address formats for the address formats supported when calculating tax.",
                "invoice_no_customer_line_items": "An invoice cannot be generated for the specified customer as there are no pending invoice items. Check that the correct customer is being specified or create any necessary invoice items first.",
                "invoice_no_payment_method_types": "An invoice cannot be finalized because there are no payment method types available to process the payment. Your invoice template settings or the invoice’s payment_settings might be restricting which payment methods are available, or you might need to activate more payment methods in the Dashboard.",
                "invoice_no_subscription_line_items": "An invoice cannot be generated for the specified subscription as there are no pending invoice items. Check that the correct subscription is being specified or create any necessary invoice items first.",
                "invoice_not_editable": "The specified invoice can no longer be edited. Instead, consider creating additional invoice items that will be applied to the next invoice. You can either manually generate the next invoice or wait for it to be automatically generated at the end of the billing cycle.",
                "invoice_on_behalf_of_not_editable": "You cannot update the on_behalf_of property of an invoice after the invoice has been assigned a number.",
                "invoice_payment_intent_requires_action": "This payment requires additional user action before it can be completed successfully. Payment can be completed using the PaymentIntent associated with the invoice. See this page for more details.",
                "invoice_upcoming_none": "There is no upcoming invoice on the specified customer to preview. Only customers with active subscriptions or pending invoice items have invoices that can be previewed.",
                "livemode_mismatch": "Test and live mode API keys, requests, and objects are only available within the mode they are in.",
                "lock_timeout": "This object cannot be accessed right now because another API request or Stripe process is currently accessing it. If you see this error intermittently, retry the request. If you see this error frequently and are making multiple concurrent requests to a single object, make your requests serially or at a lower rate. See the rate limit documentation for more details.",
                "missing": "Both a customer and source ID have been provided, but the source has not been saved to the customer. To create a charge for a customer with a specified source, you must first save the card details.",
                "no_account": "The bank account could not be located.",
                "not_allowed_on_standard_account": "Transfers and payouts on behalf of a Standard connected account are not allowed.",
                "no_payment_method": "No payment method is available for use with this operation.",
                "out_of_inventory": "One or more line item(s) are out of stock. If more stock is available, update the inventory’s orderable quantity and try again.",
                "ownership_declaration_not_allowed": "Company ownership declaration is allowed only during account updates and accounts created via account tokens.",
                "parameter_invalid_empty": "One or more required values were not provided. Make sure requests include all required parameters.",
                "parameter_invalid_integer": "One or more of the parameters requires an integer, but the values provided were a different type. Make sure that only supported values are provided for each attribute. Refer to our API documentation to look up the type of data each attribute supports.",
                "parameter_invalid_string_blank": "One or more values provided only included whitespace. Check the values in your request and update any that contain only whitespace.",
                "parameter_invalid_string_empty": "One or more required string values is empty. Make sure that string values contain at least one character.",
                "parameter_missing": "One or more required values are missing. Check our API documentation to see which values are required to create or modify the specified resource.",
                "parameter_unknown": "The request contains one or more unexpected parameters. Remove these and try again.",
                "parameters_exclusive": "Two or more mutually exclusive parameters were provided. Check our API documentation or the returned error message to see which values are permitted when creating or modifying the specified resource.",
                "payment_intent_action_required": "The provided payment method requires customer actions to complete, but error_on_requires_action was set. If you’d like to add this payment method to your integration, we recommend that you first upgrade your integration to handle actions.",
                "payment_intent_authentication_failure": "The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this PaymentIntent again.",
                "payment_intent_incompatible_payment_method": "The PaymentIntent expected a payment method with different properties than what was provided.",
                "payment_intent_invalid_parameter": "One or more provided parameters was not allowed for the given operation on the PaymentIntent. Check our API reference or the returned error message to see which values were not correct for that PaymentIntent.",
                "payment_intent_konbini_rejected_confirmation_number": "The confirmation_number provided in payment_method_options[konbini] was rejected by the processing partner at time of PaymentIntent confirmation.",
                "payment_intent_mandate_invalid": "The provided mandate is invalid and can not be used for the payment intent.",
                "payment_intent_payment_attempt_expired": "The latest payment attempt for the PaymentIntent has expired. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.",
                "payment_intent_payment_attempt_failed": "The latest payment attempt for the PaymentIntent has failed. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.",
                "payment_intent_unexpected_state": "The PaymentIntent’s state was incompatible with the operation you were trying to perform.",
                "payment_method_bank_account_already_verified": "This bank account has already been verified.",
                "payment_method_bank_account_blocked": "This bank account has failed verification in the past and can not be used. Contact us if you wish to attempt to use these bank account credentials.",
                "payment_method_billing_details_address_missing": "The PaymentMethod’s billing details is missing address details. Please update the missing fields and try again.",
                "payment_method_configuration_failures": "Attempt to create or modify Payment Method Configuration was unsuccessful.",
                "payment_method_currency_mismatch": "The currency specified does not match the currency for the attached payment method. A payment can only be created for the same currency as the corresponding payment method.",
                "payment_method_customer_decline": "The customer did not approve the payment. Please provide a new payment method to attempt to fulfill this intent again.",
                "payment_method_invalid_parameter": "Invalid parameter was provided in the payment method object. Check our API documentation or the returned error message for more context.",
                "payment_method_invalid_parameter_testmode": "The parameter provided for payment method is not allowed to be used in testmode. Check our API documentation or the returned error message for more context.",
                "payment_method_microdeposit_failed": "Microdeposits were failed to be deposited into the customer’s bank account. Please check the account, institution and transit numbers as well as the currency type.",
                "payment_method_microdeposit_verification_amounts_invalid": "You must provide exactly two microdeposit amounts.",
                "payment_method_microdeposit_verification_amounts_mismatch": "The amounts provided do not match the amounts that were sent to the bank account.",
                "payment_method_microdeposit_verification_attempts_exceeded": "You have exceeded the number of allowed verification attempts.",
                "payment_method_microdeposit_verification_descriptor_code_mismatch": "The verification code provided does not match the one sent to the bank account.",
                "payment_method_microdeposit_verification_timeout": "Payment method should be verified with microdeposits within the required period.",
                "payment_method_not_available": "The payment processor for the provided payment method is temporarily unavailable. Please try a different payment method or retry later with the same payment method.",
                "payment_method_provider_decline": "The payment or setup attempt was declined by the issuer or customer. Check the last_payment_error or last_setup_error property on the PaymentIntent or SetupIntent respectively for more details, and provide a new payment method to attempt to fulfill this intent again.",
                "payment_method_provider_timeout": "The payment method failed due to a timeout. Check the last_payment_error or last_setup_error property on the PaymentIntent or SetupIntent respectively for more details, and provide a new payment method to attempt to fulfill this intent again.",
                "payment_method_unactivated": "The operation cannot be performed as the payment method used has not been activated. Activate the payment method in the Dashboard, then try again.",
                "payment_method_unexpected_state": "The provided payment method’s state was incompatible with the operation you were trying to perform. Confirm that the payment method is in an allowed state for the given operation before attempting to perform it.",
                "payment_method_unsupported_type": "The API only supports payment methods of certain types.",
                "payout_reconciliation_not_ready": "Reconciliation for this payout is still in progress.",
                "payouts_limit_exceeded": "You have reached your daily processing limits for this payout type.",
                "payouts_not_allowed": "Payouts have been disabled on the connected account. Check the connected account’s status to see if any additional information needs to be provided, or if payouts have been disabled for another reason.",
                "platform_account_required": "Only Stripe Connect platforms can work with other accounts. If you need to setup a Stripe Connect platform, you can do so in the dashboard.",
                "platform_api_key_expired": "The API key provided by your Connect platform has expired. This occurs if your platform has either generated a new key or the connected account has been disconnected from the platform. Obtain your current API keys from the Dashboard and update your integration, or reach out to the user and reconnect the account.",
                "postal_code_invalid": "The postal code provided was incorrect.",
                "processing_error": "An error occurred while processing the card. Try again later or with a different payment method.",
                "product_inactive": "The product this SKU belongs to is no longer available for purchase.",
                "progressive_onboarding_limit_exceeded": "Progressive onboarding limit has been reached for the platform.",
                "rate_limit": "Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.",
                "refer_to_customer": "The customer has stopped the payment with their bank. Contact them for details and to arrange payment.",
                "refund_disputed_payment": "You cannot refund a disputed payment.",
                "resource_already_exists": "A resource with a user-specified ID (e.g., plan or coupon) already exists. Use a different, unique value for id and try again.",
                "resource_missing": "The ID provided is not valid. Either the resource does not exist, or an ID for a different resource has been provided.",
                "return_intent_already_processed": "You cannot confirm this refund as it is already processed.",
                "routing_number_invalid": "The bank routing number provided is invalid.",
                "secret_key_required": "The API key provided is a publishable key, but a secret key is required. Obtain your current API keys from the Dashboard and update your integration to use them.",
                "sepa_unsupported_account": "Your account does not support SEPA payments.",
                "setup_attempt_failed": "The latest setup attempt for the SetupIntent has failed. Check the last_setup_error property on the SetupIntent for more details, and provide a new payment method to attempt to set it up again.",
                "setup_intent_authentication_failure": "The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this SetupIntent again.",
                "setup_intent_invalid_parameter": "One or more provided parameters was not allowed for the given operation on the SetupIntent. Check our API reference or the returned error message to see which values were not correct for that SetupIntent.",
                "setup_intent_mandate_invalid": "The provided mandate is invalid and can not be used for the setup intent.",
                "setup_intent_setup_attempt_expired": "The latest setup attempt for the SetupIntent has expired. Check the last_setup_error property on the SetupIntent for more details, and provide a new payment method to attempt to complete this SetupIntent again.",
                "setup_intent_unexpected_state": "The SetupIntent’s state was incompatible with the operation you were trying to perform.",
                "shipping_address_invalid": "The shipping address information cannot be used to accurately determine tax rates. Verify that address fields such as zip code, state, or province have been added correctly.",
                "shipping_calculation_failed": "Shipping calculation failed as the information provided was either incorrect or could not be verified.",
                "sku_inactive": "The SKU is inactive and no longer available for purchase. Use a different SKU, or make the current SKU active again.",
                "state_unsupported": "Occurs when providing the legal_entity information for a U.S. custom account, if the provided state is not supported. (This is mostly associated states and territories.)",
                "status_transition_invalid": "The requested status transition is not valid.",
                "stripe_tax_inactive": "Stripe Tax has not been activated on your account. Check the setup documentation to get started.",
                "tax_id_invalid": "The tax ID number provided is invalid (e.g., missing digits). Tax ID information varies from country to country, but must be at least nine digits.",
                "taxes_calculation_failed": "Tax calculation for the order failed.",
                "terminal_location_country_unsupported": "Terminal is currently only available in some countries. Locations in your country cannot be created in livemode.",
                "terminal_reader_busy": "Reader is currently busy processing another request. Please reference the integration guide for details on how to handle this error.",
                "terminal_reader_hardware_fault": "Reader can no longer accept payments as an unrecoverable hardware fault has been detected. Please reach out to Stripe support at https://support.stripe.com/contact/email and provide your reader’s serial number for replacement.",
                "terminal_reader_invalid_location_for_payment": "Reader can’t take payments in the currently registered Location. Please register the reader to a new Location. See Manage locations for more information.",
                "terminal_reader_offline": "Reader is currently offline, please ensure the reader is powered on and connected to the internet before retrying your request. Reference the integration guide for details on how to handle this error.",
                "terminal_reader_timeout": "There was a timeout when sending this command to the reader. Please reference the integration guide for details on how to handle this error.",
                "testmode_charges_only": "Your account has not been activated and can only make test charges. Activate your account in the Dashboard to begin processing live charges.",
                "tls_version_unsupported": "Your integration is using an older version of TLS that is unsupported. You must be using TLS 1.2 or above.",
                "token_already_used": "The token provided has already been used. You must create a new token before you can retry this request.",
                "token_card_network_invalid": "Invalid card network parameter was provided in the card token object. Check our API documentation or the returned error message for more context.",
                "token_in_use": "The token provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.",
                "transfer_source_balance_parameters_mismatch": "When creating a Transfer, the payments parameter in source_balance should not be passed in when balance type is set to issuing.",
                "transfers_not_allowed": "The requested transfer cannot be created. Contact us if you are receiving this error.",
                "url_invalid": "The URL provided is invalid."
            }
        },
        "tickets": {
            "empty": {
                "title": "Oops! You have no tickets",
                "subtitle": "You can create a new ticket by clicking below",
                "button": "New ticket"
            }
        },
        "validation": {
            "accepted": "The {attribute} field must be accepted.",
            "active_url": "The {attribute} field it is not a valid URL.",
            "after": "The {attribute} field must be a date after {date}.",
            "after_or_equal": "The {attribute} field must be a date later than or equal to {date}.",
            "alpha": "The {attribute} field can only contain letters.",
            "alpha_dash": "The {attribute} field it can only contain letters, numbers and dashes.",
            "alpha_num": "The {attribute} field it can only contain letters and numbers.",
            "array": "The {attribute} field it must be a matrix.",
            "before": "The {attribute} field must be an earlier date {date}.",
            "before_or_equal": "The {attribute} field must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} field must be between {min} and {max}.",
                "file": "The {attribute} field must be between {min} and {max} kilobytes.",
                "string": "The {attribute} field must be between {min} and {max} characters.",
                "array": "The {attribute} field must have between {min} and {max} items."
            },
            "err": "Validation error",
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} field does not match.",
            "date": "The {attribute} field is not a valid date.",
            "date_format": "The {attribute} field does not match the {format} format.",
            "different": "The {attribute} fields and {other} fields must be different.",
            "digits": "The {attribute} field must have {digits} digits.",
            "digits_between": "The {attribute} field must be between {min} and {max} digits.",
            "dimensions": "The {attribute} field has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} field must be a valid email address.",
            "exists": "The {attribute} field selected is invalid.",
            "file": "The {attribute} field must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} field must be an image.",
            "in": "The {attribute} field selected is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} field must be an integer.",
            "ip": "The {attribute} field must be a valid IP address.",
            "ipv4": "The {attribute} field must be must be a valid IPv4 address.",
            "ipv6": "The {attribute} field must be a valid IPv6 address.",
            "json": "The {attribute} field must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} field cannot be greater than {max}.",
                "file": "The {attribute} field cannot be greater than {max} kilobytes.",
                "string": "The {attribute} field cannot have more than {max} characters.",
                "array": "The {attribute} field cannot have more than {max} items."
            },
            "mimes": "The {attribute} field must be a file of type: {values}.",
            "mimetypes": "The {attribute} field must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} field must be at least {min}.",
                "file": "The {attribute} field must be at least {min} kilobytes.",
                "string": "The {attribute} field must be at least {min} characters.",
                "array": "The {attribute} field must have at least {min} items."
            },
            "not_in": "The {attribute} field selected is invalid.",
            "numeric": "The {attribute} field must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} field has an invalid format.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field  is mandatory except when {other} is {values}.",
            "required_with": "The {attribute} field  is required when {values} is present.",
            "required_with_all": "The {attribute} field  is required when {values} is present.",
            "required_without": "The {attribute} field is mandatory when {values} is not present.",
            "required_without_all": "The {attribute} field is mandatory when none of the {values} are present.",
            "same": "The {attribute} and {other} fields must match.",
            "size": {
                "numeric": "The {attribute} field must be {size}.",
                "file": "The {attribute} field must be {size} kilobytes.",
                "string": "The {attribute} field must be {size} characters.",
                "array": "The {attribute} field must contain {size} items."
            },
            "string": "The {attribute} field must be a string.",
            "timezone": "The {attribute} field must be a valid zone.",
            "unique": "The {attribute} is already in use.",
            "uploaded": "Failed to upload the {attribute} field.",
            "url": "The {attribute} field has an invalid format.",
            "white_space": "The {attribute} field must not contain blanks.",
            "reserved_in_system": "Esse nome é reservado pelo sistema.",
            "custom": {
                "already_exists": "A record with this value already exists.",
                "fields": "Mandatory fields not filled in",
                "document": {
                    "unique": "There is already a student with the document registered."
                },
                "email": {
                    "unique": "There is already a student with the registered email"
                },
                "address": {
                    "postal_code": {
                        "invalid": "The informed zip code is invalid."
                    },
                    "fields_required": "All address fields are required"
                }
            },
            "attributes": {
                "document": "documento"
            }
        },
        "dashboard": {
            "courses": "Courses",
            "content": "Content",
            "lessons": "Lessons",
            "exercises": {
                "title": "Exercises",
                "answers": "Questions Answered"
            },
            "plan": {
                "change": "Change Plan",
                "external_status_title": "Confirmation of enrollment",
                "external_status_description": "Hello {name}, we are looking forward to starting activities. To confirm your registration, click the button below.",
                "external_status_ok": "Confirm registration",
                "unavailable_content": "Content not available yet",
                "release_date": "Release date: "
            },
            "plans": "Plans",
            "in_progress": "In Progress",
            "no_plans": "You have no plan",
            "empty_message": "Purchase at least one plan to access your content",
            "redirect_showcase": "Plans Showcase",
            "access": "Acess",
            "start": "Start",
            "continue": "Continue",
            "disabled": "Disabled",
            "progress": "Progress",
            "notifications": {
                "title": "Dashboard Notifications",
                "name": "Notifications"
            },
            "expiration_days": "Expiration days",
            "expiration_date": "Expiration date",
            "tomorrow": "Tomorrow",
            "today": "Today",
            "expired": "Expired"
        },
        "leads": {
            "capture_title": "Content Access",
            "access_content": "Access Exclusive Content",
            "fill_form_access": "Fill in the details below to access the content",
            "name": "Name",
            "email": "Email",
            "phone": "Phone",
            "name_placeholder": "Enter your full name",
            "email_placeholder": "Enter your best email",
            "phone_placeholder": "Enter your phone",
            "access_content_btn": "Access Content",
            "privacy_notice": "Your data is safe and protected with us",
            "not_provided": "Not provided",
            "errors": {
                "name_required": "Name is required",
                "name_min_length": "Name must be at least 2 characters",
                "email_required": "Email is required",
                "email_invalid": "Please enter a valid email",
                "phone_required": "Phone is required",
                "phone_invalid": "Please enter a valid phone number",
                "plan_required": "Plan is required",
                "plan_not_found": "Plan not found",
                "plan_not_available": "This plan is not available for lead capture",
                "lead_config_not_found": "Lead configuration not found for this plan",
                "at_least_one_field_required": "Please fill at least one field to continue",
                "validation_failed": "Please check the information provided",
                "submission_failed": "Error processing your data. Please try again",
                "list_failed": "Error loading leads list"
            },
            "success": {
                "captured": "Data saved successfully! Redirecting..."
            }
        }
    },
    "es": {
        "common": {
            "about_course": "Sobre el curso",
            "active": "Activo",
            "add": "Agregar",
            "all_invoices": "Todas las facturas",
            "analyze": "En análisis",
            "and": "y",
            "anonymous": "Anónimo",
            "apply": "Aplicar",
            "at": "a las",
            "attach": "Adjuntar",
            "attention": "¡Atención!",
            "back": "Volver",
            "billet": "Boleto",
            "blocked": "Bloqueado",
            "blog": "Blog",
            "browser_support_file": "El navegador no admite este tipo de archivo",
            "buy": "Comprar",
            "bind_processing": "Vinculando alunos à turma... Verifique la notificación para más información.",
            "bind_successfull": "Alunos vinculados con éxito!",
            "bind_failure": "Error al vincular alunos à turma!",
            "cancel": "Cancelar",
            "canceled": "Cancelado",
            "cart": "Carrito",
            "chat": "Chat",
            "close": "Cerrar",
            "config": "Configuración",
            "confirm": "Confirmar",
            "confirm_action": "¿Confirmar acción?",
            "contact": "Contacto",
            "content": "Contenido",
            "continue": "Continuar",
            "course": "Curso",
            "courses": "Cursos",
            "create": "Crear",
            "created_success": "Creado con éxito",
            "credit_card": "Tarjeta de Crédito",
            "dashboard": "Panel",
            "days": "días",
            "debit_card": "Tarjeta de Débito",
            "description": "Descripción",
            "details": "Detalles",
            "document": "Documento",
            "document_type": "Tipo de documento",
            "download_file": "Descargar archivo",
            "due": "Vencimiento",
            "due_invoices": "Facturas pendientes",
            "duration": "Duración",
            "edit": "Editar",
            "email": "Correo electrónico",
            "empty_alert": "Existen preguntas sin responder",
            "empty_exercises": "No has respondido todas las preguntas, ¿quieres continuar de todos modos?",
            "empty_survey": "No hay encuestas en este momento",
            "exercise": "Ejercicio",
            "exercises": "Ejercicios",
            "expand": "Expandir",
            "expired": "Vencido",
            "final_content": "Contenido final",
            "final_grade": "Nota final",
            "financial": "Financiero",
            "forum": "Foro",
            "free": "Gratuito",
            "generate_invoice": "Generar factura",
            "geolocation_block": "Ubicación no permitida",
            "geolocation_permission": "Habilita la geolocalización del navegador para iniciar sesión",
            "geolocation_unsupported": "Este navegador no admite geolocalización",
            "inactive": "Inactivo",
            "information": "Información",
            "installments": "Cuotas",
            "invalid_format": "Formato inválido",
            "invoices": "Ver facturas",
            "issue_date": "Fecha de compra",
            "justify_answer": "Justifica tu respuesta",
            "lesson": "Lección",
            "lessons": "Lecciones",
            "listing": "Listado",
            "load_more_content": "Cargar más contenido",
            "location": {
                "addresses": "Direcciones",
                "address": "Dirección",
                "city": "Ciudad",
                "number": "Número",
                "neighborhood": "Barrio",
                "state": "Estado",
                "zip_code": "Código Postal",
                "info": "Complemento"
            },
            "gamification": "Gamificación",
            "module": "Módulo",
            "modules": "Módulos",
            "my_plans": "Mis planes",
            "name": "Nombre",
            "new": "Nuevo",
            "no_forum": "No se encontró ningún foro",
            "notifications": "Notificaciones",
            "of": "de",
            "open": "Abrir",
            "overview": "Visión general",
            "paid": "Pagado",
            "paid_date": "Fecha de pago",
            "paid_invoices": "Facturas pagadas",
            "paid_value": "Valor pagado",
            "password": "Contraseña",
            "payment_error": "Error al finalizar la compra. No se pudo procesar la transacción. Revise los datos ingresados y vuelva a intentarlo.",
            "payment_method": "Método de pago",
            "plan": "Plan",
            "plans": "Planes",
            "print_billet": "Imprimir boleto",
            "processing": "Procesando",
            "products": "Productos",
            "profile": "Perfil",
            "public": "Público",
            "receipt": "Comprobante",
            "recurrence": "Facturación",
            "register": "Registrarse",
            "remove": "Eliminar",
            "required_field": "Campo obligatorio",
            "response": {
                "success": "Enviado con éxito",
                "error": "Hubo un error, vuelve a intentarlo."
            },
            "results": "Resultados",
            "save": "Guardar",
            "saved": "Guardado",
            "search": "Buscar",
            "see_less": "Ver menos",
            "select_one": "Selecciona al menos una opción",
            "send": "Enviar",
            "showing": "Mostrando",
            "start": "Iniciar",
            "status": "Estado",
            "store": "Planes",
            "support_material": "Material de apoyo",
            "tickets": "Tickets",
            "title": "Título",
            "to": "a",
            "to_due": "A vencer",
            "topics": "Encuestas",
            "type_search": "Escribe para buscar el país",
            "unavailable": "No disponible",
            "unique_invoice": "Factura única",
            "upload_error": "No se pudo enviar el archivo",
            "value": "Valor",
            "views": "Vistas",
            "zip_error": "No se pudieron cargar las información del CEP.",
            "zip_not_found": "No se encontró una dirección con ese CEP.",
            "loading": "Cargando...",
            "error_accessing_content": "Error al acceder al contenido."
        },
        "order": {
            "order": "Pago",
            "thanks": "¡Muchas gracias por adquirir nuestro contenido!",
            "info": "Información del Pago",
            "recurrence_question": "¿Desea vincular esta recurrencia a un método de pago?",
            "value": "Valor total del pago",
            "yes_link": "Sí, deseo vincular",
            "no_link": "No",
            "go_to_dashboard": "Ir al panel de control",
            "link_recurrence": "Vincular pago recurrente del contenido",
            "status": {
                "success": "¡Muchas gracias por adquirir nuestro contenido!",
                "to_pay": "Se ha realizado la solicitud de pago, espere mientras se procesa.",
                "beaten": "No fue posible realizar la operación. Comuníquese con el soporte.",
                "canceled": "No fue posible realizar la operación. Inténtelo de nuevo más tarde o comuníquese con el soporte.",
                "processing": "La transacción está siendo procesada.",
                "waiting": "La transacción está esperando la aprobación del departamento financiero."
            }
        },
        "notification": {
            "title": "Notificaciones",
            "all": "Todas las notificaciones"
        },
        "billing": {
            "billing": "Facturación",
            "invoice": {
                "created_at": "Fecha de creación de la factura",
                "buy_again": "Comprar de nuevo",
                "hash": "Número de factura",
                "descrition": "Descripción de la factura",
                "invoice": "Factura",
                "invoices": "Facturas",
                "show": "Mostrar factura",
                "pay": "Pagar factura",
                "duplicate": {
                    "title": "Duplicado",
                    "generate": "Generar duplicado"
                },
                "total": "Total de la factura",
                "fee": "Multa",
                "interest": "Intereses",
                "payed": "Esta factura ya ha sido pagada",
                "processing": "Procesando pago",
                "expiry": "Fecha de vencimiento de la factura",
                "expiry_duplicate": "Fecha de vencimiento del duplicado",
                "goto_payment": "Ir al pago",
                "canceled": "La factura ha sido cancelada",
                "interest_per_days": "por día después del vencimiento de la primera factura",
                "billet": {
                    "show": "Ver boleto",
                    "expirated": "Factura vencida"
                },
                "status": {
                    "title": "Estado",
                    "paid": "Pagada",
                    "pending": "Pendiente",
                    "canceled": "Cancelada",
                    "processing": "Procesando",
                    "expired": "Vencida"
                }
            },
            "recurrence": {
                "status": "Estado",
                "recurrence": "Recurrencia",
                "subscription": "Suscripción",
                "invoices": "Facturas de recurrencia",
                "hash": "Número de recurrencia",
                "description": "Descripción de la recurrencia",
                "due": "Próximo vencimiento",
                "view": "Ver recurrencia",
                "payment_type": "Tipo de pago vinculado",
                "info": "Información de la recurrencia",
                "name": "Nombre de la recurrencia",
                "plan": "Plan de la recurrencia",
                "value": "Valor de la recurrencia",
                "cicle": "Ciclos",
                "linked_payment": "Esta recurrencia está vinculada con el método de pago ",
                "no_linked_payment": "Esta recurrencia no está vinculada con ningún método de pago",
                "link_payment": "Vincular método de pago",
                "unlink_payment": "Desvincular método de pago",
                "null_recurring_payment": "Ningún método de pago vinculado",
                "no_payment_available": "Actualmente no hay ninguna plataforma de pagos disponible para habilitar la recurrencia seleccionada.",
                "status_codes": [
                    "Desactivada",
                    "Activada",
                    "Cancelada",
                    "Procesando"
                ]
            }
        },
        "glossary": {
            "title": "Glosario",
            "subtitle": "Consulte los términos y conceptos de sus cursos.",
            "search": "Buscar término",
            "all": "Todos",
            "category": "Categoría",
            "all_categories": "Todas las categorías",
            "course": "Curso",
            "general": "Glosario general",
            "empty": "No se encontraron términos.",
            "examples": "Ejemplos de uso",
            "synonyms": "Sinónimos",
            "related": "Ver también",
            "back": "Volver al glosario",
            "disabled": "El glosario no está disponible en esta plataforma.",
            "not_found": "Término no encontrado.",
            "preview_notice": "Vista del alumno: así ven los alumnos el glosario.",
            "menu": "Glosario"
        },
        "tags": {
            "id": "Código",
            "year": "Año",
            "month": "Mes",
            "next": "Siguiente",
            "previous": "Anterior"
        },
        "certificate": {
            "title": "Certificado",
            "description": "Certificado de finalización, haz clic en el trofeo para obtener el certificado",
            "print": "Imprimir",
            "download": "Descargar",
            "validate": "Enlace para validar el Certificado",
            "code": "Ingresa el código del certificado para validar",
            "validate_button": "Validar",
            "success": "Este certificado es válido, verifica a continuación",
            "error": "Por favor, ingresa un código de certificado válido",
            "validate_description": "Validar Certificado",
            "progress": "Has alcanzado el {studentProgress}% de aprovechamiento, sin embargo, para obtener el certificado es necesario alcanzar el {certificateProgress}%",
            "state": {
                "valid": "Certificado válido",
                "expired": "Certificado vencido",
                "not_found": "Certificado no encontrado",
                "disabled": "Validación pública apagada para este certificado",
                "valid_text": "Este certificado fue emitido por la plataforma y es auténtico.",
                "expired_text": "Este certificado existe, pero su fecha de validez ya pasó.",
                "not_found_text": "No encontramos ningún certificado con este código. Revisa el código e inténtalo de nuevo.",
                "disabled_text": "El responsable del certificado no habilitó la validación pública."
            },
            "summary": {
                "student": "Alumno",
                "content": "Contenido",
                "emitted_at": "Emitido el",
                "valid_until": "Válido hasta",
                "code": "Código"
            },
            "validate_at": "Valide en"
        },
        "captcha": {
            "title": "Error en la verificación del captcha",
            "none": "Captcha aún no creado.",
            "image": "La imagen seleccionada es incorrecta.",
            "audio": "La letra o número es incorrecto(a).",
            "incomplete": "Debes completar el captcha.",
            "wait": "Demasiados intentos, espera ",
            "frontend": {
                "accessibilityAlt": "Ícono de Sonido",
                "accessibilityTitle": "Opción de Accesibilidad: ¡escucha una pregunta y responde!",
                "accessibilityDescription": "Escribe abajo la <strong>respuesta</strong> a lo que escuchas. Números o palabras:",
                "explanation": "Haz clic o toca en <strong>RESPONDER</strong>",
                "refreshAlt": "Ícono de Recargar",
                "refreshTitle": "Recargar: obtén nuevas imágenes y opción de accesibilidad"
            },
            "images": {
                "Airplane": "Avión",
                "Balloons": "Globos",
                "Camera": "Cámara",
                "Car": "Coche",
                "Cat": "Gato",
                "Chair": "Silla",
                "Clip": "Clip",
                "Clock": "Reloj",
                "Cloud": "Nube",
                "Computer": "Computadora",
                "Envelope": "Sobre",
                "Eye": "Ojo",
                "Flag": "Bandera",
                "Folder": "Carpeta",
                "Foot": "Pie",
                "Graph": "Gráfico",
                "House": "Casa",
                "Key": "Llave",
                "Leaf": "Hoja",
                "Light Bulb": "Bombilla",
                "Lock": "Candado",
                "Magnifying Glass": "Lupa",
                "Man": "Hombre",
                "Music Note": "Nota musical",
                "Pants": "Pantalón",
                "Pencil": "Lápiz",
                "Printer": "Impresora",
                "Robot": "Robot",
                "Scissors": "Tijeras",
                "Sunglasses": "Gafas de sol",
                "Tag": "Etiqueta",
                "Tree": "Árbol",
                "Truck": "Camión",
                "T-Shirt": "Camiseta",
                "Umbrella": "Paraguas",
                "Woman": "Mujer",
                "World": "Mundo"
            }
        },
        "lesson": {
            "tabs": {
                "overview": "Resumen",
                "polls": "Encuestas",
                "forum": "Foro"
            },
            "live": {
                "unavailable": "Clase en vivo no disponible",
                "start_at": "Inicio"
            },
            "conference": {
                "unavailable": "Videoconferencia no disponible",
                "start_at": "Inicio"
            },
            "answer_placeholder": "Escribe tu respuesta",
            "finish_exercise": "Finalizar ejercicio",
            "redo": "Rehacer",
            "upload_empty": "El campo de carga no puede estar en blanco",
            "answer_download": "Descargar respuesta",
            "exercise_waiting": "Ejercicio esperando corrección.",
            "exercise_revised": "Ejercicio corregido.",
            "obs": "Observación del corrector:",
            "revised_by": "Corregido por:",
            "approved": "Ejercicio aprobado",
            "reproved": "Ejercicio reprobado",
            "conference_lesson": "Lección: Solo podrás participar como oyente",
            "conference_discussion": "Debate: podrás interactuar, selecciona la cámara y el micrófono",
            "corrected_on": "Corregido el",
            "scorm": {
                "no_entry_sco": "El paquete SCORM no tiene SCO de entrada.",
                "init_error": "Error al iniciar la sesión SCORM."
            },
            "publish": {
                "schedule": "Esta lección estará disponible entre las fechas: ",
                "schedule_end": "Esta lección finalizó en la fecha: "
            }
        },
        "profile": {
            "secondary": {
                "title": "Inicio de Sesión Secundario",
                "created": "Inicio de Sesión Secundario Creado",
                "deleted": "Inicio de Sesión Secundario Eliminado",
                "create": "Crear Inicio de Sesión Secundario",
                "delete": "Eliminar Inicio de Sesión Secundario",
                "warning": "¡Después de la eliminación, el correo electrónico perderá por completo la asociación con su cuenta!",
                "new_secondary": "Crear nuevo usuario",
                "new_secondary_over_limit": "Se alcanzó el límite de usuarios secundarios"
            },
            "info": "Información del Perfil",
            "owner": "Inicio de Sesión Principal",
            "photo": "Foto de Perfil",
            "additional_info": "Información Adicional",
            "document_not_unique": "Ya existe un suscriptor con el documento registrado",
            "delete_account": "Eliminar cuenta",
            "delete_warning": "TODOS sus datos personales, cursos adquiridos, progreso en clases,\n    ejercicios realizados, certificados, entre otros, serán eliminados de la plataforma y",
            "recover_warning": "NO PODRÁN SER RECUPERADOS.",
            "want_continue": " ¿Desea continuar?"
        },
        "financial": {
            "sales_limit_exceeded": "Límite de ventas excedido.",
            "create_coupon": "Crear cupón",
            "create_plan": "Crear plan",
            "invoices": {
                "attachment_success": "Comprobante guardado con éxito",
                "attachment_failed": "Error al guardar el comprobante",
                "status": {
                    "paid": "Pagada",
                    "open": "Abierta",
                    "overdue": "Vencida",
                    "past_due": "Atrasada",
                    "pending": "Pendiente",
                    "analyzing": "En análisis",
                    "canceled": "Cancelada",
                    "deleted": "Eliminada"
                }
            },
            "deposit": {
                "title": "Datos para el depósito",
                "button": "Enviar comprobante"
            },
            "recurrences": {
                "subscription": "Suscripción",
                "access_until": "Acceso hasta",
                "monthly": "Mensual",
                "bimonthly": "Bimestral",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "month": "1 mes",
                "year": "1 año",
                "months": "{months} meses",
                "years": "{years} años",
                "cycles": {
                    "cycles": "Ciclos",
                    "infinite": "Infinito",
                    "infinite_description": "La recurrencia se generará por un tiempo indeterminado, o hasta que el alumno cancele el plan",
                    "custom": "Personalizado",
                    "custom_description": "La recurrencia se generará por un tiempo determinado, pudiendo ser como máximo 20 veces",
                    "month": "1 mes",
                    "year": "1 año",
                    "months": "{months} meses",
                    "years": "{years} años",
                    "days": "{days} días"
                }
            },
            "stripe": {
                "redirecting": "Estamos generando su registro, por favor espere..."
            }
        },
        "pdf": {
            "invoice_generated": "Factura Generada",
            "invoice_number": "N° de Factura",
            "issue_date": "Fecha de Emisión",
            "due_date": "Fecha de Vencimiento",
            "plan_name": "Plan",
            "items": "Ítems",
            "value": "Valor",
            "total": "Total",
            "status": "Estado",
            "invoice_status": {
                "paid": "Pagada",
                "to_pay": "Pendiente de Pago",
                "past_due": "Vencida",
                "canceled": "Cancelada",
                "processing": "Procesando",
                "in_analysis": "En Análisis"
            }
        },
        "topic": {
            "topic_title": "Título del tema",
            "post": "Publicar",
            "title": "título",
            "await": "Esperando aprobación",
            "question": "Contenido del tema",
            "new_moderated": "Este foro es moderado por el administrador; su tema aparecerá en la lista cuando sea aprobado.",
            "needs_login": "Inicia sesión o crea una cuenta para participar en el tema."
        },
        "students": {
            "field_exits": "Ya existe un estudiante con el valor \"{value}\" en el campo {name}",
            "plan": {
                "remove": " ¡Atención! Al eliminar un plan asociado a la cuenta de un estudiante, se perderá el registro de progreso en los informes. Si este plan tiene una recurrencia asociada, será necesario eliminarla manualmente. ¿Desea continuar con la eliminación del plan de este estudiante?",
                "change_status": "¡Atención! Al realizar esta acción, se actualizará el estado del plan para el estudiante. Si el \"Estado\" del plan se actualiza a \"Activado\", desbloqueará el acceso para el estudiante, y si se actualiza a \"Desactivado\", bloqueará el acceso para el estudiante. Si este plan tiene una recurrencia asociada, deberá cambiar su \"Estado\" manualmente. ¿Desea continuar con el cambio de estado del plan de este estudiante?"
            }
        },
        "gamification": {
            "gamification_status": "Estado de la Gamificación",
            "gamification_my_points": "Mis Puntos",
            "gamification_points": "Puntos",
            "gamification_content_without_progress": "No se ha progresado en este plan",
            "gamification_ranking": "Clasificación General",
            "gamification_without_ranking": "Nadie ha obtenido puntos en la plataforma",
            "gamification_show_hole_progress": "Mostrar todo el progreso",
            "gamification_plan_name": "Nombre del Plan: {plan}",
            "gamification_total_points": "Puntos Totales: {points}",
            "gamification_content_name": "Nombre del Contenido",
            "gamification_finish_date": "Fecha de Finalización",
            "gamification_score": "Puntuación",
            "course_title": "Curso",
            "course_rule": "Regla del Curso",
            "course_rule_goal": "Meta del Curso",
            "course_rule_points": "Puntos del Curso",
            "module_title": "Módulo",
            "module_rule": "Regla del Módulo",
            "module_rule_goal": "Meta del Módulo",
            "module_rule_points": "Puntos del Módulo",
            "lesson_title": "Lección",
            "lesson_rule": "Regla de la Lección",
            "lesson_rule_goal": "Meta de la Lección",
            "lesson_rule_points": "Puntos de la Lección",
            "exercise_title": "Ejercicio",
            "exercise_rule": "Regla del Ejercicio",
            "exercise_rule_goal": "Meta del Ejercicio",
            "exercise_rule_points": "Puntos del Ejercicio",
            "survey_title": "Encuesta",
            "survey_rule": "Regla de la Encuesta",
            "survey_rule_goal": "Meta de la Encuesta",
            "survey_rule_points": "Puntos de la Encuesta",
            "certificate_title": "Certificado",
            "certificate_rule": "Regla del Certificado",
            "certificate_rule_goal": "Meta del Certificado",
            "certificate_rule_points": "Puntos del Certificado",
            "attendance_title": "Asistencia",
            "attendance_rule": "Regla de la Asistencia",
            "attendance_rule_goal": "Meta de la Asistencia",
            "attendance_rule_points": "Puntos de la Asistencia"
        },
        "notification_templates": {
            "APP_TICKET_CREATED": {
                "name": "Nuevo Ticket Creado",
                "body": "El administrador [[$user_name]] ha creado el ticket #[[$ticket_id]]."
            },
            "APP_TICKET_REPLY": {
                "name": "Respuesta al Ticket",
                "body": "Nueva respuesta del administrador [[$user_name]] en el ticket #[[$ticket_id]]."
            },
            "APP_TOPIC_REPLY": {
                "name": "Nueva Respuesta en el Tópico del Foro",
                "body": "Nueva respuesta en el tópico [[$topic_name]] en el foro del contenido [[$content_name]]."
            },
            "APP_TOPIC_REPLY_APPROVED": {
                "name": "Respuesta Aprobada en el Tópico del Foro",
                "body": "Tu respuesta en el tópico [[$topic_name]] del contenido [[$content_name]] ha sido aprobada."
            },
            "APP_INVOICE_PAID": {
                "name": "Factura Pagada",
                "body": "Se ha aprobado con éxito el pago de la factura #[[$invoice_id]] por un monto de [[$invoice_value]] correspondiente al plan [[$plan_name]]."
            },
            "APP_INVOICE_DUE_DATE": {
                "name": "Factura Vencida",
                "body": "Hemos detectado que la factura #[[$invoice_id]] por un monto de [[$invoice_value]] venció en la fecha [[$invoice_due_date]]. Haz clic para obtener más información."
            },
            "APP_CORRECTED_EXERCISE": {
                "name": "Ejercicio Corregido",
                "body": "El ejercicio [[$exercise_name]] ha sido [[$exercise_approve]], verifica tu calificación."
            },
            "APP_NEW_EXERCISE": {
                "name": "Nuevo Ejercicio",
                "body": "El ejercicio [[$exercise_name]] se ha añadido a un contenido del plan [[$plan_name]]."
            },
            "APP_SUSPENDED_PLAN": {
                "name": "Plan Suspendido",
                "body": "El plan [[$plan_name]] ha sido suspendido debido a pagos pendientes. Haz clic para obtener más información."
            },
            "APP_NEW_MODULE": {
                "name": "Nuevo Módulo",
                "body": "El módulo [[$module_name]] se ha añadido al curso [[$course_name]] del plan [[$plan_name]]."
            },
            "APP_NEW_LESSON": {
                "name": "Nueva Lección",
                "body": "La lección [[$lesson_name]] se ha añadido a un contenido del plan [[$plan_name]]."
            }
        },
        "exercise": {
            "time": {
                "title": "Ejercicio con límite de tiempo para la respuesta",
                "description": "Después de iniciar el ejercicio, el envío debe realizarse antes de que se agote el límite de tiempo; de lo contrario, el envío será automático.",
                "rules": "Una vez iniciado el temporizador, no se detendrá aunque se recargue la página o haya un cambio de contenido.",
                "remaining": "Tiempo restante",
                "limit": "Ejercicio con límite de tiempo"
            },
            "validate": {
                "check_error": "Marque alguna alternativa",
                "some_question_no_anwser": "Responda todas las preguntas"
            },
            "publish": {
                "schedule": "Este ejercicio estará disponible entre las fechas: ",
                "schedule_end": "Este ejercicio finalizó en la fecha: "
            }
        },
        "login": {
            "signin": "Iniciar sesión",
            "signout": "Cerrar sesión",
            "register": "Crear cuenta",
            "new_account": "Crear una nueva cuenta",
            "continue": "Continuar",
            "continue_user": "Continuar como",
            "name": "Nombre",
            "email": "Correo electrónico",
            "email_confirmation": "Confirmar correo electrónico",
            "email_reset": "Restablecer correo electrónico",
            "email_change": "Cambiar correo electrónico",
            "domain_invalid": "Dominio de correo electrónico incompatible para la categoría seleccionada",
            "document": "Documento",
            "document_type": "Tipo de documento",
            "login_type": "Forma de inicio de sesión",
            "remember": "Recordar inicio de sesión",
            "disconnect_users": "Desconectar dispositivos",
            "device_limit_hint": "Límite de dispositivos conectados alcanzado. Puedes desconectar los otros dispositivos y continuar en este.",
            "disconnect_and_signin": "Desconectar otros dispositivos e iniciar sesión",
            "validation": {
                "email": "El correo electrónico es obligatorio",
                "password": "La contraseña es obligatoria"
            },
            "messages": {
                "update_password": "Actualiza tu contraseña para continuar",
                "success": "Inicio de sesión exitoso",
                "error": "Credenciales inválidas"
            },
            "recovery": {
                "success": "Recibirás un correo electrónico con el enlace para restablecer tu contraseña",
                "error": "Correo electrónico no encontrado"
            },
            "password": {
                "title": "Contraseña",
                "confirm": "Confirmar contraseña",
                "change": {
                    "title": "Cambiar contraseña",
                    "success": "¡Contraseña cambiada!",
                    "error": "Error al cambiar la contraseña"
                },
                "forgot": "¿Olvidaste la contraseña?",
                "reset": "Restablecer la contraseña"
            },
            "account_created": "¡Cuenta creada con éxito! Redireccionando...",
            "email_already_exists": "El correo electrónico ya tiene una cuenta registrada",
            "document_type_required": "El tipo de documento es obligatorio",
            "subscribe_message": "Crea tu cuenta para acceder a ",
            "has_account": "¿Ya tienes una cuenta?",
            "access_here": "Accede aquí."
        },
        "chat": {
            "you_are_banned": "Has sido prohibido en este chat, consulta al administrador para obtener más información",
            "you_are_accept": "Tu interacción con el chat ha sido aprobada",
            "cannot_approve": "No tienes permiso para aprobar mensajes en el chat",
            "cannot_ban": "No tienes permiso para prohibir a un usuario",
            "send_placeholder": "Escribe tu mensaje...",
            "message_waiting": "Mensaje enviado. Espera moderación.",
            "pending": "Esperando aprobación",
            "message_sent_error": "Error al enviar el mensaje",
            "end": "Chat finalizado",
            "needs_login": "Inicia sesión o crea una cuenta para interactuar en el chat"
        },
        "wiki": {
            "my_wikis": "Mis wikis",
            "title": "Wiki",
            "subtitle": "Construye el contenido junto con tu clase.",
            "empty": "Todavía no participas en ninguna wiki.",
            "course": "Curso",
            "classroom": "Clase",
            "relation": {
                "general": "General",
                "plan": "Plan: {name}",
                "course": "Curso: {name}"
            },
            "open": "Abrir wiki",
            "status": {
                "not_started": "Abre el {date}",
                "editing": "En edición",
                "closed": "Cerrada"
            },
            "deadline": {
                "ends_in": "Vence en {days} día|Vence en {days} días",
                "ends_today": "Vence hoy",
                "over": "Plazo cerrado",
                "none": "Sin plazo",
                "not_started": "Abre el {date}"
            },
            "closed_notice": "La edición de esta wiki ha terminado. Aún puedes leerla y consultar el historial.",
            "not_started_notice": "Esta wiki abre para edición el {date} a las {time}. Hasta entonces, puedes leer el contenido.",
            "read_more": "Leer descripción completa",
            "read_less": "Ocultar descripción",
            "participants": "participantes",
            "contributions": "contribuciones",
            "last_update": "Última actualización",
            "today_at": "hoy a las {time}",
            "yesterday": "ayer",
            "pages": "Páginas",
            "search_page": "Buscar página",
            "new_page": "Nueva página",
            "new_page_title": "Título de la página",
            "parent_page": "Página madre (opcional)",
            "no_parent": "Sin página madre",
            "create": "Crear página",
            "cancel": "Cancelar",
            "page_created": "Página creada.",
            "page_locked": "Página bloqueada por el profesor.",
            "locked_short": "Bloqueada",
            "no_pages": "Ninguna página todavía.",
            "no_results": "Ninguna página encontrada.",
            "select_page": "Elige una página para leer.",
            "tabs": {
                "read": "Leer",
                "edit": "Editar",
                "history": "Historial",
                "discussion": "Discusión"
            },
            "last_edit": "Última edición: {user}, {date}",
            "editor": {
                "bold": "Negrita",
                "italic": "Cursiva",
                "heading": "Título",
                "list": "Lista",
                "table": "Tabla",
                "link": "Enlace",
                "link_url": "Dirección del enlace",
                "insert": "Insertar",
                "summary": "Resumen del cambio (opcional)",
                "summary_placeholder": "Describe lo que cambiaste.",
                "save": "Guardar cambio",
                "being_edited": "{user} está editando esta página…",
                "cannot_edit": "No puedes editar esta página.",
                "conflict_title": "Otra persona modificó la página",
                "conflict_text": "Tu texto se mantuvo abajo. Compáralo con la versión actual y guarda de nuevo cuando lo ajustes.",
                "conflict_mine": "Mi borrador",
                "conflict_theirs": "Versión actual",
                "use_current": "Descartar mi borrador y cargar la versión actual",
                "keep_mine": "Seguir con mi borrador",
                "unsaved": "Tienes cambios sin guardar en esta página. ¿Salir sin guardar?"
            },
            "files": {
                "send": "Enviar archivo",
                "hint": "Las imágenes aparecen en el texto; PDF, PPTX, DOCX, XLSX aparecen como archivo para descargar. Hasta 25 MB.",
                "sent": "Archivo enviado.",
                "invalid": "Archivo no permitido. Envía PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX o XLSX de hasta 25 MB.",
                "uploading": "Enviando…",
                "remove": "Quitar",
                "removed": "Archivo quitado."
            },
            "file_download": "Descargar",
            "history": {
                "version": "Versión {number}",
                "by": "por {user}",
                "view": "Ver versión",
                "back": "Volver al historial",
                "current": "Actual",
                "empty": "Sin versiones.",
                "teacher_only": "Restaurar versiones es tarea del profesor."
            },
            "discussion": {
                "title": "Discusión",
                "type": "Tipo",
                "types": {
                    "question": "Pregunta",
                    "suggestion": "Sugerencia",
                    "justification": "Justificación",
                    "debate": "Debate"
                },
                "write": "Escribe tu comentario",
                "publish": "Publicar",
                "reply": "Responder",
                "replying_to": "Respondiendo a {user}",
                "empty": "Ningún comentario todavía. Empieza la discusión.",
                "teacher": "PROFESOR",
                "closed": "La discusión de esta wiki está cerrada. Puedes leer los comentarios, pero no publicar."
            },
            "feed": {
                "title": "Últimos cambios",
                "created": "creó la página {page}",
                "edited": "{summary} en {page}",
                "commented": "comentó en {page}",
                "empty": "Ningún cambio todavía."
            },
            "version_created": "Página creada",
            "version_edited": "Cambio",
            "version_restored": "Versión {number} restaurada",
            "version_teacher": "Cambio del profesor",
            "cannot_create": "No puedes crear páginas en esta wiki.",
            "cannot_edit": "No puedes editar esta página.",
            "conflict": "Otra persona modificó la página mientras editabas.",
            "saved": "Cambio guardado.",
            "comment_published": "Comentario publicado.",
            "error": "No se pudo completar. Inténtalo de nuevo."
        },
        "emails": {
            "verify": {
                "send_link": "Enlace Enviado",
                "send_obs": "Para activar tu cuenta, accede al correo electrónico registrado y confirma tus datos",
                "if_not_received_link": "Si no has recibido el correo electrónico",
                "click_here_another_send": "haz clic aquí",
                "expired_link": "Enlace caducado",
                "expired_obs": "Este enlace no está disponible. Accede a tu cuenta en la plataforma de cursos en línea para enviar un nuevo enlace de confirmación",
                "access_account": "Haz clic aquí para acceder a tu cuenta",
                "activated_account": "Cuenta activada con éxito",
                "link_another_send": "Enlace enviado nuevamente",
                "fail_link_another_send": "Error al volver a enviar el enlace",
                "little_missing": "Falta poco",
                "link_sent": "Hemos enviado un enlace de confirmación al correo electrónico registrado. Para activar tu cuenta, accede al correo electrónico y confirma tus datos",
                "click_another_send": "Haz clic aquí para volver a enviar el enlace de confirmación"
            }
        },
        "empty": {
            "unique_invoice_title": "Sin facturas para mostrar",
            "unique_invoice_subtitle": "Aquí aparecerán todas tus facturas únicas.",
            "recurrence_title": "Sin recurrencias para mostrar",
            "recurrence_subtitle": "Aquí aparecerán todas tus recurrencias.",
            "filter_title": "Tu búsqueda no arrojó ningún resultado",
            "filter_subtitle": "Inténtalo nuevamente con nuevos parámetros",
            "topic_title": "No se encontraron temas"
        },
        "auth": {
            "failed": "Credenciales inválidas",
            "device": "Límite de dispositivos conectados a esta cuenta alcanzado",
            "userselect": "Seleccione su usuario para continuar",
            "terms_accept": "Es necesario aceptar los términos de uso antes de continuar",
            "deactivated": "¡El estudiante está suspendido de la plataforma!"
        },
        "form": {
            "address": {
                "country": "País",
                "state": "Estado",
                "city": "Ciudad",
                "address": "Dirección",
                "number": "Número",
                "neighborhood": "Barrio",
                "info": "Complemento",
                "cep": "Código Postal",
                "invalid_zip": "Código Postal inválido",
                "fill_zip": "Complete el campo Código Postal"
            },
            "select_option": "Seleccione una opción"
        },
        "content": {
            "course_content": "Contenido del curso",
            "lesson_content": "Contenido de la lección",
            "description": "Descripción",
            "download_content": "Contenido para descargar",
            "lock": {
                "PLAN_EXPIRED": "Este plan ha caducado",
                "PLAN_UNAVAILABLE": "Plan no disponible",
                "SCHEDULE": "Contenido programado {details}",
                "SCHEDULE_SALE": "Desbloqueado después de {details}",
                "PROGRESS": "Progreso mínimo no alcanzado: {details}",
                "GRADE": "Nota mínima no alcanzada: {details}",
                "AVAILABLE": "Contenido disponible",
                "UNAVAILABLE": "Contenido no disponible",
                "VIEWS_LIMIT": "Límite de visualizaciones alcanzado",
                "WAITING_AUTHORIZATION": "Esperando autorización",
                "WAITING_EXTERNAL_STATUS": "Matrícula no confirmada",
                "NOT_FREE_AFTER_CONTENT": "Es necesario esperar {details} días para desbloquear esta lección o el contenido anterior."
            },
            "uploads": {
                "url": "URL",
                "open_link": "Abrir enlace",
                "upload": "Subir",
                "title": "Subidas",
                "create": "Enviar archivos",
                "edit": "Editar archivo",
                "files": "Archivos",
                "file": "Archivo",
                "various_files": "Archivos varios",
                "unsupported_preview": "Vista previa no disponible",
                "name": "Nombre",
                "clear_list": "Limpiar lista",
                "description": "Descripción",
                "send_file": "Enviar archivo",
                "send_image": "Enviar imagen",
                "send_media": "Enviar archivos",
                "message": "Arrastra y suelta tu archivo aquí",
                "info": "O",
                "remove": "Eliminar archivo",
                "cancel": "Cancelar envío",
                "confirm": "¿Estás seguro de que deseas cancelar el envío?",
                "unsupported": "Tu navegador no admite la carga arrastrando el archivo",
                "fallback": "Por favor, utiliza el formulario para enviar el archivo",
                "type": "No se pueden enviar archivos con este formato",
                "exceeded": "Envía como máximo",
                "once": "a la vez",
                "error": "Error al enviar el archivo.",
                "canceled": "Envío cancelado",
                "validate": "Selecciona un archivo",
                "created_at": "Enviado en",
                "size": "Tamaño",
                "change": "Enviar archivo",
                "attachment": "Adjunto",
                "docs": "Documentos",
                "images": "Imágenes",
                "videos": "Videos",
                "audios": "Audios",
                "all": "Todos los archivos",
                "select": "Seleccionar",
                "use": "Usar",
                "media_gallery": "Galería de medios",
                "rules_failed": "Has alcanzado el límite máximo de descargas",
                "instruction": "Arrastra y suelta tu archivo aquí o haz clic para seleccionar un archivo",
                "warning": "nao feche a página até que a transferência seja concluída",
                "max_size": "Tamaño máximo de archivo permitido: 10GB"
            },
            "exercise": {
                "exercise": "Ejercicio",
                "questions": "Preguntas:",
                "utilization": "Aprovechamiento",
                "error": {
                    "no_connection": "Imposible conectar con el servidor. Por favor, inténtalo de nuevo más tarde.",
                    "upload": "Error al subir el archivo, inténtalo de nuevo."
                }
            },
            "lesson": {
                "video": "Contenido en vídeo",
                "video_n": "Vídeo",
                "upload": "Archivo de apoyo",
                "public_lesson": "Lección pública",
                "watch_now": "Ver ahora"
            },
            "type": {
                "live": "En vivo",
                "file": "Archivo"
            },
            "open": {
                "new_tab": "Abrir en nueva pestaña"
            }
        },
        "cart": {
            "recurrence": {
                "title": "Recurrencias",
                "monthly": "Mensual",
                "bimonthly": "Bimensual",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "custom": "Cobrado cada",
                "days": "días",
                "change_payment": "Elija la forma de pago de la recurrencia",
                "cpf": "CPF",
                "holder_cpf": "CPF del titular",
                "area_code": "Código de área",
                "phone_number": "Número de teléfono",
                "name": "Nombre",
                "holder": "Nombre",
                "card_holder": "Nombre del titular (igual al del tarjetahabiente)",
                "gerencia_net": "Gerencia Net",
                "birth": "Fecha de nacimiento",
                "credit_card_brand": "Marca de la tarjeta de crédito",
                "credit_card_number": "Número de tarjeta de crédito",
                "credit_card_cvv": "CVV",
                "credit_card_expiration_month": "Mes de vencimiento",
                "credit_card_expiration_year": "Año de vencimiento",
                "payment_alert": "Solo se permite 1 artículo de tipo recurrente en el carrito si la forma de pago es GerenciaNet",
                "approve_text": "Aprobar la recurrencia",
                "have_recurrence": "Atención, ya tienes algún artículo en tu carrito, para agregar un artículo recurrente, debes finalizar la compra o limpiar el carrito"
            },
            "coupon": {
                "has_coupon": "¿Tienes un cupón de descuento?",
                "placeholder": "CÓDIGO",
                "apply": "Aplicar",
                "discount_coupon": "Cupón de descuento",
                "coupon": "Cupón",
                "add": "Aplicar un cupón de descuento"
            },
            "add_item": {
                "failed": "Error al agregar el artículo al carrito"
            },
            "recurrent_plan_aready_exists": "Artículo recurrente ya agregado al carrito",
            "invalid_plan_type": "Tipo de plan no válido",
            "invalid_plan_recurrence_option": "La opción de recurrencia especificada no es válida",
            "plan_recurrence_required": "Proporcione una opción de recurrencia",
            "plan_sales_limit_exceeded": "Límite de ventas alcanzado para este plan",
            "plan_recurrence_option_applied": "Opción de recurrencia aplicada con éxito",
            "plan_reccurrence_option_failed": "Error al aplicar la opción de recurrencia",
            "plan_type_required": "El tipo de plan es obligatorio",
            "pay": "Realizar pago",
            "change_payment": "Complete los datos de pago",
            "cart": "Carrito de compras",
            "go_to_cart": "Ir al carrito",
            "subscribe": "Suscribirse",
            "add_to_cart": "Agregar al carrito",
            "access_plan": "Acceder al plan",
            "plan_info": "Información del plan",
            "payment_type": "Forma de pago",
            "product": "Producto",
            "price": "Precio",
            "checkout": "Pagar",
            "type": "Período del plan",
            "type_recurrence": "Pago recurrente",
            "type_unique": "Pago único",
            "discount": "Descuento",
            "total": "Total: ",
            "finish": "Finalizar",
            "empty": "Tu carrito está vacío",
            "empty_message": "Antes de ir al pago, debes agregar algún producto a tu carrito.",
            "empty_button": "Seguir comprando",
            "currency": "Moneda",
            "filter": "Filtrar",
            "filter_by": "Filtrar por",
            "order_by": "Ordenar por",
            "remove_failed": "Error al intentar quitar el artículo del carrito",
            "admin_message": "No se pudo realizar la compra, asegúrate de estar conectado como alumno",
            "plans": {
                "types": "Tipos de planes",
                "public": "Público",
                "free": "Gratis",
                "single_purchase": "Pago único",
                "recurrence": "Recurrente",
                "value": "Valor del plan",
                "categories": "Categorías",
                "no_category": "Sin categoría"
            },
            "min_price": "Precio mínimo",
            "max_price": "Precio máximo",
            "clean_filters": "Limpiar filtros",
            "clear": "Vaciar el carrito",
            "item_added": "¡Artículo añadido al carrito!",
            "code": "Código",
            "code_empty": "Código obligatorio",
            "free_item_add": "¡Inscrito con éxito!",
            "free_item_wait": "Plan agregado a tu cuenta, espera la autorización de tu inscripción",
            "deleted": "Artículo del carrito eliminado con éxito",
            "item": {
                "added": "Artículo añadido al carrito",
                "removed": "Artículo eliminado del carrito",
                "exists": "Producto ya añadido al carrito"
            },
            "obs": "Nota:",
            "obs_message": "El pago puede demorar hasta 72 horas en aprobarse.",
            "billet_bank": "Para realizar el pago con ",
            "billet_bank_redirect": "haz clic en el botón de abajo y serás redirigido a la página de impresión del boleto bancario.",
            "billet_dare": "Para emitir la guía de pago DARE, haz clic en el botón de abajo y serás redirigido a la página de impresión de la guía DARE.",
            "paypal_message": "Para realizar el pago con PayPal, haz clic en el botón de abajo y serás redirigido al sitio de PayPal.",
            "stripe_message": "Para realizar el pago con Stripe Checkout, haz clic en el botón de abajo y serás redirigido al sitio de Stripe.",
            "stripe_message_no_recurrency": "Los pagos recurrentes aún no están disponibles para Stripe. Por favor, elija otro método de pago.",
            "checkout_stripe": "Checkout Stripe",
            "payment_intent_stripe": "Stripe",
            "stripe": {
                "card_number": "Número de tarjeta",
                "card_expiry": "Vencimiento",
                "card_cvc": "CVC",
                "card_already_registered": "¡Ya tienes una tarjeta registrada!",
                "card_last_digits": "Últimos dígitos",
                "card_brand": "Marca de la tarjeta",
                "card_status": "Estado",
                "remove_payment_method": "Eliminar Método de Pago",
                "payment_method": "Método de Pago Registrado ",
                "card_exp_month": "Mes de Vencimiento",
                "card_exp_year": "Año de Vencimiento",
                "create_token": "Registrar Método de Pago",
                "update_token": "Actualizar Método de Pago"
            },
            "pagseguro_message": "Para realizar el pago con PagSeguro, haz clic en el botón de abajo y serás redirigido al sitio de PagSeguro.",
            "credit_card_message": "Para realizar el pago con tarjeta de crédito, haz clic en el botón de abajo y serás redirigido para completar el pago.",
            "credit_card_installments_message": "Para realizar el pago con tarjeta de crédito, elige el número de cuotas y haz clic en el botón de abajo para ser redirigido al pago.",
            "credit_card_obs": "El pago puede demorar hasta 48 horas en aprobarse.",
            "paypal_obs": "El pago puede demorar hasta 24 horas en aprobarse.",
            "stripe_obs": "El pago puede demorar hasta 24 horas en aprobarse.",
            "paypal": "PayPal",
            "pagseguro": "PagSeguro",
            "pagseguro_billet_message": "Para realizar el pago mediante boleto, ingresa tu CPF y haz clic en Generar Boleto.",
            "pagseguro_billet_generate": "Generar Boleto",
            "pagseguro_billet_pdf": "Guardar boleto en PDF",
            "pix": "Pix",
            "pix_message": "Para realizar el pago mediante Pix, ingresa tu CPF y haz clic en Generar código QR",
            "pix_key": "Clave Pix",
            "pix_copy": "Copia y pega:",
            "dare": "DARE",
            "credit_card": "Tarjeta de Crédito",
            "deposit": "Depósito Bancario",
            "deposit_message": "Para realizar el pago mediante una transferencia electrónica, haz clic en el botón de abajo y luego serás redirigido a la página con los datos bancarios y el campo de adjunto para el comprobante de pago.",
            "make_payment": "Realizar pago con ",
            "finish_payment": "¡Gracias por tu compra!",
            "plan_activate": "Tu plan se activará una vez que se complete el pago",
            "date_expired": "La tarjeta ha caducado.",
            "address": {
                "address": "Dirección",
                "insert": "Por favor, registra una dirección",
                "invalid": "Lo siento, no se pudo guardar la dirección"
            },
            "checkout_errors": {
                "brand_not_identified": "No fue posible identificar la marca de la tarjeta. Revise el número ingresado o seleccione la marca manualmente.",
                "brand_not_accepted": "La marca {brand} no es aceptada por este medio de pago.",
                "pending_invoice_multiple": "Ya existe una factura abierta para uno de los ítems del carrito. Pague la factura en Financiero o quite el ítem para continuar.",
                "payment_reversed": "El cobro en la tarjeta fue cancelado automáticamente y no se debitará ningún valor.",
                "payment_not_reversed": "No fue posible cancelar el cobro automáticamente. Contacte al soporte informando la hora de la compra."
            }
        },
        "blog": {
            "share": "Compartir",
            "share_on": "Compartir en {social}",
            "copy_url": "Copiar URL",
            "posts": {
                "by": "Publicado por",
                "views": "Visualizaciones",
                "search": "Buscar publicación",
                "latest": "Últimas publicaciones",
                "no_data": "Ninguna publicación"
            },
            "comments": {
                "title": "Comentarios",
                "reply_to": "Respuesta a {author}",
                "no_replies": "Ninguna respuesta",
                "show_replies": "Mostrar respuestas",
                "login_comment": "Inicia sesión y deja tu comentario",
                "form_title": "Deja un comentario",
                "no_data": "Ningún comentario hasta el momento",
                "send": "Enviar",
                "reply": "Responder",
                "replies": "Respuestas",
                "load_more": "Ver más comentarios"
            },
            "categories": {
                "title": "Categorías",
                "more": "Mostrar más"
            },
            "tags": {
                "see_more": "Ver más sobre:"
            }
        },
        "header": {
            "cart": {
                "empty": "Tu carrito está vacío."
            },
            "profile": {
                "title": "Perfil",
                "logout": "Cerrar sesión",
                "welcome": "Bienvenido",
                "notifications": "Notificaciones",
                "cart": "Carrito",
                "menus": "Menús"
            },
            "notifications": {
                "you_have": "Tienes",
                "notification": "notificación.",
                "notifications": "notificaciones.",
                "all": "Ver todas",
                "ago": "hace",
                "marker_all_read": "Marcar todas como leídas"
            }
        },
        "class": {
            "back_to_plan": "Volver al plan",
            "course_content": "Contenido del curso",
            "forum": "Foro",
            "hasnt_forum": "No tiene foro",
            "description": "Descripción",
            "certificate_without_progress": "No se ha alcanzado suficiente progreso para recibir el certificado"
        },
        "support": {
            "submit": "Enviar Consulta",
            "support_form": "Formulario de Contacto",
            "label": "Asunto",
            "invalid_email": "Correo electrónico no válido.",
            "sent_success": "Correo electrónico de contacto enviado con éxito.",
            "title": "Soporte",
            "show_more": "Mostrar más",
            "chat": {
                "title": "Chat",
                "search": "Buscar",
                "write_message": "Escribe un mensaje",
                "send": "Enviar",
                "finish": "Finalizar Interacciones del Chat",
                "last_interaction": "Última interacción",
                "interaction_finish": "Interacción finalizada",
                "attendant": "Asistente",
                "send_placeholder": "Escribe tu mensaje..."
            },
            "forum": "Foro",
            "forum_answer": "Respuestas del Foro",
            "forums": {
                "title": "Foro",
                "type": "Tipo de Foro",
                "moderated": "Moderado",
                "number_topics": "Número de Temas",
                "view_topics": "Ver Temas",
                "inactive": "Desactivar Foro",
                "active": "Activar Foro",
                "remove": "Eliminar Foro",
                "remove_forum_warning": "Al eliminar el foro, se eliminarán todos los temas y respuestas. ¿Estás seguro de que deseas continuar?",
                "topics": {
                    "title": "Temas",
                    "name": "Nombre del Tema",
                    "number_answers": "Número de Interacciones",
                    "status": "Estado",
                    "user": "Usuario Creador del Tema",
                    "created_date": "Fecha de Creación",
                    "answers": "Respuestas",
                    "edit": "Editar Tema",
                    "remove": "Eliminar Tema",
                    "update_name": "Actualizar nombre del Tema"
                },
                "create": "Crear Foro",
                "waiting_for_approval": "Esperando aprobación",
                "updated_at": "Fecha de Actualización"
            },
            "forum_answers": {
                "view": "Ver respuestas",
                "title": "Interacciones del Tema",
                "reply_placeholder": "Escribe una Respuesta...",
                "topic_edit_placeholder": "Editando el texto..."
            },
            "settings": {
                "title": "Configuración de Soporte",
                "email": "Correo electrónico",
                "labels": "Asuntos",
                "label": "Asunto",
                "add_label": "Agregar etiqueta",
                "remove_label": "Eliminar etiqueta",
                "enable_ticket": "Soporte a través de ticket",
                "email_title": "Correo electrónico",
                "ticket_title": "Ticket",
                "chat_title": "Chat",
                "enable_email": "Soporte por correo electrónico",
                "enable_chat": "Soporte por chat",
                "support_form": "Formulario de contacto de soporte"
            },
            "tickets": {
                "ticket": "Ticket",
                "tickets": "Tickets",
                "create": "Nuevo Ticket",
                "title": "Asunto",
                "search": "Buscar por id o título del ticket",
                "content": "Mensaje de respuesta",
                "send": "Enviar",
                "plan": "Plan",
                "send_success": "Mensaje enviado con éxito",
                "resolved": "Ticket resuelto",
                "delete_many": "Eliminar Ticket(s)",
                "delete": "Eliminar Ticket",
                "operator": "Operador",
                "change_operator": "Cambiar operador",
                "student": "Suscriptor",
                "department": "Departamento",
                "created_at": "Creado en",
                "last_reply": "Última interacción",
                "waiting_time": "{user} está esperando una respuesta desde hace {time}",
                "status": "Situación",
                "some": "un ticket",
                "view": "Ver ticket",
                "id": "ID",
                "all": "Todos",
                "reply": "Mensaje",
                "reply_error": "Error al enviar respuesta",
                "close": "Cerrar Ticket",
                "situation": {
                    "OPEN": "Abierto",
                    "WAITING_STUDENT": "Esperando Suscriptor",
                    "WAITING_OP": "Esperando Operador",
                    "CLOSED": "Cerrado",
                    "RESOLVED": "Resuelto",
                    "IN_PROCESS": "En proceso"
                },
                "number_ticket": "Nº del Ticket"
            },
            "labels": {
                "labels": "Departamentos",
                "manager": "Gestionar departamentos",
                "find": "Escribe para buscar departamentos"
            },
            "map": {
                "contact_info": "Información de Contacto",
                "telephone": "Teléfono",
                "address": "Dirección"
            }
        },
        "documents": {
            "type": "Tipo de documento",
            "invalid": "Documento {type} inválido"
        },
        "course": {
            "tabs": {
                "wiki": "Wiki de la clase",
                "glossary": "Glosario",
                "overview": "Visión general",
                "content": "Contenido",
                "forum": "Foro"
            },
            "start": "Comenzar",
            "continue": "Continuar",
            "modules": "Módulos",
            "lessons": "Lecciones",
            "exercises": "Ejercicios",
            "topics": "Encuestas",
            "show_more": "Mostrar más",
            "module_no_content": "Este módulo no tiene contenido",
            "course_no_content": "En este momento no hay contenido disponible para visualización",
            "publish": {
                "schedule": "Este curso estará disponible entre las fechas: ",
                "schedule_end": "Este curso finalizó en la fecha: "
            }
        },
        "module": {
            "publish": {
                "schedule": "Este módulo se liberará entre las fechas:",
                "schedule_end": "Este módulo finalizó en la fecha:"
            }
        },
        "payment_erros": {
            "stripe": {
                "account_closed": "La cuenta bancaria del cliente ha sido cerrada.",
                "account_country_invalid_address": "El país de la dirección comercial proporcionada no coincide con el país de la cuenta. Las empresas deben estar ubicadas en el mismo país que la cuenta.",
                "account_error_country_change_requires_additional_steps": "Su cuenta ya se ha configurado como una plataforma Connect. Cambiar su país requiere pasos adicionales. Comuníquese con el soporte de Stripe para obtener más información.",
                "account_information_mismatch": "Algunas informaciones de la cuenta no coinciden entre sí. Por ejemplo, algunos bancos pueden requerir que el nombre del perfil comercial coincida con el nombre del titular de la cuenta.",
                "account_invalid": "El ID de la cuenta proporcionado como valor para el encabezado Stripe-Account es inválido. Verifique que sus solicitudes estén especificando un ID de cuenta válido.",
                "account_number_invalid": "El número de cuenta bancaria proporcionado es inválido (por ejemplo, faltan dígitos). La información de la cuenta bancaria varía de un país a otro. Recomendamos crear validaciones en sus formularios de entrada según los formatos de cuenta bancaria que proporcionamos.",
                "acss_debit_session_incomplete": "La sesión de débito ACSS no está lista para cambiar a estado completo todavía. Por favor intente nuevamente más tarde.",
                "alipay_upgrade_required": "Este método para crear pagos Alipay ya no es compatible. Actualice su integración para usar Sources en su lugar.",
                "amount_too_large": "La cantidad especificada es mayor que la cantidad máxima permitida. Use una cantidad menor e intente nuevamente.",
                "amount_too_small": "La cantidad especificada es menor que la cantidad mínima permitida. Use una cantidad mayor e intente nuevamente.",
                "api_key_expired": "La clave API proporcionada ha expirado. Obtenga sus claves API actuales del Panel de control y actualice su integración para usarlas.",
                "application_fees_not_allowed": "El movimiento de dinero propuesto no pudo completarse por razones regulatorias.",
                "authentication_required": "El pago requiere autenticación para proceder. Intente nuevamente después de autenticar el pago.",
                "balance_insufficient": "La transferencia o pago no se pudo completar porque la cuenta asociada no tiene un saldo suficiente disponible. Cree una nueva transferencia o pago utilizando una cantidad menor o igual al saldo disponible de la cuenta.",
                "balance_invalid_parameter": "Se proporcionó un parámetro inválido en el objeto del método de saldo. Consulte nuestra documentación de la API o el mensaje de error devuelto para obtener más contexto.",
                "bank_account_bad_routing_numbers": "Se sabe que la cuenta bancaria no admite la moneda en cuestión.",
                "bank_account_declined": "La cuenta bancaria proporcionada no se puede usar para cobrar, ya sea porque aún no está verificada o porque no es compatible.",
                "bank_account_exists": "La cuenta bancaria proporcionada ya existe en el objeto Cliente especificado. Si la cuenta bancaria también debe estar vinculada a otro cliente, incluya el ID de cliente correcto al hacer la solicitud nuevamente.",
                "bank_account_restricted": "La cuenta del cliente no se puede usar con el método de pago.",
                "bank_account_unusable": "La cuenta bancaria proporcionada no se puede usar. Debe usarse una cuenta bancaria diferente.",
                "bank_account_unverified": "Su plataforma Connect está intentando compartir una cuenta bancaria no verificada con una cuenta conectada.",
                "bank_account_verification_failed": "La cuenta bancaria no se puede verificar, ya sea porque las cantidades de microdepósito proporcionadas no coinciden con las cantidades reales o porque la verificación ha fallado demasiadas veces.",
                "billing_invalid_mandate": "La suscripción o factura intentó el pago en un método de pago sin un mandato activo. Para crear pagos de suscripción o factura con este método de pago, debe confirmarse en la sesión primero con un PaymentIntent o SetupIntent.",
                "billing_policy_remote_function_response_invalid": "Una respuesta de endpoint de función remota de política de facturación devolvió datos inválidos.",
                "billing_policy_remote_function_timeout": "Una función remota de política de facturación agotó el tiempo de espera.",
                "billing_policy_remote_function_unexpected_status_code": "Una función remota de política de facturación devolvió un código de estado inesperado.",
                "billing_policy_remote_function_unreachable": "Ocurrió un error al ejecutar una función remota de política de facturación.",
                "bitcoin_upgrade_required": "Este método para crear pagos de Bitcoin ya no es compatible. Actualice su integración para usar Sources en su lugar.",
                "capture_charge_authorization_expired": "La autorización de la carga ha expirado y no se puede capturar. Consulte la documentación del método de pago para obtener más información.",
                "capture_unauthorized_payment": "La carga que está intentando capturar no ha sido autorizada para capturar el pago.",
                "card_decline_rate_limit_exceeded": "Esta tarjeta ha sido rechazada demasiadas veces. Puede intentar cargar esta tarjeta nuevamente después de 24 horas. Sugerimos comunicarse con su cliente para asegurarse de que haya ingresado toda su información correctamente y que no haya problemas con su tarjeta.",
                "card_declined": "La tarjeta ha sido rechazada. Cuando una tarjeta es rechazada, el error devuelto también incluye el atributo decline_code con la razón por la cual la tarjeta fue rechazada. Consulte nuestra documentación de códigos de rechazo para obtener más información.",
                "cardholder_phone_number_required": "Debe tener un número de teléfono registrado para los titulares de tarjetas que crearán tarjetas de la UE. No puede crear tarjetas de la UE sin un número de teléfono registrado para el titular de la tarjeta. Consulte la documentación de 3D Secure para más detalles.",
                "charge_already_captured": "La carga que está intentando capturar ya ha sido capturada. Actualice la solicitud con un ID de carga no capturado.",
                "charge_already_refunded": "La carga que está intentando reembolsar ya ha sido reembolsada. Actualice la solicitud para usar el ID de una carga que no haya sido reembolsada.",
                "charge_disputed": "La carga que está intentando reembolsar ha sido disputada. Consulte la documentación de disputas para saber cómo responder a la disputa.",
                "charge_exceeds_source_limit": "Esta carga causaría que excediera su límite de procesamiento de ventana continua para este tipo de fuente. Por favor, intente nuevamente la carga más tarde o comuníquese con nosotros para solicitar un límite de procesamiento más alto.",
                "charge_expired_for_capture": "La carga no se puede capturar porque la autorización ha expirado. Las cargas de autorización y captura deben capturarse dentro de un número determinado de días (7 por defecto).",
                "charge_invalid_parameter": "Uno o más parámetros proporcionados no estaban permitidos para la operación dada en la carga. Consulte nuestra referencia de la API o el mensaje de error devuelto para ver qué valores no eran correctos para esa carga.",
                "charge_not_refundable": "El intento de reembolsar una carga no tuvo éxito porque la carga ya no es reembolsable.",
                "clearing_code_unsupported": "El código de compensación proporcionado no es compatible.",
                "country_code_invalid": "El código del país proporcionado era inválido.",
                "country_unsupported": "Su plataforma intentó crear una cuenta personalizada en un país que aún no es compatible. Asegúrese de que los usuarios solo puedan registrarse en países admitidos por cuentas personalizadas.",
                "coupon_expired": "El cupón proporcionado para una suscripción o pedido ha expirado. Cree un nuevo cupón o use uno existente que sea válido.",
                "customer_max_payment_methods": "Se ha alcanzado el número máximo de métodos de pago para este cliente. Desvincule algunos métodos de pago de este cliente o proceda con un cliente diferente.",
                "customer_max_subscriptions": "Se ha alcanzado el número máximo de suscripciones para un cliente. Contáctenos si está recibiendo este error.",
                "customer_tax_location_invalid": "La información de ubicación del cliente no se puede utilizar para determinar con precisión las tasas. Verifique que los campos de dirección como país, estado y código postal se hayan agregado correctamente. Consulte los formatos de dirección admitidos.",
                "debit_not_authorized": "El cliente ha notificado a su banco que este pago no fue autorizado.",
                "email_invalid": "La dirección de correo electrónico es inválida (por ejemplo, no está formateada correctamente). Verifique que la dirección de correo electrónico esté formateada correctamente e incluya solo caracteres permitidos.",
                "expired_card": "La tarjeta ha expirado. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "financial_connections_account_inactive": "Los datos no se pueden actualizar en cuentas de Conexiones Financieras inactivas.",
                "financial_connections_no_successful_transaction_refresh": "Los datos de transacción solo se pueden recuperar para cuentas que tienen al menos una actualización de transacción exitosa.",
                "forwarding_api_inactive": "La API de almacenamiento y reenvío actualmente no está accesible con esta cuenta y/o configuración. Contáctenos si está recibiendo este error.",
                "forwarding_api_invalid_parameter": "Se proporcionó un parámetro inválido en la API de almacenamiento y reenvío. Consulte nuestra documentación de la API o el mensaje de error devuelto para obtener más contexto.",
                "forwarding_api_upstream_connection_error": "Stripe no recibió una respuesta del punto final de destino.",
                "forwarding_api_upstream_connection_timeout": "La solicitud al punto final de destino agotó el tiempo de espera.",
                "idempotency_key_in_use": "La clave de idempotencia proporcionada está siendo utilizada actualmente en otra solicitud. Esto ocurre si su integración está realizando solicitudes duplicadas simultáneamente.",
                "incomplete_name": "El nombre proporcionado no es válido.",
                "invalid_expiry_year_past": "El año de vencimiento de la tarjeta es inválido. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "incorrect_address": "La dirección proporcionada no coincide con la dirección que el emisor de la tarjeta tiene en el archivo. Verifique la dirección o use una tarjeta diferente.",
                "incomplete_address": "La dirección proporcionada está incompleta.",
                "incomplete_cvc": "El código de seguridad de la tarjeta es incompleto. Verifique el código de seguridad de la tarjeta o use una tarjeta diferente.",
                "incomplete_expiry": "La fecha de vencimiento de la tarjeta es incompleta. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "incorrect_expiry_month": "El mes de vencimiento de la tarjeta es incorrecto. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "incorrect_expiry_year": "El año de vencimiento de la tarjeta es incorrecto. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "incorrect_cvc_length": "El código de seguridad de la tarjeta tiene una longitud incorrecta. Verifique el código de seguridad de la tarjeta o use una tarjeta diferente.",
                "incorret_boleto_tax_id": "El ID fiscal proporcionado no es válido para el boleto.",
                "incorrect_cvc": "El código de seguridad de la tarjeta es incorrecto. Verifique el código de seguridad de la tarjeta o use una tarjeta diferente.",
                "incorrect_number": "El número de la tarjeta es incorrecto. Verifique el número de la tarjeta o use una tarjeta diferente.",
                "incorrect_zip": "El código postal de la tarjeta es incorrecto. Verifique el código postal de la tarjeta o use una tarjeta diferente.",
                "incomplete_number": "El número de la tarjeta está incompleto. Verifique el número de la tarjeta o use una tarjeta diferente.",
                "instant_payouts_config_disabled": "Esta cuenta conectada no es elegible para Pagos Instantáneos. Pida a la plataforma que habilite los Pagos Instantáneos.",
                "instant_payouts_currency_disabled": "Esta cuenta conectada no es elegible para Pagos Instantáneos en esta moneda. Pida a la plataforma que habilite los Pagos Instantáneos en esta moneda.",
                "instant_payouts_limit_exceeded": "Ha alcanzado sus límites de procesamiento diarios para Pagos Instantáneos.",
                "instant_payouts_unsupported": "Esta tarjeta no es elegible para Pagos Instantáneos. Pruebe con una tarjeta de débito de un banco compatible.",
                "insufficient_funds": "La cuenta del cliente no tiene fondos suficientes para cubrir este pago.",
                "intent_invalid_state": "La intención no está en el estado requerido para realizar la operación.",
                "intent_verification_method_missing": "La intención no tiene un método de verificación especificado en su objeto PaymentMethodOptions.",
                "invalid_card_type": "La tarjeta proporcionada como cuenta externa no es compatible para pagos. Proporcione una tarjeta de débito no prepaga en su lugar.",
                "invalid_characters": "Este valor proporcionado al campo contiene caracteres que no son compatibles con el campo.",
                "invalid_charge_amount": "La cantidad especificada es inválida. El monto de la carga debe ser un entero positivo en la unidad monetaria más pequeña y no debe exceder el monto mínimo o máximo.",
                "invalid_cvc": "El código de seguridad de la tarjeta es inválido. Verifique el código de seguridad de la tarjeta o use una tarjeta diferente.",
                "invalid_expiry_month": "El mes de vencimiento de la tarjeta es incorrecto. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "invalid_expiry_year": "El año de vencimiento de la tarjeta es incorrecto. Verifique la fecha de vencimiento o use una tarjeta diferente.",
                "invalid_number": "El número de la tarjeta es inválido. Verifique los detalles de la tarjeta o use una tarjeta diferente.",
                "invalid_source_usage": "La fuente no se puede usar porque no está en el estado correcto (por ejemplo, una solicitud de carga está intentando usar una fuente con una fuente pendiente, fallida o consumida). Verifique el estado de la fuente que está intentando usar.",
                "invalid_tax_location": "La ubicación especificada es inválida. Consulte los Formatos de dirección admitidos para obtener los formatos de dirección admitidos al calcular impuestos.",
                "invoice_no_customer_line_items": "No se puede generar una factura para el cliente especificado ya que no hay elementos de factura pendientes. Verifique que se esté especificando el cliente correcto o cree primero los elementos de factura necesarios.",
                "invoice_no_payment_method_types": "No se puede finalizar una factura porque no hay tipos de métodos de pago disponibles para procesar el pago. Las configuraciones de plantilla de factura o las configuraciones de payment_settings de la factura pueden estar restringiendo qué métodos de pago están disponibles, o puede necesitar activar más métodos de pago en el Panel de control.",
                "invoice_no_subscription_line_items": "No se puede generar una factura para la suscripción especificada ya que no hay elementos de factura pendientes. Verifique que se esté especificando la suscripción correcta o cree primero los elementos de factura necesarios.",
                "invoice_not_editable": "La factura especificada ya no se puede editar. En su lugar, considere crear elementos de factura adicionales que se aplicarán a la próxima factura. Puede generar manualmente la próxima factura o esperar a que se genere automáticamente al final del ciclo de facturación.",
                "invoice_on_behalf_of_not_editable": "No puede actualizar la propiedad on_behalf_of de una factura después de que se haya asignado un número a la factura.",
                "invoice_payment_intent_requires_action": "Este pago requiere una acción adicional del usuario antes de poder completarse con éxito. El pago se puede completar utilizando el PaymentIntent asociado con la factura. Consulte esta página para obtener más detalles.",
                "invoice_upcoming_none": "No hay una factura próxima para el cliente especificado para previsualizar. Solo los clientes con suscripciones activas o elementos de factura pendientes tienen facturas que se pueden previsualizar.",
                "livemode_mismatch": "Las claves de la API, solicitudes y objetos de modo de prueba y modo en vivo solo están disponibles dentro del modo en el que se encuentran.",
                "lock_timeout": "Este objeto no se puede acceder en este momento porque otra solicitud de API o proceso de Stripe lo está accediendo actualmente. Si ve este error de manera intermitente, intente nuevamente la solicitud. Si ve este error con frecuencia y está realizando múltiples solicitudes simultáneas a un solo objeto, realice sus solicitudes en serie o a una tasa más baja. Consulte la documentación de límite de tasa para obtener más detalles.",
                "missing": "Se han proporcionado un cliente y un ID de fuente, pero la fuente no se ha guardado para el cliente. Para crear una carga para un cliente con una fuente especificada, primero debe guardar los detalles de la tarjeta.",
                "no_account": "No se pudo ubicar la cuenta bancaria.",
                "not_allowed_on_standard_account": "No se permiten transferencias y pagos en nombre de una cuenta conectada estándar.",
                "no_payment_method": "No se pudo encontrar un método de pago para la suscripción.",
                "out_of_inventory": "Uno o más elementos de línea están fuera de stock. Si hay más stock disponible, actualice la cantidad ordenable del inventario e intente nuevamente.",
                "ownership_declaration_not_allowed": "La declaración de propiedad de la empresa solo se permite durante las actualizaciones de cuenta y las cuentas creadas a través de tokens de cuenta.",
                "parameter_invalid_empty": "No se proporcionaron uno o más valores requeridos. Asegúrese de que las solicitudes incluyan todos los parámetros requeridos.",
                "parameter_invalid_integer": "Uno o más de los parámetros requiere un entero, pero los valores proporcionados eran de un tipo diferente. Asegúrese de que solo se proporcionen valores admitidos para cada atributo. Consulte nuestra documentación de la API para buscar el tipo de datos que admite cada atributo.",
                "parameter_invalid_string_blank": "Uno o más valores proporcionados solo incluían espacios en blanco. Verifique los valores en su solicitud y actualice los que contienen solo espacios en blanco.",
                "parameter_invalid_string_empty": "Uno o más valores de cadena requeridos están vacíos. Asegúrese de que los valores de cadena contengan al menos un carácter.",
                "parameter_missing": "Faltan uno o más valores requeridos. Consulte nuestra documentación de la API para ver qué valores son necesarios para crear o modificar el recurso especificado.",
                "parameter_unknown": "La solicitud contiene uno o más parámetros inesperados. Elimínelos e intente nuevamente.",
                "parameters_exclusive": "Se proporcionaron dos o más parámetros mutuamente exclusivos. Consulte nuestra documentación de la API o el mensaje de error devuelto para ver qué valores están permitidos al crear o modificar el recurso especificado.",
                "payment_intent_action_required": "El método de pago proporcionado requiere acciones del cliente para completarse, pero se estableció error_on_requires_action. Si desea agregar este método de pago a su integración, recomendamos primero actualizar su integración para manejar acciones.",
                "payment_intent_authentication_failure": "El método de pago proporcionado ha fallado en la autenticación. Proporcione un nuevo método de pago para intentar completar este PaymentIntent nuevamente.",
                "payment_intent_incompatible_payment_method": "El PaymentIntent esperaba un método de pago con propiedades diferentes a las que se proporcionaron.",
                "payment_intent_invalid_parameter": "Uno o más parámetros proporcionados no estaban permitidos para la operación dada en el PaymentIntent. Consulte nuestra referencia de la API o el mensaje de error devuelto para ver qué valores no eran correctos para ese PaymentIntent.",
                "payment_intent_konbini_rejected_confirmation_number": "El número de confirmación proporcionado en payment_method_options[konbini] fue rechazado por el socio de procesamiento en el momento de la confirmación del PaymentIntent.",
                "payment_intent_mandate_invalid": "El mandato proporcionado es inválido y no se puede usar para la intención de pago.",
                "payment_intent_payment_attempt_expired": "El último intento de pago para el PaymentIntent ha expirado. Verifique la propiedad last_payment_error en el PaymentIntent para obtener más detalles y proporcione un nuevo método de pago para intentar completar este PaymentIntent nuevamente.",
                "payment_intent_payment_attempt_failed": "El último intento de pago para el PaymentIntent ha fallado. Verifique la propiedad last_payment_error en el PaymentIntent para obtener más detalles y proporcione un nuevo método de pago para intentar completar este PaymentIntent nuevamente.",
                "payment_intent_unexpected_state": "El estado del PaymentIntent era incompatible con la operación que estaba intentando realizar.",
                "payment_method_bank_account_already_verified": "Esta cuenta bancaria ya ha sido verificada.",
                "payment_method_bank_account_blocked": "Esta cuenta bancaria ha fallado en la verificación en el pasado y no se puede usar. Contáctenos si desea intentar usar estas credenciales de cuenta bancaria.",
                "payment_method_billing_details_address_missing": "Los detalles de facturación del método de pago carecen de detalles de dirección. Actualice los campos faltantes e intente nuevamente.",
                "payment_method_configuration_failures": "El intento de crear o modificar la Configuración del Método de Pago no tuvo éxito.",
                "payment_method_currency_mismatch": "La moneda especificada no coincide con la moneda para el método de pago adjunto. Un pago solo se puede crear para la misma moneda que el método de pago correspondiente.",
                "payment_method_customer_decline": "El cliente no aprobó el pago. Proporcione un nuevo método de pago para intentar completar esta intención nuevamente.",
                "payment_method_invalid_parameter": "Se proporcionó un parámetro inválido en el objeto del método de pago. Consulte nuestra documentación de la API o el mensaje de error devuelto para obtener más contexto.",
                "payment_method_invalid_parameter_testmode": "El parámetro proporcionado para el método de pago no está permitido para usarse en el modo de prueba. Consulte nuestra documentación de la API o el mensaje de error devuelto para obtener más contexto.",
                "payment_method_microdeposit_failed": "Los microdepósitos no se depositaron en la cuenta bancaria del cliente. Verifique el número de cuenta, los números de institución y tránsito, así como el tipo de moneda.",
                "payment_method_microdeposit_verification_amounts_invalid": "Debe proporcionar exactamente dos cantidades de microdepósito.",
                "payment_method_microdeposit_verification_amounts_mismatch": "Las cantidades proporcionadas no coinciden con las cantidades enviadas a la cuenta bancaria.",
                "payment_method_microdeposit_verification_attempts_exceeded": "Ha excedido el número de intentos de verificación permitidos.",
                "payment_method_microdeposit_verification_descriptor_code_mismatch": "El código de verificación proporcionado no coincide con el enviado a la cuenta bancaria.",
                "payment_method_microdeposit_verification_timeout": "El método de pago debe verificarse con microdepósitos dentro del período requerido.",
                "payment_method_not_available": "El procesador de pagos para el método de pago proporcionado está temporalmente no disponible. Intente con un método de pago diferente o intente nuevamente más tarde con el mismo método de pago.",
                "payment_method_provider_decline": "El intento de pago o configuración fue rechazado por el emisor o cliente. Consulte la propiedad last_payment_error o last_setup_error en el PaymentIntent o SetupIntent, respectivamente, para obtener más detalles, y proporcione un nuevo método de pago para intentar completar esta intención nuevamente.",
                "payment_method_provider_timeout": "El método de pago falló debido a un tiempo de espera. Consulte la propiedad last_payment_error o last_setup_error en el PaymentIntent o SetupIntent, respectivamente, para obtener más detalles, y proporcione un nuevo método de pago para intentar completar esta intención nuevamente.",
                "payment_method_unactivated": "La operación no se puede realizar, ya que el método de pago utilizado no ha sido activado. Active el método de pago en el Panel de control y luego intente nuevamente.",
                "payment_method_unexpected_state": "El estado del método de pago proporcionado era incompatible con la operación que estaba intentando realizar. Confirme que el método de pago está en un estado permitido para la operación dada antes de intentar realizarla.",
                "payment_method_unsupported_type": "La API solo admite métodos de pago de ciertos tipos.",
                "payout_reconciliation_not_ready": "La conciliación para este pago aún está en progreso.",
                "payouts_limit_exceeded": "Ha alcanzado sus límites de procesamiento diarios para este tipo de pago.",
                "payouts_not_allowed": "Los pagos han sido desactivados en la cuenta conectada. Verifique el estado de la cuenta conectada para ver si se necesita proporcionar información adicional o si los pagos se han desactivado por otra razón.",
                "platform_account_required": "Solo las plataformas de Stripe Connect pueden trabajar con otras cuentas. Si necesita configurar una plataforma Stripe Connect, puede hacerlo en el Panel de control.",
                "platform_api_key_expired": "La clave API proporcionada por su plataforma Connect ha expirado. Esto ocurre si su plataforma ha generado una nueva clave o si la cuenta conectada se ha desconectado de la plataforma. Obtenga sus claves API actuales del Panel de control y actualice su integración, o comuníquese con el usuario y vuelva a conectar la cuenta.",
                "postal_code_invalid": "El código postal proporcionado era incorrecto.",
                "processing_error": "Ocurrió un error al procesar la tarjeta. Intente nuevamente más tarde o con un método de pago diferente.",
                "product_inactive": "El producto al que pertenece este SKU ya no está disponible para su compra.",
                "progressive_onboarding_limit_exceeded": "Se ha alcanzado el límite de integración progresiva para la plataforma.",
                "rate_limit": "Demasiadas solicitudes llegaron a la API demasiado rápido. Recomendamos un retroceso exponencial de sus solicitudes.",
                "refer_to_customer": "El cliente ha detenido el pago con su banco. Comuníquese con él para obtener detalles y para organizar el pago.",
                "refund_disputed_payment": "No puede reembolsar un pago en disputa.",
                "resource_already_exists": "Un recurso con un ID especificado por el usuario (por ejemplo, plan o cupón) ya existe. Use un valor diferente y único para el ID e intente nuevamente.",
                "resource_missing": "El ID proporcionado no es válido. O el recurso no existe o se ha proporcionado un ID para un recurso diferente.",
                "return_intent_already_processed": "No puede confirmar este reembolso, ya que ya está procesado.",
                "routing_number_invalid": "El número de ruta bancaria proporcionado es inválido.",
                "secret_key_required": "La clave API proporcionada es una clave publicable, pero se requiere una clave secreta. Obtenga sus claves API actuales del Panel de control y actualice su integración para usarlas.",
                "sepa_unsupported_account": "Su cuenta no admite pagos SEPA.",
                "setup_attempt_failed": "El último intento de configuración para el SetupIntent falló. Consulte la propiedad last_setup_error en el SetupIntent para obtener más detalles y proporcione un nuevo método de pago para intentar configurarlo nuevamente.",
                "setup_intent_authentication_failure": "El método de pago proporcionado ha fallado en la autenticación. Proporcione un nuevo método de pago para intentar completar este SetupIntent nuevamente.",
                "setup_intent_invalid_parameter": "Uno o más parámetros proporcionados no estaban permitidos para la operación dada en el SetupIntent. Consulte nuestra referencia de la API o el mensaje de error devuelto para ver qué valores no eran correctos para ese SetupIntent.",
                "setup_intent_mandate_invalid": "El mandato proporcionado es inválido y no se puede usar para la intención de configuración.",
                "setup_intent_setup_attempt_expired": "El último intento de configuración para el SetupIntent ha expirado. Consulte la propiedad last_setup_error en el SetupIntent para obtener más detalles y proporcione un nuevo método de pago para intentar completar este SetupIntent nuevamente.",
                "setup_intent_unexpected_state": "El estado del SetupIntent era incompatible con la operación que estaba intentando realizar.",
                "shipping_address_invalid": "La información de la dirección de envío no se puede utilizar para determinar con precisión las tasas. Verifique que los campos de dirección como código postal, estado o provincia se hayan agregado correctamente.",
                "shipping_calculation_failed": "El cálculo del envío falló porque la información proporcionada era incorrecta o no se pudo verificar.",
                "sku_inactive": "El SKU está inactivo y ya no está disponible para su compra. Use un SKU diferente o haga que el SKU actual esté activo nuevamente.",
                "state_unsupported": "Ocurre al proporcionar la información de entidad legal para una cuenta personalizada de EE. UU. si el estado proporcionado no es compatible. (Esto está principalmente asociado con estados y territorios.)",
                "status_transition_invalid": "La transición de estado solicitada no es válida.",
                "stripe_tax_inactive": "Stripe Tax no se ha activado en su cuenta. Consulte la documentación de configuración para comenzar.",
                "tax_id_invalid": "El ID fiscal proporcionado es inválido (por ejemplo, no se puede verificar). Verifique que el ID fiscal se haya ingresado correctamente y que coincida con el formato esperado.",
                "taxes_calculation_failed": "El cálculo de impuestos falló porque la información proporcionada era incorrecta o no se pudo verificar.",
                "testmode_charges_only": "Solo se pueden crear cargos en modo de prueba. No se pueden crear otros objetos en modo de prueba.",
                "testmode_credentials_required": "Se requieren credenciales de modo de prueba. Obtenga sus claves API actuales del Panel de control y actualice su integración para usarlas.",
                "testmode_only": "Solo se pueden realizar solicitudes en modo de prueba. Cambie a la clave API en vivo para realizar solicitudes en vivo.",
                "tls_version_unsupported": "Su integración está utilizando una versión de TLS que ya no es compatible. Debe actualizar su integración para usar TLS 1.2 o superior.",
                "token_already_used": "El token de pago ya se ha utilizado. Cree un nuevo token y vuelva a intentarlo.",
                "token_in_use": "El token de pago ya está en uso. Si necesita crear varios pagos con el mismo token, asegúrese de que no se esté utilizando en otro lugar.",
                "transfers_not_allowed": "Las transferencias han sido desactivadas en la cuenta conectada. Verifique el estado de la cuenta conectada para ver si se necesita proporcionar información adicional o si las transferencias se han desactivado por otra razón.",
                "url_invalid": "La URL proporcionada no es válida."
            }
        },
        "tickets": {
            "empty": {
                "title": "¡Ops! No tienes ningún ticket",
                "subtitle": "Puedes crear un nuevo ticket haciendo clic abajo",
                "button": "Nuevo ticket"
            }
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha posterior a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números y guiones.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser un array.",
            "err": "Error de validación",
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "El campo de confirmación {attribute} no coincide.",
            "date": "El campo {attribute} no es una fecha válida.",
            "date_format": "El campo {attribute} no coincide con el formato {format}.",
            "different": "Los campos {attribute} y {other} deben ser diferentes.",
            "digits": "El campo {attribute} debe tener {digits} dígitos.",
            "digits_between": "El campo {attribute} debe tener entre {min} y {max} dígitos.",
            "dimensions": "El campo {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El campo {attribute} tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El campo {attribute} seleccionado es inválido.",
            "file": "El campo {attribute} debe ser un archivo.",
            "filled": "El campo {attribute} debe tener un valor.",
            "image": "El campo {attribute} debe ser una imagen.",
            "in": "El campo {attribute} seleccionado es inválido.",
            "in_array": "El campo {attribute} no existe en {other}.",
            "integer": "El campo {attribute} debe ser un número entero.",
            "ip": "El campo {attribute} debe ser una dirección IP válida.",
            "ipv4": "El campo {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "El campo {attribute} debe ser una dirección IPv6 válida.",
            "json": "El campo {attribute} debe ser una cadena JSON válida.",
            "max": {
                "numeric": "El campo {attribute} no puede ser superior a {max}.",
                "file": "El campo {attribute} no puede ser superior a {max} kilobytes.",
                "string": "El campo {attribute} no puede ser superior a {max} caracteres.",
                "array": "El campo {attribute} no puede tener más de {max} elementos."
            },
            "mimes": "El campo {attribute} debe ser un archivo de tipo: {values}.",
            "mimetypes": "El campo {attribute} debe ser un archivo de tipo: {values}.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos {min}.",
                "file": "El campo {attribute} debe tener al menos {min} kilobytes.",
                "string": "El campo {attribute} debe tener al menos {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} elementos."
            },
            "not_in": "El campo {attribute} seleccionado es inválido.",
            "numeric": "El campo {attribute} debe ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El formato del campo {attribute} es inválido.",
            "required": "El campo {attribute} es obligatorio.",
            "required_if": "El campo {attribute} es obligatorio cuando {other} es {value}.",
            "required_unless": "El campo {attribute} es obligatorio a menos que {other} sea {values}.",
            "required_with": "El campo {attribute} es obligatorio cuando {values} está presente.",
            "required_with_all": "El campo {attribute} es obligatorio cuando {values} está presente.",
            "required_without": "El campo {attribute} es obligatorio cuando {values} no está presente.",
            "required_without_all": "El campo {attribute} es obligatorio cuando ninguno de los {values} está presente.",
            "same": "Los campos {attribute} y {other} deben coincidir.",
            "size": {
                "numeric": "El campo {attribute} debe ser {size}.",
                "file": "El campo {attribute} debe ser {size} kilobytes.",
                "string": "El campo {attribute} debe ser {size} caracteres.",
                "array": "El campo {attribute} debe contener {size} elementos."
            },
            "string": "El campo {attribute} debe ser una cadena de texto.",
            "timezone": "El campo {attribute} debe ser una zona horaria válida.",
            "unique": "El {attribute} ya está en uso.",
            "uploaded": "Falló la subida del archivo {attribute}.",
            "url": "El formato del campo {attribute} es inválido.",
            "white_space": "El campo {attribute} no debe contener espacios en blanco.",
            "reserved_in_system": "Este nombre está reservado por el sistema.",
            "custom": {
                "already_exists": "Ya existe un registro con ese valor",
                "fields": "Campos obligatorios no completados",
                "document": {
                    "unique": "Ya existe un alumno con el documento registrado"
                },
                "email": {
                    "unique": "Ya existe un alumno con el correo electrónico registrado"
                },
                "address": {
                    "postal_code": {
                        "invalid": "El CEP proporcionado es inválido"
                    },
                    "fields_required": "Todos los campos de la dirección son obligatorios"
                }
            },
            "attributes": {
                "document": "documento"
            }
        },
        "dashboard": {
            "courses": "Cursos",
            "content": "Contenido",
            "lessons": "Lecciones",
            "exercises": {
                "title": "Ejercicios",
                "answers": "Preguntas Respondidas"
            },
            "plan": {
                "change": "Cambiar Plan",
                "external_status_title": "Confirmación de matrícula",
                "external_status_description": "Hola {name}, estamos ansiosos por comenzar las actividades. <br> Para confirmar la matrícula, haz clic en el botón a continuación.",
                "external_status_ok": "Confirmar matrícula",
                "unavailable_content": "Contenido aún no disponible",
                "release_date": "Fecha de lanzamiento: "
            },
            "plans": "Planes",
            "in_progress": "En Progreso",
            "no_plans": "No tienes ningún plan",
            "empty_message": "Adquiere al menos un plan para acceder a tu contenido",
            "redirect_showcase": "Vitrina de Planes",
            "access": "Acceder",
            "start": "Comenzar",
            "continue": "Continuar",
            "disabled": "Desactivado",
            "progress": "Progreso",
            "notifications": {
                "title": "Notificaciones del Tablero",
                "name": "Notificaciones"
            },
            "expiration_days": "Días para expiración",
            "expiration_date": "Fecha de expiración",
            "tomorrow": "Mañana",
            "today": "Hoy",
            "expired": "Expirado"
        },
        "leads": {
            "capture_title": "Acceso al Contenido",
            "access_content": "Accede al Contenido Exclusivo",
            "fill_form_access": "Completa los datos a continuación para acceder al contenido",
            "name": "Nombre",
            "email": "Correo electrónico",
            "phone": "Teléfono",
            "name_placeholder": "Ingresa tu nombre completo",
            "email_placeholder": "Ingresa tu mejor correo electrónico",
            "phone_placeholder": "Ingresa tu teléfono",
            "access_content_btn": "Acceder al Contenido",
            "privacy_notice": "Tus datos están seguros y protegidos con nosotros",
            "not_provided": "No informado",
            "errors": {
                "name_required": "El nombre es obligatorio",
                "name_min_length": "El nombre debe tener al menos 2 caracteres",
                "email_required": "El correo electrónico es obligatorio",
                "email_invalid": "Por favor ingresa un correo electrónico válido",
                "phone_required": "El teléfono es obligatorio",
                "phone_invalid": "Por favor ingresa un número de teléfono válido",
                "plan_required": "El plan es obligatorio",
                "plan_not_found": "Plan no encontrado",
                "plan_not_available": "Este plan no está disponible para captura de leads",
                "lead_config_not_found": "Configuración de leads no encontrada para este plan",
                "at_least_one_field_required": "Por favor completa al menos un campo para continuar",
                "validation_failed": "Por favor verifica la información proporcionada",
                "submission_failed": "Error al procesar tus datos. Inténtalo de nuevo",
                "list_failed": "Error al cargar la lista de leads"
            },
            "success": {
                "captured": "¡Datos guardados exitosamente! Redirigiendo..."
            }
        }
    },
    "pt-BR": {
        "common": {
            "about_course": "Sobre o curso",
            "active": "Ativo",
            "add": "Adicionar",
            "all_invoices": "Todas as faturas",
            "analyze": "Em analise",
            "and": "e",
            "anonymous": "Anônimo",
            "apply": "Aplicar",
            "at": "as",
            "attach": "Anexar",
            "attention": "Atenção!",
            "back": "Voltar",
            "billet": "Boleto",
            "blocked": "Bloqueado",
            "blog": "Blog",
            "browser_support_file": "O navegador não possui suporte a esse tipo de arquivo",
            "buy": "Comprar",
            "bind_processing": "Vinculando alunos à turma... Verifique a notificação para mais informações.",
            "bind_partial": "Alguns alunos não foram vinculados!",
            "bind_complete": "Todos os alunos foram vinculados com sucesso!",
            "bind_failure": "Erro ao vincular alunos à turma!",
            "unbinding_in_progress": "Desvinculando alunos da turma... Verifique a notificação para mais informações.",
            "unbinding_successfull": "Alunos desvinculados com sucesso!",
            "unbinding_failure": "Erro ao desvincular alunos da turma!",
            "bind_plan_processing": "Vinculando plano à turma... Por favor, aguarde alguns instantes.",
            "bind_plan_complete": "Plano vinculado à turma com sucesso!",
            "bind_plan_partial": "Alguns alunos não foram vinculados!",
            "bind_plan_failure": "Erro ao vincular plano à turma!",
            "cancel": "Cancelar",
            "canceled": "Cancelado",
            "cart": "Carrinho",
            "chat": "Chat",
            "close": "Fechar",
            "config": "Configurações",
            "confirm": "Confirmar",
            "confirm_action": "Confirmar ação?",
            "contact": "Contato",
            "content": "Conteúdo",
            "continue": "Continuar",
            "course": "Curso",
            "courses": "Cursos",
            "create": "Criar",
            "created_success": "Criado com sucesso",
            "credit_card": "Cartão de Crédito",
            "dashboard": "Painel",
            "days": "dias",
            "debit_card": "Cartão de Débito",
            "description": "Descrição",
            "details": "Detalhes",
            "document": "Documento",
            "document_type": "Tipo de documento",
            "download_file": "Baixar arquivo",
            "due": "Vencimento",
            "due_invoices": "Faturas a vencer",
            "duration": "Duração",
            "edit": "Editar",
            "error": "Ocorreu um erro",
            "email": "E-mail",
            "empty_alert": "Existem questões não respondidas",
            "empty_exercises": "Você não respondeu a todas as perguntas, deseja mesmo continuar?",
            "empty_survey": "Não há enquetes no momento",
            "exercise": "Exercício",
            "exercises": "Exercícios",
            "expand": "Expandir",
            "expired": "Vencido",
            "final_content": "Conteúdo final",
            "final_grade": "Nota",
            "financial": "Financeiro",
            "forum": "Fórum",
            "free": "Gratuito",
            "generate_invoice": "Gerar Fatura",
            "geolocation_block": "Localização não permitida",
            "geolocation_permission": "Ative a geolocalização do navegador para realizar login",
            "geolocation_unsupported": "Este navegador não possui suporte a geolocalização",
            "inactive": "Inativo",
            "information": "Informações",
            "installments": "Parcelas",
            "invalid_format": "Formato inválido",
            "invoices": "Visualizar faturas",
            "issue_date": "Data da compra",
            "justify_answer": "Justifique sua resposta",
            "lesson": "Aula",
            "lessons": "Aulas",
            "listing": "Listagem",
            "load_more_content": "Carregar mais conteúdo",
            "location": {
                "addresses": "Endereços",
                "address": "Endereço",
                "city": "Cidade",
                "number": "Número",
                "neighborhood": "Bairro",
                "state": "Estado",
                "zip_code": "CEP",
                "info": "Complemento"
            },
            "gamification": "Gamificação",
            "module": "Módulo",
            "modules": "Módulos",
            "my_plans": "Meus planos",
            "name": "Nome",
            "new": "Novo",
            "no_forum": "Nenhum fórum encontrado",
            "notifications": "Notificações",
            "of": "de",
            "open": "Abrir",
            "overview": "Visão Geral",
            "paid": "Pago",
            "paid_date": "Data do pagamento",
            "paid_invoices": "Faturas pagas",
            "paid_value": "Valor pago",
            "password": "Senha",
            "payment_error": "Falha ao finalizar compra! Não foi possível processar a transação, reveja os dados informados e tente novamente.",
            "payment_method": "Método de pagamento",
            "plan": "Plano",
            "plans": "Planos",
            "print_billet": "Imprimir boleto",
            "processing": "Processando",
            "products": "Produtos",
            "profile": "Perfil",
            "public": "Público",
            "receipt": "Comprovante",
            "recurrence": "Faturamento",
            "register": "Cadastre-se",
            "remove": "Remover",
            "required_field": "Campo obrigatório",
            "response": {
                "success": "Enviado com sucesso",
                "error": "Houve algum erro, tente novamente."
            },
            "results": "Resultado",
            "save": "Salvar",
            "saved": "Salvo",
            "search": "Pesquisar",
            "see_less": "Ver menos",
            "select_one": "Selecione ao menos uma opção",
            "send": "Enviar",
            "showing": "Mostrando",
            "start": "Iniciar",
            "status": "Status",
            "store": "Planos",
            "support_material": "Material de apoio",
            "tickets": "Tickets",
            "title": "Título",
            "to": "a",
            "to_due": "A vencer",
            "topics": "Enquetes",
            "type_search": "Digite para pesquisar o país",
            "try_again": "Tentar novamente",
            "unavailable": "Indisponível",
            "unique_invoice": "Fatura única",
            "upload_error": "Não foi possível enviar o arquivo",
            "value": "Valor",
            "views": "Visualizações",
            "zip_error": "Não foi possível carregar as informações do CEP.",
            "zip_not_found": "Não foi encontrado um endereço com esse CEP.",
            "loading": "Carregando...",
            "error_accessing_content": "Erro ao acessar o conteúdo."
        },
        "order": {
            "order": "Pagamento",
            "thanks": "Muito Obrigado por ter adquirido nosso conteúdo!",
            "info": "Informações do Pagamento",
            "recurrence_question": "Deseja vincular esta recorrência a um metodo de pagamento?",
            "value": "Valor Total do pagamento",
            "yes_link": "Sim, Desejo Vincular",
            "no_link": "Não",
            "go_to_dashboard": "Ir para dashboard",
            "link_recurrence": "Vincular pagamento recorrente do conteúdo",
            "status": {
                "success": "Muito Obrigado por ter adquirido nosso conteúdo!",
                "to_pay": "O pedido de pagamento foi realizado, aguarde o processamento.",
                "beaten": "Não foi possível realizar a operação. Entre em contato com o suporte.",
                "canceled": "Não foi possível realizar a operação. Tente novamente mais tarde ou entre em contato com o suporte.",
                "processing": "A transação está sendo processada.",
                "waiting": "A transação está aguardando liberação do departamento financeiro"
            }
        },
        "notification": {
            "title": "Notificações",
            "all": "Todas notificações"
        },
        "billing": {
            "billing": "Faturamento",
            "invoice": {
                "created_at": "Data de criação da fatura",
                "buy_again": "Comprar novamente",
                "hash": "Número da Fatura",
                "descrition": "Descrição da Fatura",
                "invoice": "Fatura",
                "invoices": "Faturas",
                "show": "Exibir fatura",
                "pay": "Pagar Fatura",
                "duplicate": {
                    "title": "Segunda Via",
                    "generate": "Gerar Segunda Via"
                },
                "total": "Valor final da fatura",
                "fee": "Multa",
                "interest": "Juros",
                "payed": "Esta fatura ja foi paga",
                "processing": "Processando pagamento",
                "expiry": "Data de Vencimento da fatura",
                "expiry_duplicate": "Data de Vencimento Segunda Via",
                "goto_payment": "Ir para pagamento",
                "canceled": "Fatura foi cancelada",
                "interest_per_days": "ao dia após vencimento da primeira fatura",
                "billet": {
                    "show": "Exibir boleto",
                    "expirated": "Fatura expirada"
                },
                "status": {
                    "title": "Situação",
                    "paid": "Paga",
                    "pending": "Pendente",
                    "canceled": "Cancelada",
                    "processing": "Processando",
                    "expired": "Expirada"
                }
            },
            "recurrence": {
                "status": "Situação",
                "recurrence": "Recorrência",
                "subscription": "Assinatura",
                "invoices": "Faturas da Recorrência",
                "hash": "Número da Recorrência",
                "description": "Descrição da Recorrência",
                "due": "Próximo Vencimento",
                "view": "Visualizar Recorrência",
                "payment_type": "Forma de Pagamento Vinculado",
                "info": "Informações da Recorrência",
                "name": "Nome da Recorrência",
                "plan": "Plano da Recorrência",
                "value": "Valor da Recorrência",
                "cicle": "Ciclos",
                "linked_payment": "Esta recorrência esta vinculada com método de pagamento ",
                "no_linked_payment": "Esta recorrência não esta vinculada com nenhum método de pagamento",
                "link_payment": "Vincular Método de Pagamento",
                "unlink_payment": "Desvincular Método de Pagamento",
                "null_recurring_payment": "Nenhum meio de pagamento vinculado",
                "no_payment_available": "No momento não há nenhuma plataforma de pagamentos disponível para habilitar a recorrência selecionada.",
                "status_codes": [
                    "Desativada",
                    "Ativada",
                    "Cancelada",
                    "Processando"
                ]
            }
        },
        "glossary": {
            "title": "Glossário",
            "subtitle": "Consulte os termos e conceitos dos seus cursos.",
            "search": "Pesquisar termo",
            "all": "Todos",
            "category": "Categoria",
            "all_categories": "Todas as categorias",
            "course": "Curso",
            "general": "Glossário geral",
            "empty": "Nenhum termo encontrado.",
            "examples": "Exemplos de utilização",
            "synonyms": "Sinônimos",
            "related": "Veja também",
            "back": "Voltar ao glossário",
            "disabled": "O glossário não está disponível nesta plataforma.",
            "not_found": "Termo não encontrado.",
            "preview_notice": "Visão do aluno: é assim que os alunos veem o glossário.",
            "menu": "Glossário"
        },
        "tags": {
            "id": "Código",
            "year": "Ano",
            "month": "Mês",
            "next": "Próximo",
            "previous": "Voltar"
        },
        "certificate": {
            "title": "Certificado",
            "description": "Certificado de conclusão, clique no trofeu para obter o certificado",
            "print": "Imprimir",
            "download": "Baixar",
            "validate": "Link para validar o Certificado",
            "code": "Digite o códito do certificado para validar",
            "validate_button": "Validar",
            "success": "Esse certificado é válido, confira abaixo",
            "error": "por favor digite um código de certificado valido",
            "validate_description": "Validar Certificado",
            "progress": "Você atingiu {studentProgress}% de aproveitamento, porém para ter direito ao certificado é necessário atingir {certificateProgress}% de aproveitamento",
            "state": {
                "valid": "Certificado válido",
                "expired": "Certificado expirado",
                "not_found": "Certificado não encontrado",
                "disabled": "Validação pública desligada para este certificado",
                "valid_text": "Este certificado foi emitido pela plataforma e é autêntico.",
                "expired_text": "Este certificado existe, mas a data de validade já passou.",
                "not_found_text": "Não encontramos nenhum certificado com este código. Confira o código e tente de novo.",
                "disabled_text": "O responsável pelo certificado não liberou a validação pública."
            },
            "summary": {
                "student": "Aluno",
                "content": "Conteúdo",
                "emitted_at": "Emitido em",
                "valid_until": "Válido até",
                "code": "Código"
            },
            "validate_at": "Valide em"
        },
        "captcha": {
            "title": "Erro na verificação do captcha!",
            "none": "Captcha não criado ainda.",
            "image": "A imagem selecionada está incorreta.",
            "audio": "A letra ou número está incorreta(o).",
            "incomplete": "Você deve completar o captcha.",
            "wait": "Excesso de tentativas, aguarde ",
            "frontend": {
                "accessibilityAlt": "Ícone de Som",
                "accessibilityTitle": "Opção de Acessibilidade: ouça uma questão e responda à mesma!",
                "accessibilityDescription": "Escreva em baixo a <strong>resposta</strong> ao que ouve. Números ou palavras:",
                "explanation": "Clique ou toque no/a <strong>ANSWER</strong>",
                "refreshAlt": "Ícone de recarregar",
                "refreshTitle": "Recarregar: obtenha novas imagens e opção de acessibilidade!"
            },
            "images": {
                "Airplane": "Avião",
                "Balloons": "Balões",
                "Camera": "Camera",
                "Car": "Carro",
                "Cat": "Gato",
                "Chair": "Cadeira",
                "Clip": "Clipe",
                "Clock": "Relógio",
                "Cloud": "Nuvem",
                "Computer": "Computador",
                "Envelope": "Envelope",
                "Eye": "Olho",
                "Flag": "Bandeira",
                "Folder": "Pasta",
                "Foot": "Pé",
                "Graph": "Gráfico",
                "House": "Casa",
                "Key": "Chave",
                "Leaf": "Folha",
                "Light Bulb": "Lâmpada",
                "Lock": "Cadeado",
                "Magnifying Glass": "Lupa",
                "Man": "Homem",
                "Music Note": "Nota musical",
                "Pants": "Calça",
                "Pencil": "Lapis",
                "Printer": "Impressora",
                "Robot": "Robô",
                "Scissors": "Tesoura",
                "Sunglasses": "Óculos",
                "Tag": "Etiqueta",
                "Tree": "Árvore",
                "Truck": "Caminhão",
                "T-Shirt": "Camisa",
                "Umbrella": "Guarda-Chuva",
                "Woman": "Mulher",
                "World": "Planeta"
            }
        },
        "lesson": {
            "tabs": {
                "overview": "Visão geral",
                "polls": "Enquete",
                "forum": "Fórum"
            },
            "live": {
                "unavailable": "Aula ao vivo não disponível",
                "start_at": "Inicio"
            },
            "conference": {
                "unavailable": "Videoconferência não disponível",
                "start_at": "Inicio",
                "waiting_teacher": "Aguardando professor",
                "teacher_not_started": "A transmissão ainda não foi iniciada."
            },
            "scorm": {
                "no_entry_sco": "Pacote SCORM não possui SCO de entrada.",
                "init_error": "Erro ao iniciar sessão SCORM."
            },
            "answer_placeholder": "Escreva sua resposta",
            "finish_exercise": "Finalizar exercício",
            "redo": "Refazer",
            "upload_empty": "O campo de upload não pode ficar em branco",
            "answer_download": "Download resposta",
            "exercise_waiting": "Exercício aguardando correção.",
            "exercise_revised": "Exercício corrigido.",
            "obs": "Observação do corretor:",
            "revised_by": "Corrigido por:",
            "approved": "Exercício aprovado",
            "reproved": "Exercício reprovado",
            "conference_lesson": "Aula: Você poderá participar apenas como ouvinte",
            "conference_discussion": "Debate: você poderá interagir, selecione a camera e o microfone",
            "corrected_on": "Corrigido em",
            "publish": {
                "schedule": "Essa aula será liberado entre as datas: ",
                "schedule_end": "Essa aula finalizou na data: "
            }
        },
        "profile": {
            "secondary": {
                "title": "Login Secundário",
                "created": "Login Secundário Criado",
                "deleted": "Login Secundário Deletado",
                "create": "Criar Login Secundário",
                "delete": "Excluir Login Secundário",
                "warning": "Após a exclusão o email perderá completamente a associação com sua conta!",
                "new_secondary": "Criar novo usuário",
                "new_secondary_over_limit": "Limite de usuários secundários atingido"
            },
            "info": "Informações do Perfil",
            "owner": "Login Principal",
            "photo": "Foto do Perfil",
            "additional_info": "Informações adicionais",
            "document_not_unique": "Já existe um assinante com o documento cadastrado",
            "delete_account": "Apagar conta",
            "delete_warning": "TODOS os seus dados pessoais, cursos adquiridos, progresso em aulas,\n    exercícios realizados, certificados, entre outros serão removidos da plataforma e",
            "recover_warning": "NÃO PODERÃO SER RECUPERADOS.",
            "want_continue": " Deseja continuar?"
        },
        "financial": {
            "sales_limit_exceeded": "Limite de vendas excedido.",
            "create_coupon": "Criar cupom",
            "create_plan": "Criar plano",
            "invoices": {
                "attachment_success": "Comprovante salvo com sucesso",
                "attachment_failed": "Falha ao salvar o comprovante",
                "status": {
                    "paid": "Paga",
                    "open": "Aberta",
                    "overdue": "Atrasada",
                    "past_due": "Vencida",
                    "pending": "Processando",
                    "analyzing": "Em análise",
                    "canceled": "Cancelada",
                    "deleted": "Deletada"
                }
            },
            "deposit": {
                "title": "Dados para o depósito",
                "button": "Enviar comprovante"
            },
            "recurrences": {
                "subscription": "Assinatura",
                "access_until": "Acesso por",
                "monthly": "Mensal",
                "bimonthly": "Bimestral",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "month": "1 mês",
                "year": "1 ano",
                "months": "{months} meses",
                "years": "{years} anos",
                "cycles": {
                    "cycles": "Ciclos",
                    "infinite": "Infinito",
                    "infinite_description": "A recorrência será gerada por um tempo indeterminado, ou até a aluno cancelar o plano",
                    "custom": "Customizado",
                    "custom_description": "A recorrência será gerada por um tempo determinado, podendo ser no máximo 20 vezes",
                    "month": "1 mês",
                    "year": "1 ano",
                    "months": "{months} meses",
                    "years": "{years} anos",
                    "days": "{days} dias"
                }
            },
            "stripe": {
                "redirecting": "Estamos gerando seu cadastro, Aguarde..."
            }
        },
        "pdf": {
            "invoice_generated": "Fatura Gerada",
            "invoice_number": "N° Fatura",
            "issue_date": "Emissão",
            "due_date": "Vencimento",
            "plan_name": "Plano",
            "items": "Itens",
            "value": "Valor",
            "total": "Total",
            "status": "Status",
            "invoice_status": {
                "paid": "Pago",
                "to_pay": "A Pagar",
                "past_due": "Vencida",
                "canceled": "Cancelada",
                "processing": "Processando",
                "in_analysis": "Em Análise"
            }
        },
        "topic": {
            "topic_title": "Título do tópico",
            "post": "Postar",
            "title": "título",
            "await": "Aguardando aprovação",
            "question": "conteúdo tópico",
            "new_moderated": "Esse fórum é moderado pelo adiministrador, seu tópico aparecerá na listagem quando for aprovado.",
            "needs_login": "Realize login ou crie uma conta para interagir no tópico"
        },
        "students": {
            "field_exits": "Já existe um aluno com o valor \"{value}\" no campo {name}",
            "plan": {
                "remove": " Atenção! Ao remover um plano associado a conta de um aluno(a) levará a perda do registro de progresso nos relatórios. Caso este plano possua uma recorrência associada será necessário removê-la manualmente. Deseja prosseguir com a exclusão do plano deste aluno(a)?",
                "change_status": "Atenção! Ao realizar esta ação, será atualizado o status do plano para o aluno(a). Se a \"Situação\" do plano for atualizado para \"Ativado\" irá desbloquear o acesso para o aluno e se for atualizado para \"Desativado\" irá bloquear o acesso para o aluno. Caso este plano possua uma recorrência associada deverá ser mudado o seu \"Status\" manualmente. Deseja prosseguir com a alteração de status do plano deste aluno(a)?"
            }
        },
        "gamification": {
            "gamification_status": "Status da gamificação",
            "gamification_my_points": "Minha Pontuação",
            "gamification_points": "Pontos",
            "gamification_content_without_progress": "Nenhum progresso foi realizado nesse plano",
            "gamification_ranking": "Ranqueamento Geral",
            "gamification_without_ranking": "Ninguém pontuou na plataforma",
            "gamification_show_hole_progress": "Exibir todo o progresso",
            "gamification_plan_name": "Nome do Plano: {plan}",
            "gamification_total_points": "Pontuação total: {points}",
            "gamification_content_name": "Nome do Conteúdo",
            "gamification_finish_date": "Data de Conclusão",
            "gamification_score": "Pontuação",
            "course_title": "Curso",
            "course_rule": "Regra do Curso",
            "course_rule_goal": "Meta do Curso",
            "course_rule_points": "Pontos do Curso",
            "module_title": "Módulo",
            "module_rule": "Regra do Módulo",
            "module_rule_goal": "Meta do Módulo",
            "module_rule_points": "Pontos do Módulo",
            "lesson_title": "Aula",
            "lesson_rule": "Regra da Aula",
            "lesson_rule_goal": "Meta da Aula",
            "lesson_rule_points": "Pontos da Aula",
            "exercise_title": "Exercício",
            "exercise_rule": "Regra do Exercício",
            "exercise_rule_goal": "Meta do Exercício",
            "exercise_rule_points": "Pontos do Exercício",
            "survey_title": "Enquete",
            "survey_rule": "Regra da Enquete",
            "survey_rule_goal": "Meta da Enquete",
            "survey_rule_points": "Pontos da Enquete",
            "certificate_title": "Certificado",
            "certificate_rule": "Regra do Certificado",
            "certificate_rule_goal": "Meta do Certificado",
            "certificate_rule_points": "Pontos do Certificado",
            "attendance_title": "Presença",
            "attendance_rule": "Regra da Presença",
            "attendance_rule_goal": "Meta da Presença",
            "attendance_rule_points": "Pontos da Presença"
        },
        "notification_templates": {
            "APP_TICKET_CREATED": {
                "name": "Novo Ticket Criado",
                "body": "O administrador [[$user_name]] criou o ticket #[[$ticket_id]]."
            },
            "APP_TICKET_REPLY": {
                "name": "Ticket Respondido",
                "body": "Nova resposta do administrador [[$user_name]] no ticket #[[$ticket_id]]."
            },
            "APP_TOPIC_REPLY": {
                "name": "Nova Resposta no Tópico do Fórum",
                "body": "Nova resposta do tópico [[$topic_name]] no fórum do conteúdo [[$content_name]]."
            },
            "APP_TOPIC_REPLY_APPROVED": {
                "name": "Resposta Aprovada no Tópico do Fórum",
                "body": "Sua resposta no tópico [[$topic_name]] do conteúdo [[$content_name]] foi aprovada."
            },
            "APP_INVOICE_PAID": {
                "name": "Fatura Paga",
                "body": "Pagamento da fatura #[[$invoice_id]] no valor de [[$invoice_value]] referente ao plano [[$plan_name]] aprovado com sucesso."
            },
            "APP_INVOICE_DUE_DATE": {
                "name": "Fatura Vencida",
                "body": "Detectamos que a fatura #[[$invoice_id]] no valor de [[$invoice_value]], venceu na data [[$invoice_due_date]] clique para mais informações."
            },
            "APP_CORRECTED_EXERCISE": {
                "name": "Exercício Corrigido",
                "body": "O exercício [[$exercise_name]] foi [[$exercise_approve]], confira sua nota."
            },
            "APP_NEW_EXERCISE": {
                "name": "Novo Exercício",
                "body": "O exercício [[$exercise_name]] foi adicionado a um conteúdo do plano [[$plan_name]]."
            },
            "APP_SUSPENDED_PLAN": {
                "name": "Plano Suspenso",
                "body": "O plano [[$plan_name]] foi suspenso devido a pagamentos pendentes. Clique para mais informações."
            },
            "APP_NEW_MODULE": {
                "name": "Novo Módulo",
                "body": "O modulo [[$module_name]] foi adicionado ao curso [[$course_name]] do plano [[$plan_name]]."
            },
            "APP_NEW_LESSON": {
                "name": "Nova Aula",
                "body": "A aula [[$lesson_name]] foi adicionada a um conteúdo do plano [[$plan_name]]."
            }
        },
        "exercise": {
            "time": {
                "title": "Exercício com tempo limite para resposta",
                "description": "Após iniciar o exercício o envio deve acontecer até esgotar o tempo limite, caso contrário o envio será automático",
                "rules": "Depois de iniciado o timer não irá parar mesmo se a página for recarregada ou ocorrer uma mudança de conteúdo",
                "remaining": "Tempo restante",
                "limit": "Exercício com tempo limite"
            },
            "validate": {
                "check_error": "Marque alguma alternativa",
                "some_question_no_anwser": "Responda todas as questões"
            },
            "publish": {
                "schedule": "Esse exercício será liberado entre as datas: ",
                "schedule_end": "Esse exercício finalizou na data: "
            }
        },
        "login": {
            "signin": "Entrar",
            "signout": "Sair",
            "register": "Criar Conta",
            "new_account": "Criar uma nova conta",
            "continue": "Continuar",
            "continue_user": "Continuar como",
            "name": "Nome",
            "email": "Email",
            "email_confirmation": "Confirme o Email",
            "email_reset": "Redefinir Email",
            "email_change": "Alterar Email",
            "domain_invalid": "Domínio de e-mail incompatível para a categoria selecionada",
            "document": "Documento",
            "document_type": "Tipo de Documento",
            "login_type": "Forma de login",
            "remember": "Lembrar Login",
            "disconnect_users": "Desconectar dispositivos",
            "device_limit_hint": "Limite de dispositivos conectados atingido. Você pode desconectar os outros dispositivos e continuar neste.",
            "disconnect_and_signin": "Desconectar outros dispositivos e entrar",
            "validation": {
                "email": "Email é obrigatório",
                "password": "Password é obrigatório"
            },
            "messages": {
                "update_password": "Atualize sua senha para continuar",
                "success": "Login realizado com sucesso",
                "error": "Credenciais inválidas"
            },
            "recovery": {
                "success": "Você receberá um e-mail com o link para redefinir sua senha",
                "error": "E-mail não encontrado"
            },
            "password": {
                "title": "Senha",
                "confirm": "Confirme a senha",
                "change": {
                    "title": "Alterar Senha",
                    "success": "Senha Alterada!",
                    "error": "Erro ao alterar a senha"
                },
                "forgot": "Esqueceu a senha?",
                "reset": "Redefinir a senha"
            },
            "account_created": "Conta criada com sucesso! Redirecionando...",
            "email_already_exists": "Email já possui uma conta registrada",
            "document_type_required": "Documento é obrigatório",
            "subscribe_message": "Crie sua conta para ter acesso a ",
            "has_account": "Já possui uma conta?",
            "access_here": "Acesse aqui."
        },
        "chat": {
            "you_are_banned": "Você foi banido desse chat, consulte o administrador para mais informações",
            "you_are_accept": "Sua interação com o chat foi concedida",
            "cannot_approve": "Vocẽ não possui permissão para aprovar mensagens do chat",
            "cannot_ban": "Você não possui permissão para banir um usuário",
            "send_placeholder": "Digite sua menssagem...",
            "message_waiting": "Mensagem enviada. Aguarde a moderação.",
            "pending": "Aguardando aprovação",
            "message_sent_error": "Erro ao enviar mensagem",
            "end": "Chat encerrado",
            "needs_login": "Realize login ou crie uma conta para interagir no chat"
        },
        "wiki": {
            "my_wikis": "Minhas wikis",
            "title": "Wiki",
            "subtitle": "Construa o conteúdo junto com a turma.",
            "empty": "Você ainda não participa de nenhuma wiki.",
            "course": "Curso",
            "classroom": "Turma",
            "relation": {
                "general": "Geral",
                "plan": "Plano: {name}",
                "course": "Curso: {name}"
            },
            "open": "Abrir wiki",
            "status": {
                "not_started": "Abre em {date}",
                "editing": "Em edição",
                "closed": "Encerrada"
            },
            "deadline": {
                "ends_in": "Vence em {days} dia|Vence em {days} dias",
                "ends_today": "Vence hoje",
                "over": "Prazo encerrado",
                "none": "Sem prazo",
                "not_started": "Abre em {date}"
            },
            "closed_notice": "A edição desta wiki foi encerrada. Você ainda pode ler e consultar o histórico.",
            "not_started_notice": "Esta wiki abre para edição em {date} às {time}. Até lá, você pode ler o conteúdo.",
            "read_more": "Ler descrição completa",
            "read_less": "Recolher descrição",
            "participants": "participantes",
            "contributions": "contribuições",
            "last_update": "Última atualização",
            "today_at": "hoje às {time}",
            "yesterday": "ontem",
            "pages": "Páginas",
            "search_page": "Buscar página",
            "new_page": "Nova página",
            "new_page_title": "Título da página",
            "parent_page": "Página-mãe (opcional)",
            "no_parent": "Sem página-mãe",
            "create": "Criar página",
            "cancel": "Cancelar",
            "page_created": "Página criada.",
            "page_locked": "Página bloqueada pelo professor.",
            "locked_short": "Bloqueada",
            "no_pages": "Nenhuma página ainda.",
            "no_results": "Nenhuma página encontrada.",
            "select_page": "Escolha uma página para ler.",
            "tabs": {
                "read": "Ler",
                "edit": "Editar",
                "history": "Histórico",
                "discussion": "Discussão"
            },
            "last_edit": "Última edição: {user}, {date}",
            "editor": {
                "bold": "Negrito",
                "italic": "Itálico",
                "heading": "Título",
                "list": "Lista",
                "table": "Tabela",
                "link": "Link",
                "link_url": "Endereço do link",
                "insert": "Inserir",
                "summary": "Resumo da alteração (opcional)",
                "summary_placeholder": "Descreva o que você alterou.",
                "save": "Salvar alteração",
                "being_edited": "{user} está editando esta página…",
                "cannot_edit": "Você não pode editar esta página.",
                "conflict_title": "A página foi alterada por outra pessoa",
                "conflict_text": "Seu texto foi mantido abaixo. Compare com a versão atual e salve de novo quando ajustar.",
                "conflict_mine": "Meu rascunho",
                "conflict_theirs": "Versão atual",
                "use_current": "Descartar meu rascunho e carregar a versão atual",
                "keep_mine": "Continuar com meu rascunho",
                "unsaved": "Você tem alterações não salvas nesta página. Sair sem salvar?"
            },
            "files": {
                "send": "Enviar arquivo",
                "hint": "Imagens aparecem no texto; PDF, PPTX, DOCX, XLSX aparecem como arquivo para baixar. Até 25 MB.",
                "sent": "Arquivo enviado.",
                "invalid": "Arquivo não permitido. Envie PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX ou XLSX de até 25 MB.",
                "uploading": "Enviando…",
                "remove": "Remover",
                "removed": "Arquivo removido."
            },
            "file_download": "Baixar",
            "history": {
                "version": "Versão {number}",
                "by": "por {user}",
                "view": "Ver versão",
                "back": "Voltar ao histórico",
                "current": "Atual",
                "empty": "Sem versões.",
                "teacher_only": "Restaurar versões é tarefa do professor."
            },
            "discussion": {
                "title": "Discussão",
                "type": "Tipo",
                "types": {
                    "question": "Pergunta",
                    "suggestion": "Sugestão",
                    "justification": "Justificativa",
                    "debate": "Debate"
                },
                "write": "Escreva seu comentário",
                "publish": "Publicar",
                "reply": "Responder",
                "replying_to": "Respondendo a {user}",
                "empty": "Nenhum comentário ainda. Comece a discussão.",
                "teacher": "PROFESSOR",
                "closed": "A discussão desta wiki está encerrada. Você pode ler os comentários, mas não publicar."
            },
            "feed": {
                "title": "Últimas alterações",
                "created": "criou a página {page}",
                "edited": "{summary} em {page}",
                "commented": "comentou em {page}",
                "empty": "Nenhuma alteração ainda."
            },
            "version_created": "Página criada",
            "version_edited": "Alteração",
            "version_restored": "Versão {number} restaurada",
            "version_teacher": "Alteração do professor",
            "cannot_create": "Você não pode criar páginas nesta wiki.",
            "cannot_edit": "Você não pode editar esta página.",
            "conflict": "A página foi alterada por outra pessoa enquanto você editava.",
            "saved": "Alteração salva.",
            "comment_published": "Comentário publicado.",
            "error": "Não foi possível concluir. Tente de novo."
        },
        "emails": {
            "verify": {
                "send_link": "Link Enviado",
                "send_obs": "Para ativar sua conta, acesse o e-mail cadastrado e confirme seus dados",
                "if_not_received_link": "Caso não tenha recebido o e-mail",
                "click_here_another_send": "click aqui",
                "expired_link": "Link expirado",
                "expired_obs": "Esse link esta indisponível. Acesse sua conta na plataforma de cursos online para enviar um novo link de confirmação",
                "access_account": "Click aqui para acessar sua conta",
                "activated_account": "Conta ativada com sucesso",
                "link_another_send": "Link enviado novamente",
                "fail_link_another_send": "Falha ao reenviar o link",
                "little_missing": "Falta pouco",
                "link_sent": "Enviamos um link de confirmação para o e-mail cadastrado. Para ativar sua conta, acesse o e-mail e confirme seus dados",
                "click_another_send": "Clique aqui para reenviar o link de confirmação"
            }
        },
        "empty": {
            "unique_invoice_title": "Sem faturas para mostrar",
            "unique_invoice_subtitle": "Aqui aparecerão todas suas faturas únicas.",
            "recurrence_title": "Sem recorrências para mostrar",
            "recurrence_subtitle": "Aqui aparecerão todas suas recorrências.",
            "filter_title": "Sua busca não retornou nenhum resultado",
            "filter_subtitle": "Tente novamente com novos parâmetros",
            "topic_title": "Nenhum tópico encontrado"
        },
        "auth": {
            "failed": "Credenciais inválidas",
            "device": "Limite de dispositivos conectado com esta conta atingido",
            "userselect": "Selecione seu usuário para continuar",
            "terms_accept": "É preciso aceitar os termos de uso antes de continuar",
            "deactivated": "Aluno está suspenso da plataforma!"
        },
        "form": {
            "address": {
                "country": "País",
                "state": "Estado",
                "city": "Cidade",
                "address": "Endereço",
                "number": "Número",
                "neighborhood": "Bairro",
                "info": "Complemento",
                "cep": "CEP",
                "invalid_zip": "CEP inválido",
                "fill_zip": "Preencha o campo CEP"
            },
            "select_option": "Selecione uma opção"
        },
        "content": {
            "course_content": "Conteúdo do curso",
            "lesson_content": "Conteúdo da Aula",
            "description": "Descrição",
            "download_content": "Conteúdo para download",
            "lock": {
                "PLAN_EXPIRED": "Esse plano expirou",
                "PLAN_UNAVAILABLE": "Plano indisponível",
                "SCHEDULE": "Conteúdo agendado {details}",
                "SCHEDULE_SALE": "Liberado após {details}",
                "PROGRESS": "Progresso mínimo {details} não atingido",
                "GRADE": "Nota mínima {details} não atingida",
                "AVAILABLE": "Conteúdo disponível",
                "UNAVAILABLE": "Conteúdo indisponível",
                "VIEWS_LIMIT": "Limite de visualizações atingido",
                "WAITING_AUTHORIZATION": "Aguardando autorização",
                "WAITING_EXTERNAL_STATUS": "Matrícula não confirmada",
                "NOT_FREE_AFTER_CONTENT": "É necessário esperar {details} dias até liberar esta aula ou desbloquear o conteúdo anterior."
            },
            "uploads": {
                "url": "Url",
                "open_link": "Abrir Arquivo",
                "upload": "Upload",
                "title": "Uploads",
                "create": "Enviar Arquivos",
                "edit": "Editar arquivo",
                "files": "Arquivos",
                "file": "Arquivo",
                "various_files": "Arquivos diversos",
                "unsupported_preview": "Pré-visualização não disponível",
                "name": "Nome",
                "clear_list": "Limpar fila",
                "description": "Descrição",
                "send_file": "Enviar arquivo",
                "send_image": "Enviar imagem",
                "send_media": "Enviar arquivos",
                "message": "Arraste e solte aqui seu arquivo",
                "info": "Ou",
                "remove": "Remover arquivo",
                "cancel": "Cancelar envio",
                "confirm": "Tem certeza que deseja cancelar o envio?",
                "unsupported": "O seu navegador não suporta o envio arrastando o arquivo",
                "fallback": "Porfavor utilize o formulário para enviar o arquivo",
                "type": "Não é possivel enviar arquivos com esse formato",
                "exceeded": "Envie no máximo",
                "once": "por vez",
                "error": "Falha ao enviar arquivo.",
                "canceled": "Envio cancelado",
                "validate": "Selecione um arquivo",
                "created_at": "Data de Envio",
                "sent": "Enviado",
                "size": "Tamanho",
                "change": "Enviar Arquivo",
                "attachment": "Anexo",
                "docs": "Documentos",
                "images": "Imagens",
                "videos": "Vídeos",
                "audios": "Áudios",
                "all": "Todos os arquivos",
                "select": "Selecionar",
                "use": "Selecionar",
                "media_gallery": "Galeria de mídias",
                "rules_failed": "Voce atingiu o limite máximo de downloads",
                "instruction": "Arraste e solte seu arquivo aqui ou clique para selecionar",
                "warning": "Não fechar a janela até que o download seja concluído",
                "max_size": "Tamanho máximo do arquivo: 10GB"
            },
            "exercise": {
                "exercise": "Exercício",
                "questions": "Questões:",
                "utilization": "Aproveitamento",
                "error": {
                    "no_connection": "Impossível conectar-se com o servidor. Por favor tente novamente mais tarde.",
                    "upload": "Erro ao enviar arquivo, verifique o tamanho e o formato do arquivo ou tente novamente mais tarde."
                }
            },
            "lesson": {
                "video": "Conteúdo em Vídeo",
                "video_n": "Vídeo",
                "upload": "Arquivo de Apoio",
                "public_lesson": "Aula Pública",
                "watch_now": "Assistir Agora"
            },
            "type": {
                "live": "Ao vivo",
                "file": "Arquivo"
            },
            "open": {
                "new_tab": "Abrir em Nova Guia"
            }
        },
        "cart": {
            "recurrence": {
                "title": "Recorrências",
                "monthly": "Mensal",
                "bimonthly": "Bimestral",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "custom": "Cobrados a cada",
                "days": "dias",
                "change_payment": "Escolha a forma de pagamento da recorrência",
                "cpf": "CPF",
                "holder_cpf": "CPF do Titular",
                "area_code": "Código de Área",
                "phone_number": "Número do telefone",
                "name": "Nome",
                "holder": "Nome",
                "card_holder": "Nome do Titular (igual ao cartão)",
                "gerencia_net": "Gerencia Net",
                "birth": "Data de Nascimento",
                "credit_card_brand": "Bandeira",
                "credit_card_number": "Número do cartão",
                "credit_card_cvv": "CVV",
                "credit_card_expiration_month": "Mês de Expiração",
                "credit_card_expiration_year": "Ano de Expiração",
                "payment_alert": "Só é permitido 1 item do tipo recorrente no carrinho se a forma de pagamento for GerenciaNet",
                "approve_text": "Aprovar a Recorrência",
                "have_recurrence": "Atenção, você ja contem algum item no seu carrinho, para adicionar um item recorrente é preciso que finalize a compra ou limpe do carrinho",
                "recurrence": "Informações adicionais para pagamento com recorrência",
                "invalid_birthdate": "Data de nascimento inválida",
                "invalid_phone_number": "Número de telefone inválido",
                "invalid_checkout": "Preencha as informações adicionais para pagamento com recorrência"
            },
            "coupon": {
                "has_coupon": "Possui um cupom de desconto?",
                "placeholder": "CÓDIGO",
                "apply": "Aplicar",
                "discount_coupon": "Cupom de desconto",
                "coupon": "Cupom",
                "add": "Aplicar um cupom de desconto"
            },
            "add_item": {
                "failed": "Falha ao adicionar item ao carrinho"
            },
            "recurrent_plan_aready_exists": "Item recorrente já adicionado ao carrinho",
            "invalid_plan_type": "Tipo de plano invalido",
            "invalid_plan_recurrence_option": "A opção de recorrência informada é inválida",
            "plan_recurrence_required": "Informe uma opção de recorrência",
            "plan_sales_limit_exceeded": "Limite de vendas atingido para esse plano",
            "plan_recurrence_option_applied": "Opção de recorrencia aplicada com sucesso!",
            "plan_reccurrence_option_failed": "Falha ao aplicar opção de recorrência",
            "plan_type_required": "O tipo do plano é obrigatorio",
            "pay": "Realizar Pagamento",
            "change_payment": "Preencha os dados de pagamento",
            "cart": "Carrinho de Compra",
            "go_to_cart": "Ir ao carrinho",
            "subscribe": "Inscrever-se",
            "add_to_cart": "Adicionar ao carrinho",
            "access_plan": "Acessar Plano",
            "plan_info": "Informações do plano",
            "payment_type": "Forma de pagamento",
            "product": "Produto",
            "price": "Preço",
            "checkout": "Pagamento",
            "type": "Período do Plano",
            "type_recurrence": "Pagamento Recorrente",
            "type_unique": "Pagamento Único",
            "discount": "Disconto",
            "total": "Total: ",
            "finish": "Finalizar",
            "empty": "O seu carrinho está vazio",
            "empty_message": " Antes de ir para o checkout você deve adicionar algum produto ao seu carrinho.",
            "empty_button": "Continuar comprando",
            "currency": "Moeda",
            "filter": "Filtrar",
            "filter_by": "Filtrar por",
            "order_by": "Ordenar por",
            "remove_failed": "Falha ao tentar remover item do carrinho",
            "admin_message": "Não foi possível realizar a compra, certifique-se de estar logado como aluno",
            "plans": {
                "types": "Tipos de Planos",
                "public": "Público",
                "free": "Grátis",
                "single_purchase": "Pagamento Único",
                "recurrence": "Recorrente",
                "value": "Valor do Plano",
                "categories": "Categorias",
                "no_category": "Sem categoria"
            },
            "min_price": "Menor Preço",
            "max_price": "Maior Preço",
            "clean_filters": "Limpar Filtros",
            "clear": "Limpar o Carrinho",
            "item_added": "Item Adicionado ao carrinho!",
            "code": "Código",
            "code_empty": "Código obrigatório",
            "free_item_add": "Inscrito com sucesso!",
            "free_item_wait": "Plano adicionado a sua conta, aguarde a autorização de sua inscrição",
            "deleted": "Item do carrinho removido com sucesso!",
            "item": {
                "added": "Item adicionado ao carrinho!",
                "removed": "Item removido do carrinho",
                "exists": "Produto já adicionado ao carrinho"
            },
            "obs": "Obs:",
            "obs_message": "O pagamento pode demorar até 72 horas para ser aprovado.",
            "billet_bank": "Para realizar o pagamento com o ",
            "billet_bank_redirect": "clique no botão abaixo e você será redirecionado para a página de impressão do boleto bancário.",
            "billet_dare": "Para realizar a emissão da guia de pagamento DARE, clique no botão abaixo e você será redirecionado para a página de impressão da guia DARE.",
            "paypal_message": "Para realizar o pagamento com o Paypal, clique no botão abaixo e você será redirecionado para o site do Paypal.",
            "stripe_message": "Para realizar o pagamento com via Checkout Stripe, clique no botão abaixo e você será redirecionado para o site do Stripe.",
            "stripe_message_no_recurrency": "Pagamentos recorrentes ainda não estão disponíveis para o Stripe. Por favor, escolha outra forma de pagamento.",
            "checkout_stripe": "Checkout Stripe",
            "payment_intent_stripe": "Stripe",
            "stripe": {
                "card_number": "Número do Cartão",
                "card_expiry": "Data de Vencimento",
                "card_cvc": "CVC",
                "card_already_registered": "Você já possui um cartão cadastrado!",
                "card_last_digits": "Final do Cartão",
                "card_brand": "Bandeira",
                "card_status": "Status",
                "remove_payment_method": "Remover Cartão",
                "payment_method": "Método de Pagamento Cadastrado ",
                "card_exp_month": "Mês de Vencimento",
                "card_exp_year": "Ano de Vencimento",
                "create_token": "Cadastrar Metodo de Pagamento",
                "update_token": "Atualizar Metodo de Pagamento"
            },
            "pagseguro_message": "Para realizar o pagamento com o PagSeguro, clique no botão abaixo e você será redirecionado para o site do PagSeguro.",
            "credit_card_message": "Para realizar o pagamento com o cartão de crédito, clique no botão abaixo e você será redirecionado para realizar o pagamento.",
            "credit_card_installments_message": "Para realizar o pagamento com o cartão de crédito, escolha o número de parcelas e clique no botão abaixo para ser redirecionado ao pagamento.",
            "credit_card_obs": "O pagamento pode demorar até 48 horas para ser aprovado.",
            "paypal_obs": "O pagamento pode demorar até 24 horas para ser aprovado.",
            "stripe_obs": "O pagamento pode demorar até 48 horas para ser aprovado.",
            "paypal": "PayPal",
            "pagseguro": "PagSeguro",
            "pagseguro_billet_message": "Para realizar o pagamento via boleto, digite o seu cpf e clique em Gerar Boleto.",
            "pagseguro_billet_generate": "Gerar Boleto",
            "pagseguro_billet_pdf": "Salvar boleto em PDF",
            "pix": "Pix",
            "pix_message": "Para realizar o pagamento via pix digite o seu cpf e clique em Gerar QR code",
            "pix_key": "Chave Pix",
            "pix_copy": "Copie e Cole:",
            "dare": "DARE",
            "credit_card": "Cartão de Crédito",
            "deposit": "Depósito Bancário",
            "deposit_message": "Para realizar o pagamento com uma transferência eletrônica de valores, clique no botão abaixo e após você será redirecionado para a página com os dados bancários e o campo de anexo do comprovante de pagamento.",
            "make_payment": "Realizar Pagamento com ",
            "finish_payment": "Obrigado pela compra!",
            "plan_activate": "Seu plano será ativado quando o pagamento for concluído",
            "date_expired": "O cartão está vencido.",
            "address": {
                "address": "Endereço",
                "insert": "Por favor, cadastre um endereço",
                "invalid": "Desculpe, não foi possivel salvar o endereço"
            },
            "checkout_errors": {
                "brand_not_identified": "Não foi possível identificar a bandeira do cartão. Confira o número digitado ou selecione a bandeira manualmente.",
                "brand_not_accepted": "A bandeira {brand} não é aceita por este meio de pagamento.",
                "pending_invoice_multiple": "Já existe uma fatura em aberto para um dos itens do carrinho. Pague a fatura em Financeiro ou remova o item para continuar.",
                "payment_reversed": "A cobrança no cartão foi cancelada automaticamente e nenhum valor será debitado.",
                "payment_not_reversed": "Não foi possível cancelar a cobrança automaticamente. Entre em contato com o suporte informando o horário da compra."
            }
        },
        "blog": {
            "share": "Compartilhar",
            "share_on": "Compartilhar no {social}",
            "copy_url": "Copiar url",
            "posts": {
                "by": "Publicado por",
                "views": "Visualizações",
                "search": "Buscar publicação",
                "latest": "Ultimas publicações",
                "no_data": "Nenhuma publicação"
            },
            "comments": {
                "title": "Comentários",
                "reply_to": "Resposta a {author}",
                "no_replies": "Nenhuma resposta",
                "show_replies": "Mostrar respostas",
                "login_comment": "Faça login e deixe seu comentário",
                "form_title": "Deixe um comentário",
                "no_data": "Nenhum comentário até o momento",
                "send": "Enviar",
                "reply": "Responder",
                "replies": "Respostas",
                "load_more": "Ver mais comentários"
            },
            "categories": {
                "title": "Categorias",
                "more": "Mostrar mais"
            },
            "tags": {
                "see_more": "Veja mais sobre:"
            }
        },
        "header": {
            "cart": {
                "empty": "Seu carrinho está vazio."
            },
            "profile": {
                "title": "Perfil",
                "logout": "Sair",
                "welcome": "Bem-vindo",
                "notifications": "Notificações",
                "cart": "Carrinho",
                "menus": "Menus"
            },
            "notifications": {
                "you_have": "Você tem",
                "notification": "notificação.",
                "notifications": "notificações.",
                "all": "Ver todas",
                "ago": "atrás",
                "marker_all_read": "Marcar todas como lidas"
            }
        },
        "class": {
            "back_to_plan": "Voltar ao plano",
            "course_content": "Conteúdo do curso",
            "forum": "Fórum",
            "hasnt_forum": "Não possui fórum",
            "description": "Descrição",
            "certificate_without_progress": "Progresso suficiente não atingido para receber certificado"
        },
        "support": {
            "submit": "Enviar Contato",
            "support_form": "Formulário de Contato",
            "label": "Assunto",
            "invalid_email": "Email inválido.",
            "sent_success": "Email de contato enviado com sucesso!",
            "title": "Suporte",
            "show_more": "Mostrar mais",
            "chat": {
                "title": "Chat",
                "search": "Pesquisa",
                "write_menssage": "Escreva uma menssagem",
                "send": "Enviar",
                "finish": "Finalizar Interações do Chat",
                "last_interaction": "Última interação",
                "interaction_finish": "Interação finalizada",
                "attendant": "Atendente",
                "send_placeholder": "Digite sua menssagem..."
            },
            "forum": "Fórum",
            "forum_answer": "Respostas",
            "forums": {
                "title": "Fórum",
                "type": "Tipo do Fórum",
                "modereted": "Moderado",
                "number_topics": "Número de Tópicos",
                "view_topics": "Ver Tópicos",
                "inactive": "Desativar Fórum",
                "active": "Ativar Fórum",
                "remove": "Remover Fórum",
                "remove_forum_warning": "Ao Remover o forum, todas os tópicos e repostas serão excluidos. Você tem certeza que deseja proceguir?",
                "topics": {
                    "title": "Tópicos",
                    "name": "Nome do Tópico",
                    "number_answers": "Número de Interações",
                    "status": "Status",
                    "user": "Usuário Criador do Tópico",
                    "created_date": "Data de Criação",
                    "answers": "Respostas",
                    "edit": "Editar Tópico",
                    "remove": "Remover Tópico",
                    "update_name": "Atualizar nome do Tópico"
                },
                "create": "Criar Fórum",
                "waiting_for_approval": "Aguardando aprovação",
                "updated_at": "Data de Atualização"
            },
            "forum_answers": {
                "view": "Ver respostas",
                "title": "Interações do Tópico",
                "reply_placeholder": "Escreva uma Resposta...",
                "topicedit_placeholder": "Alterando o texto..."
            },
            "settings": {
                "title": "Configurações do Suporte",
                "email": "E-mail",
                "labels": "Assuntos",
                "label": "Assunto",
                "add_label": "Adicionar etiqueta",
                "remove_label": "Remover etiqueta",
                "enable_ticket": "Suporte via ticket",
                "email_title": "Email",
                "ticket_title": "Ticket",
                "chat_title": "Chat",
                "enable_email": "Suporte via e-mail",
                "enable_chat": "Suporte via chat",
                "support_form": "Formulário de contato ao suporte"
            },
            "tickets": {
                "ticket": "Ticket",
                "tickets": "Tickets",
                "create": "Novo Ticket",
                "title": "Assunto",
                "search": "Busque pelo id ou título do ticket",
                "content": "Mensagem de reposta",
                "send": "Enviar",
                "plan": "Plano",
                "send_success": "Mensagem enviada com sucesso",
                "resolved": "Ticket finalizado",
                "delete_many": "Remover Ticket(s)",
                "delete": "Remover Ticket",
                "operator": "Operador",
                "change_operator": "Alterar operador",
                "student": "Assinante",
                "department": "Departamento",
                "created_at": "Criado em",
                "last_reply": "Última interação",
                "waiting_time": "{user} está aguardando resposta a {time}",
                "some": "um ticket",
                "id": "ID",
                "all": "Todos os tickets",
                "reply": "Mensagem",
                "reply_error": "Falha ao enviar resposta",
                "status": "Situação",
                "close": "Fechar Ticket",
                "situation": {
                    "OPEN": "Aberto",
                    "WAITING_STUDENT": "Aguardando Assinante",
                    "WAITING_OP": "Aguardando Operador",
                    "CLOSED": "Fechado",
                    "RESOLVED": "Resolvido",
                    "IN_PROCESS": "Em atendimento"
                },
                "number_ticket": "Nº do Ticket"
            },
            "labels": {
                "labels": "Departamentos",
                "manager": "Gerenciar departamentos",
                "find": "Digite para pesquisar departamentos"
            },
            "map": {
                "contact_info": "Informações de Contato",
                "telephone": "Telefone",
                "address": "Endereço"
            }
        },
        "documents": {
            "type": "Tipo de documento",
            "invalid": "Documento {type} inválido"
        },
        "course": {
            "tabs": {
                "wiki": "Wiki da turma",
                "glossary": "Glossário",
                "overview": "Visão geral",
                "content": "Conteúdo",
                "forum": "Fórum"
            },
            "start": "Iniciar",
            "continue": "Continuar",
            "modules": "Módulos",
            "lessons": "Aulas",
            "exercises": "Exercíos",
            "topics": "Enquete",
            "show_more": "Mostrar Mais",
            "module_no_content": "Esse módulo não possui conteúdo",
            "course_no_content": "No momento não há conteúdo disponível para visualização",
            "publish": {
                "schedule": "Esse curso será liberado entre as datas: ",
                "schedule_end": "Esse curso finalizou na data: "
            }
        },
        "module": {
            "publish": {
                "schedule": "Esse módulo será liberado entre as datas: ",
                "schedule_end": "Esse módulo finalizou na data: "
            }
        },
        "payment_erros": {
            "stripe": {
                "account_closed": "A conta bancária do cliente foi encerrada.",
                "account_country_invalid_address": "O país do endereço comercial fornecido não corresponde ao país da conta. Empresas devem estar localizadas no mesmo país da conta.",
                "account_error_country_change_requires_additional_steps": "Sua conta já foi configurada como uma plataforma Connect. Alterar seu país requer etapas adicionais. Entre em contato com o suporte da Stripe para mais informações.",
                "account_information_mismatch": "Algumas informações da conta não correspondem entre si. Por exemplo, alguns bancos podem exigir que o nome do perfil comercial corresponda ao nome do titular da conta.",
                "account_invalid": "O ID da conta fornecido como valor para o cabeçalho Stripe-Account é inválido. Verifique se suas solicitações estão especificando um ID de conta válido.",
                "account_number_invalid": "O número da conta bancária fornecido é inválido (por exemplo, dígitos faltando). As informações da conta bancária variam de país para país. Recomendamos criar validações em seus formulários de entrada com base nos formatos de conta bancária que fornecemos.",
                "acss_debit_session_incomplete": "A sessão de débito ACSS não está pronta para ser concluída ainda. Tente novamente mais tarde.",
                "alipay_upgrade_required": "Este método de criação de pagamentos Alipay não é mais suportado. Atualize sua integração para usar o Sources.",
                "amount_too_large": "O valor especificado é maior que o valor máximo permitido. Use um valor menor e tente novamente.",
                "amount_too_small": "O valor especificado é menor que o valor mínimo permitido. Use um valor maior e tente novamente.",
                "api_key_expired": "A chave API fornecida expirou. Obtenha suas chaves API atuais no Dashboard e atualize sua integração para usá-las.",
                "application_fees_not_allowed": "O movimento de dinheiro proposto não pôde ser concluído por razões regulatórias.",
                "authentication_required": "O pagamento requer autenticação para prosseguir. Você deve autenticar o pagamento ou fornecer um método de pagamento diferente.",
                "balance_insufficient": "A transferência ou pagamento não pôde ser concluído porque a conta associada não possui saldo suficiente disponível. Crie uma nova transferência ou pagamento usando um valor igual ou menor ao saldo disponível da conta.",
                "balance_invalid_parameter": "Foi fornecido um parâmetro inválido no objeto do método de saldo. Verifique nossa documentação da API ou a mensagem de erro retornada para mais contexto.",
                "bank_account_bad_routing_numbers": "A conta bancária é conhecida por não suportar a moeda em questão.",
                "bank_account_declined": "A conta bancária fornecida não pode ser usada para cobrança, ou porque ainda não foi verificada ou porque não é suportada.",
                "bank_account_exists": "A conta bancária fornecida já existe no objeto Cliente especificado. Se a conta bancária também deve ser anexada a outro cliente, inclua o ID do cliente correto ao fazer a solicitação novamente.",
                "bank_account_restricted": "A conta do cliente não pode ser usada com o método de pagamento.",
                "bank_account_unusable": "A conta bancária fornecida não pode ser usada. Uma conta bancária diferente deve ser usada.",
                "bank_account_unverified": "Sua plataforma Connect está tentando compartilhar uma conta bancária não verificada com uma conta conectada.",
                "bank_account_verification_failed": "A conta bancária não pode ser verificada, ou porque os valores dos microdepósitos fornecidos não correspondem aos valores reais, ou porque a verificação falhou muitas vezes.",
                "billing_invalid_mandate": "A assinatura ou fatura tentou o pagamento em um método de pagamento sem um mandato ativo. Para criar pagamentos de assinatura ou fatura com este método de pagamento, ele deve ser confirmado na sessão com um PaymentIntent ou SetupIntent primeiro.",
                "billing_policy_remote_function_response_invalid": "Uma resposta do endpoint da função remota de política de cobrança retornou dados inválidos.",
                "billing_policy_remote_function_timeout": "Uma função remota de política de cobrança expirou.",
                "billing_policy_remote_function_unexpected_status_code": "Uma função remota de política de cobrança retornou um código de status inválido.",
                "billing_policy_remote_function_unreachable": "Ocorreu um erro ao executar uma função remota de política de cobrança.",
                "bitcoin_upgrade_required": "Este método de criação de pagamentos Bitcoin não é mais suportado. Atualize sua integração para usar o Sources.",
                "capture_charge_authorization_expired": "A cobrança não pode ser capturada pois a autorização expirou. Consulte a documentação do método de pagamento para mais informações.",
                "capture_unauthorized_payment": "A cobrança que você está tentando capturar não foi autorizada para captura de pagamento.",
                "card_decline_rate_limit_exceeded": "Este cartão foi recusado muitas vezes. Você pode tentar cobrar este cartão novamente após 24 horas. Sugerimos entrar em contato com o cliente para garantir que ele tenha inserido todas as informações corretamente e que não haja problemas com o cartão.",
                "card_declined": "O cartão foi recusado. Verifique se todos os dados do cartão foram inseridos corretamente e se o cartão ainda não expirou.",
                "cardholder_phone_number_required": "Você deve ter um número de telefone registrado para os portadores de cartão que criarão cartões da UE. Não é possível criar cartões da UE sem um número de telefone registrado para o titular do cartão. Consulte a Documentação do 3D Secure para mais detalhes.",
                "charge_already_captured": "A cobrança que você está tentando capturar já foi capturada. Atualize a solicitação com um ID de cobrança não capturada.",
                "charge_already_refunded": "A cobrança que você está tentando reembolsar já foi reembolsada. Atualize a solicitação para usar o ID de uma cobrança que não foi reembolsada.",
                "charge_disputed": "A cobrança que você está tentando reembolsar foi contestada. Verifique a documentação de disputas para saber como responder à disputa.",
                "charge_exceeds_source_limit": "Esta cobrança faria com que você excedesse seu limite de processamento de janela contínua para este tipo de fonte. Por favor, tente novamente a cobrança mais tarde, ou entre em contato conosco para solicitar um limite de processamento mais alto.",
                "charge_expired_for_capture": "A cobrança não pode ser capturada pois a autorização expirou. As cobranças de autorização e captura devem ser capturadas dentro de um número definido de dias (7 por padrão).",
                "charge_invalid_parameter": "Um ou mais parâmetros fornecidos não foram permitidos para a operação dada na cobrança. Verifique nossa referência da API ou a mensagem de erro retornada para ver quais valores não estavam corretos para essa cobrança.",
                "charge_not_refundable": "A tentativa de reembolsar uma cobrança foi malsucedida porque a cobrança não é mais reembolsável.",
                "clearing_code_unsupported": "O código de compensação fornecido não é suportado.",
                "country_code_invalid": "O código do país fornecido era inválido.",
                "country_unsupported": "Sua plataforma tentou criar uma conta personalizada em um país que ainda não é suportado. Verifique se os usuários só podem se inscrever em países suportados por contas personalizadas.",
                "coupon_expired": "O cupom fornecido para uma assinatura ou pedido expirou. Crie um novo cupom ou use um existente que seja válido.",
                "customer_max_payment_methods": "O número máximo de métodos de pagamento para este cliente foi atingido. Desvincule alguns métodos de pagamento deste cliente ou prossiga com um cliente diferente.",
                "customer_max_subscriptions": "O número máximo de assinaturas para um cliente foi atingido. Entre em contato conosco se você estiver recebendo este erro.",
                "customer_tax_location_invalid": "As informações de localização do cliente não podem ser usadas para determinar com precisão as taxas. Verifique se os campos de endereço, como país, estado e código postal, foram adicionados corretamente. Consulte os formatos de endereço suportados.",
                "debit_not_authorized": "O cliente notificou seu banco que este pagamento não foi autorizado.",
                "email_invalid": "O endereço de e-mail é inválido (por exemplo, não está formatado corretamente). Verifique se o endereço de e-mail está formatado corretamente e inclui apenas caracteres permitidos.",
                "expired_card": "O cartão expirou. Verifique a data de validade ou use um cartão diferente.",
                "financial_connections_account_inactive": "Os dados não podem ser atualizados em contas de Conexões Financeiras inativas.",
                "financial_connections_no_successful_transaction_refresh": "Os dados da transação só podem ser recuperados para contas que têm pelo menos uma atualização de transação bem-sucedida.",
                "forwarding_api_inactive": "A API de armazenamento e encaminhamento atualmente não está acessível com esta conta e/ou configuração. Entre em contato conosco se estiver recebendo este erro.",
                "forwarding_api_invalid_parameter": "Foi fornecido um parâmetro inválido na API de armazenamento e encaminhamento. Verifique nossa documentação da API ou a mensagem de erro retornada para mais contexto.",
                "forwarding_api_upstream_connection_error": "A Stripe não recebeu uma resposta do endpoint de destino.",
                "forwarding_api_upstream_connection_timeout": "A solicitação para o endpoint de destino expirou.",
                "idempotency_key_in_use": "A chave de idempotência fornecida está atualmente sendo usada em outra solicitação. Isso ocorre se sua integração estiver fazendo solicitações duplicadas simultaneamente.",
                "incorrect_address": "O endereço de cobrança está incorreto. Verifique o endereço do cartão ou use um cartão diferente.",
                "incomplete_address": "O endereço de cobrança está incompleto. Verifique o endereço do cartão ou use um cartão diferente.",
                "incomplete_name": "Informe seu nome completo.",
                "incorrect_cvc": "O código de segurança do cartão está incorreto. Verifique o código de segurança do cartão ou use um cartão diferente.",
                "incorrect_number": "O número do cartão está incorreto. Verifique o número do cartão ou use um cartão diferente.",
                "incorrect_zip": "O código postal do cartão está incorreto. Verifique o código postal do cartão ou use um cartão diferente.",
                "incomplete_number": "O número do cartão está incompleto. Verifique o número do cartão ou use um cartão diferente.",
                "incomplete_cvc": "O código de segurança do cartão está incompleto. Verifique o código de segurança do cartão ou use um cartão diferente.",
                "incomplete_expiry": "A data de validade do cartão está incompleta. Verifique a data de validade do cartão ou use um cartão diferente.",
                "incorrect_expiry_month": "O mês de validade do cartão está incorreto. Verifique a data de validade do cartão ou use um cartão diferente.",
                "incorrect_expiry_year": "O ano de validade do cartão está incorreto. Verifique a data de validade do cartão ou use um cartão diferente.",
                "incorrect_cvc_length": "O código de segurança do cartão é inválido. Verifique o código de segurança do cartão ou use um cartão diferente.",
                "incorret_boleto_tax_id": "O CPF/CNPJ fornecido é inválido.",
                "invalid_expiry_year_past": "O ano de validade do cartão está no passado. Verifique a data de validade do cartão ou use um cartão diferente.",
                "instant_payouts_config_disabled": "Esta conta conectada não é elegível para Pagamentos Instantâneos. Peça à plataforma para habilitar Pagamentos Instantâneos.",
                "instant_payouts_currency_disabled": "Esta conta conectada não é elegível para Pagamentos Instantâneos nesta moeda. Peça à plataforma para habilitar Pagamentos Instantâneos nesta moeda.",
                "instant_payouts_limit_exceeded": "Você atingiu seus limites diários de processamento para Pagamentos Instantâneos.",
                "instant_payouts_unsupported": "Este cartão não é elegível para Pagamentos Instantâneos. Tente um cartão de débito de um banco suportado.",
                "insufficient_funds": "A conta do cliente não possui fundos suficientes para cobrir este pagamento.",
                "intent_invalid_state": "A intenção não está no estado necessário para realizar a operação.",
                "intent_verification_method_missing": "A intenção não possui um método de verificação especificado em seu objeto PaymentMethodOptions.",
                "invalid_card_type": "O cartão fornecido como conta externa não é suportado para pagamentos. Forneça um cartão de débito não pré-pago em vez disso.",
                "invalid_characters": "Este valor fornecido ao campo contém caracteres que não são suportados pelo campo.",
                "invalid_charge_amount": "O valor especificado é inválido. O valor da cobrança deve ser um inteiro positivo na menor unidade da moeda e não deve exceder o valor mínimo ou máximo.",
                "invalid_cvc": "O código de segurança do cartão é inválido. Verifique o código de segurança do cartão ou use um cartão diferente.",
                "invalid_expiry_month": "O mês de validade do cartão está incorreto. Verifique a data de validade ou use um cartão diferente.",
                "invalid_expiry_year": "O ano de validade do cartão está incorreto. Verifique a data de validade ou use um cartão diferente.",
                "invalid_number": "O número do cartão é inválido. Verifique os detalhes do cartão ou use um cartão diferente.",
                "invalid_source_usage": "A fonte não pode ser usada porque não está no estado correto (por exemplo, uma solicitação de cobrança está tentando usar uma fonte com uma fonte pendente, falha ou consumida). Verifique o status da fonte que você está tentando usar.",
                "invalid_tax_location": "A localização especificada é inválida. Verifique os Formatos de endereço suportados para os formatos de endereço suportados ao calcular o imposto.",
                "invoice_no_customer_line_items": "Não é possível gerar uma fatura para o cliente especificado, pois não há itens de fatura pendentes. Verifique se o cliente correto está sendo especificado ou crie quaisquer itens de fatura necessários primeiro.",
                "invoice_no_payment_method_types": "Não é possível finalizar uma fatura porque não há tipos de métodos de pagamento disponíveis para processar o pagamento. As configurações de modelo de fatura ou as configurações de pagamento da fatura podem estar restringindo quais métodos de pagamento estão disponíveis, ou você pode precisar ativar mais métodos de pagamento no Dashboard.",
                "invoice_no_subscription_line_items": "Não é possível gerar uma fatura para a assinatura especificada, pois não há itens de fatura pendentes. Verifique se a assinatura correta está sendo especificada ou crie quaisquer itens de fatura necessários primeiro.",
                "invoice_not_editable": "A fatura especificada não pode mais ser editada. Considere criar itens de fatura adicionais que serão aplicados à próxima fatura. Você pode gerar manualmente a próxima fatura ou aguardar que ela seja gerada automaticamente no final do ciclo de faturamento.",
                "invoice_on_behalf_of_not_editable": "Você não pode atualizar a propriedade on_behalf_of de uma fatura após a fatura ter sido atribuída a um número.",
                "invoice_payment_intent_requires_action": "Este pagamento requer ação adicional do usuário antes de poder ser concluído com sucesso. O pagamento pode ser concluído usando o PaymentIntent associado à fatura. Consulte esta página para mais detalhes.",
                "invoice_upcoming_none": "Não há fatura futura para o cliente especificado para visualizar. Somente clientes com assinaturas ativas ou itens de fatura pendentes têm faturas que podem ser visualizadas.",
                "livemode_mismatch": "Chaves de API, solicitações e objetos de modo de teste e modo de produção estão disponíveis apenas dentro do modo em que estão.",
                "lock_timeout": "Este objeto não pode ser acessado agora porque outra solicitação de API ou processo Stripe está acessando-o atualmente. Se você vir esse erro de forma intermitente, tente novamente a solicitação. Se você vir esse erro com frequência e estiver fazendo várias solicitações simultâneas a um único objeto, faça suas solicitações em série ou a uma taxa mais baixa. Consulte a documentação de limites de taxa para mais detalhes.",
                "missing": "Ambos um cliente e um ID de fonte foram fornecidos, mas a fonte não foi salva para o cliente. Para criar uma cobrança para um cliente com uma fonte especificada, você deve primeiro salvar os detalhes do cartão.",
                "no_account": "A conta bancária não pôde ser localizada.",
                "not_allowed_on_standard_account": "Transferências e pagamentos em nome de uma conta conectada Padrão não são permitidos.",
                "no_payment_method": "Nenhum método de pagamento foi fornecido. Crie um novo método de pagamento ou use um existente.",
                "out_of_inventory": "Um ou mais itens da linha estão fora de estoque. Se mais estoque estiver disponível, atualize a quantidade disponível para pedido do inventário e tente novamente.",
                "ownership_declaration_not_allowed": "A declaração de propriedade da empresa é permitida apenas durante atualizações de conta e contas criadas via tokens de conta.",
                "parameter_invalid_empty": "Um ou mais valores obrigatórios não foram fornecidos. Certifique-se de que as solicitações incluam todos os parâmetros obrigatórios.",
                "parameter_invalid_integer": "Um ou mais parâmetros requerem um inteiro, mas os valores fornecidos eram de um tipo diferente. Certifique-se de que apenas valores suportados sejam fornecidos para cada atributo. Consulte nossa documentação da API para verificar o tipo de dados que cada atributo suporta.",
                "parameter_invalid_string_blank": "Um ou mais valores fornecidos incluíam apenas espaços em branco. Verifique os valores em sua solicitação e atualize os que contêm apenas espaços em branco.",
                "parameter_invalid_string_empty": "Um ou mais valores de string obrigatórios estão vazios. Certifique-se de que os valores de string contenham pelo menos um caractere.",
                "parameter_missing": "Um ou mais valores obrigatórios estão faltando. Consulte nossa documentação da API para verificar quais valores são obrigatórios para criar ou modificar o recurso especificado.",
                "parameter_unknown": "A solicitação contém um ou mais parâmetros inesperados. Remova-os e tente novamente.",
                "parameters_exclusive": "Dois ou mais parâmetros mutuamente exclusivos foram fornecidos. Consulte nossa documentação da API ou a mensagem de erro retornada para verificar quais valores são permitidos ao criar ou modificar o recurso especificado.",
                "payment_intent_action_required": "O método de pagamento fornecido requer ações do cliente para ser concluído, mas error_on_requires_action foi definido. Se você deseja adicionar este método de pagamento à sua integração, recomendamos primeiro atualizar sua integração para lidar com ações.",
                "payment_intent_authentication_failure": "O método de pagamento fornecido falhou na autenticação. Forneça um novo método de pagamento para tentar concluir este PaymentIntent novamente.",
                "payment_intent_incompatible_payment_method": "O PaymentIntent esperava um método de pagamento com propriedades diferentes do que foi fornecido.",
                "payment_intent_invalid_parameter": "Um ou mais parâmetros fornecidos não foram permitidos para a operação dada no PaymentIntent. Verifique nossa referência da API ou a mensagem de erro retornada para verificar quais valores não estavam corretos para esse PaymentIntent.",
                "payment_intent_konbini_rejected_confirmation_number": "O número de confirmação fornecido em payment_method_options[konbini] foi rejeitado pelo parceiro de processamento no momento da confirmação do PaymentIntent.",
                "payment_intent_mandate_invalid": "O mandato fornecido é inválido e não pode ser usado para o intent de pagamento.",
                "payment_intent_payment_attempt_expired": "A última tentativa de pagamento para o PaymentIntent expirou. Verifique a propriedade last_payment_error no PaymentIntent para mais detalhes e forneça um novo método de pagamento para tentar concluir este PaymentIntent novamente.",
                "payment_intent_payment_attempt_failed": "A última tentativa de pagamento para o PaymentIntent falhou. Verifique a propriedade last_payment_error no PaymentIntent para mais detalhes e forneça um novo método de pagamento para tentar concluir este PaymentIntent novamente.",
                "payment_intent_unexpected_state": "O estado do PaymentIntent era incompatível com a operação que você estava tentando realizar.",
                "payment_method_bank_account_already_verified": "Esta conta bancária já foi verificada.",
                "payment_method_bank_account_blocked": "Esta conta bancária falhou na verificação no passado e não pode ser usada. Entre em contato conosco se desejar tentar usar essas credenciais de conta bancária.",
                "payment_method_billing_details_address_missing": "Os detalhes de cobrança do PaymentMethod estão faltando detalhes de endereço. Atualize os campos ausentes e tente novamente.",
                "payment_method_configuration_failures": "A tentativa de criar ou modificar a Configuração do Método de Pagamento não foi bem-sucedida.",
                "payment_method_currency_mismatch": "A moeda especificada não corresponde à moeda do método de pagamento anexado. Um pagamento só pode ser criado para a mesma moeda que o método de pagamento correspondente.",
                "payment_method_customer_decline": "O cliente não aprovou o pagamento. Forneça um novo método de pagamento para tentar concluir esta intenção novamente.",
                "payment_method_invalid_parameter": "Foi fornecido um parâmetro inválido no objeto do método de pagamento. Verifique nossa documentação da API ou a mensagem de erro retornada para mais contexto.",
                "payment_method_invalid_parameter_testmode": "O parâmetro fornecido para o método de pagamento não é permitido para ser usado no modo de teste. Verifique nossa documentação da API ou a mensagem de erro retornada para mais contexto.",
                "payment_method_microdeposit_failed": "Os microdepósitos não foram depositados na conta bancária do cliente. Verifique o número da conta, os números da instituição e de trânsito, bem como o tipo de moeda.",
                "payment_method_microdeposit_verification_amounts_invalid": "Você deve fornecer exatamente dois valores de microdepósito.",
                "payment_method_microdeposit_verification_amounts_mismatch": "Os valores fornecidos não correspondem aos valores que foram enviados para a conta bancária.",
                "payment_method_microdeposit_verification_attempts_exceeded": "Você excedeu o número de tentativas de verificação permitidas.",
                "payment_method_microdeposit_verification_descriptor_code_mismatch": "O código de verificação fornecido não corresponde ao enviado para a conta bancária.",
                "payment_method_microdeposit_verification_timeout": "O método de pagamento deve ser verificado com microdepósitos dentro do período necessário.",
                "payment_method_not_available": "O processador de pagamento para o método de pagamento fornecido está temporariamente indisponível. Tente um método de pagamento diferente ou tente novamente mais tarde com o mesmo método de pagamento.",
                "payment_method_provider_decline": "A tentativa de pagamento ou configuração foi recusada pelo emissor ou cliente. Verifique a propriedade last_payment_error ou last_setup_error no PaymentIntent ou SetupIntent, respectivamente, para mais detalhes, e forneça um novo método de pagamento para tentar concluir esta intenção novamente.",
                "payment_method_provider_timeout": "O método de pagamento falhou devido a um tempo limite. Verifique a propriedade last_payment_error ou last_setup_error no PaymentIntent ou SetupIntent, respectivamente, para mais detalhes, e forneça um novo método de pagamento para tentar concluir esta intenção novamente.",
                "payment_method_unactivated": "A operação não pode ser realizada, pois o método de pagamento usado não foi ativado. Ative o método de pagamento no Dashboard e tente novamente.",
                "payment_method_unexpected_state": "O estado do método de pagamento fornecido era incompatível com a operação que você estava tentando realizar. Confirme que o método de pagamento está em um estado permitido para a operação dada antes de tentar realizá-la.",
                "payment_method_unsupported_type": "A API só suporta métodos de pagamento de certos tipos.",
                "payout_reconciliation_not_ready": "A reconciliação para este pagamento ainda está em andamento.",
                "payouts_limit_exceeded": "Você atingiu seus limites diários de processamento para este tipo de pagamento.",
                "payouts_not_allowed": "Os pagamentos foram desativados na conta conectada. Verifique o status da conta conectada para ver se é necessário fornecer informações adicionais ou se os pagamentos foram desativados por outro motivo.",
                "platform_account_required": "Somente plataformas Stripe Connect podem trabalhar com outras contas. Se você precisar configurar uma plataforma Stripe Connect, poderá fazê-lo no painel de controle.",
                "platform_api_key_expired": "A chave API fornecida pela sua plataforma Connect expirou. Isso ocorre se sua plataforma gerou uma nova chave ou se a conta conectada foi desconectada da plataforma. Obtenha suas chaves API atuais no painel de controle e atualize sua integração, ou entre em contato com o usuário e reconecte a conta.",
                "postal_code_invalid": "O código postal fornecido estava incorreto.",
                "processing_error": "Ocorreu um erro ao processar o cartão. Tente novamente mais tarde ou com um método de pagamento diferente.",
                "product_inactive": "O produto ao qual este SKU pertence não está mais disponível para compra.",
                "progressive_onboarding_limit_exceeded": "O limite de integração progressiva foi atingido para a plataforma.",
                "rate_limit": "Muitas solicitações atingiram a API muito rapidamente. Recomendamos um retrocesso exponencial de suas solicitações.",
                "refer_to_customer": "O cliente interrompeu o pagamento com seu banco. Entre em contato com ele para obter detalhes e para organizar o pagamento.",
                "refund_disputed_payment": "Você não pode reembolsar um pagamento contestado.",
                "resource_already_exists": "Um recurso com um ID especificado pelo usuário (por exemplo, plano ou cupom) já existe. Use um valor diferente e exclusivo para o ID e tente novamente.",
                "resource_missing": "O ID fornecido não é válido. Ou o recurso não existe ou foi fornecido um ID para um recurso diferente.",
                "return_intent_already_processed": "Você não pode confirmar este reembolso, pois ele já foi processado.",
                "routing_number_invalid": "O número de roteamento bancário fornecido é inválido.",
                "secret_key_required": "A chave API fornecida é uma chave publicável, mas é necessária uma chave secreta. Obtenha suas chaves API atuais no painel de controle e atualize sua integração para usá-las.",
                "sepa_unsupported_account": "Sua conta não suporta pagamentos SEPA.",
                "setup_attempt_failed": "A última tentativa de configuração para o SetupIntent falhou. Verifique a propriedade last_setup_error no SetupIntent para mais detalhes e forneça um novo método de pagamento para tentar configurá-lo novamente.",
                "setup_intent_authentication_failure": "O método de pagamento fornecido falhou na autenticação. Forneça um novo método de pagamento para tentar concluir este SetupIntent novamente.",
                "setup_intent_invalid_parameter": "Um ou mais parâmetros fornecidos não foram permitidos para a operação dada no SetupIntent. Verifique nossa referência da API ou a mensagem de erro retornada para verificar quais valores não estavam corretos para esse SetupIntent.",
                "setup_intent_mandate_invalid": "O mandato fornecido é inválido e não pode ser usado para a intenção de configuração.",
                "setup_intent_setup_attempt_expired": "A última tentativa de configuração para o SetupIntent expirou. Verifique a propriedade last_setup_error no SetupIntent para mais detalhes e forneça um novo método de pagamento para tentar concluir este SetupIntent novamente.",
                "setup_intent_unexpected_state": "O estado do SetupIntent era incompatível com a operação que você estava tentando realizar.",
                "shipping_address_invalid": "As informações de endereço de envio não podem ser usadas para determinar com precisão as taxas. Verifique se os campos de endereço, como código postal, estado ou província, foram adicionados corretamente.",
                "shipping_calculation_failed": "O cálculo do frete falhou porque as informações fornecidas estavam incorretas ou não puderam ser verificadas.",
                "sku_inactive": "O SKU está inativo e não está mais disponível para compra. Use um SKU diferente ou torne o SKU atual ativo novamente.",
                "state_unsupported": "Ocorre ao fornecer informações de entidade legal para uma conta personalizada dos EUA, se o estado fornecido não for suportado. (Isso está principalmente associado a estados e territórios.)",
                "status_transition_invalid": "A transição de status solicitada não é válida.",
                "stripe_tax_inactive": "O Stripe Tax não foi ativado na sua conta. Consulte a documentação de configuração para começar.",
                "tax_id_invalid": "O número de identificação fiscal fornecido é inválido (por exemplo, dígitos faltando). As informações de identificação fiscal variam de país para país, mas devem ter pelo menos nove dígitos.",
                "taxes_calculation_failed": "O cálculo de impostos para o pedido falhou.",
                "terminal_location_country_unsupported": "O terminal está atualmente disponível apenas em alguns países. Locais no seu país não podem ser criados no modo de produção.",
                "terminal_reader_busy": "O leitor está ocupado processando outra solicitação. Consulte o guia de integração para obter detalhes sobre como lidar com este erro.",
                "terminal_reader_hardware_fault": "O leitor não pode mais aceitar pagamentos, pois foi detectada uma falha de hardware irrecuperável. Entre em contato com o suporte da Stripe em https://support.stripe.com/contact/email e forneça o número de série do seu leitor para substituição.",
                "terminal_reader_invalid_location_for_payment": "O leitor não pode aceitar pagamentos no local registrado atualmente. Registre o leitor em um novo local. Consulte Gerenciar locais para mais informações.",
                "terminal_reader_offline": "O leitor está offline no momento, certifique-se de que o leitor está ligado e conectado à internet antes de tentar novamente. Consulte o guia de integração para obter detalhes sobre como lidar com este erro.",
                "terminal_reader_timeout": "Ocorreu um tempo limite ao enviar este comando para o leitor. Consulte o guia de integração para obter detalhes sobre como lidar com este erro.",
                "testmode_charges_only": "Sua conta não foi ativada e só pode fazer cobranças de teste. Ative sua conta no painel de controle para começar a processar cobranças reais.",
                "tls_version_unsupported": "Sua integração está usando uma versão mais antiga do TLS que não é suportada. Você deve usar o TLS 1.2 ou superior.",
                "token_already_used": "O token fornecido já foi usado. Você deve criar um novo token antes de tentar esta solicitação novamente.",
                "token_card_network_invalid": "Foi fornecido um parâmetro de rede de cartão inválido no objeto do token do cartão. Verifique nossa documentação da API ou a mensagem de erro retornada para mais contexto.",
                "token_in_use": "O token fornecido está sendo usado em outra solicitação. Isso ocorre se sua integração estiver fazendo solicitações duplicadas simultaneamente.",
                "transfer_source_balance_parameters_mismatch": "Ao criar uma Transferência, o parâmetro payments em source_balance não deve ser passado quando o tipo de saldo é definido como issuing.",
                "transfers_not_allowed": "A transferência solicitada não pode ser criada. Entre em contato conosco se estiver recebendo este erro.",
                "url_invalid": "A URL fornecida é inválida."
            }
        },
        "tickets": {
            "empty": {
                "title": "Ops! Você não tem nenhum ticket",
                "subtitle": "Você pode criar um novo ticket clicando abaixo",
                "button": "Novo ticket"
            }
        },
        "validation": {
            "accepted": "O campo {attribute} deve ser aceito.",
            "active_url": "O campo {attribute} não é uma URL válida.",
            "after": "O campo {attribute} deve ser uma data posterior a {date}.",
            "after_or_equal": "O campo {attribute} deve ser uma data posterior ou igual a {date}.",
            "alpha": "O campo {attribute} só pode conter letras.",
            "alpha_dash": "O campo {attribute} só pode conter letras, números e traços.",
            "alpha_num": "O campo {attribute} só pode conter letras e números.",
            "array": "O campo {attribute} deve ser uma matriz.",
            "before": "O campo {attribute} deve ser uma data anterior {date}.",
            "before_or_equal": "O campo {attribute} deve ser uma data anterior ou igual a {date}.",
            "between": {
                "numeric": "O campo {attribute} deve ser entre {min} e {max}.",
                "file": "O campo {attribute} deve ser entre {min} e {max} kilobytes.",
                "string": "O campo {attribute} deve ser entre {min} e {max} caracteres.",
                "array": "O campo {attribute} deve ter entre {min} e {max} itens."
            },
            "err": "Erro de validação",
            "boolean": "O campo {attribute} deve ser verdadeiro ou falso.",
            "confirmed": "O campo {attribute} de confirmação não confere.",
            "date": "O campo {attribute} não é uma data válida.",
            "date_format": "O campo {attribute} não corresponde ao formato {format}.",
            "different": "Os campos {attribute} e {other} devem ser diferentes.",
            "digits": "O campo {attribute} deve ter {digits} dígitos.",
            "digits_between": "O campo {attribute} deve ter entre {min} e {max} dígitos.",
            "dimensions": "O campo {attribute} tem dimensões de imagem inválidas.",
            "distinct": "O campo {attribute} campo tem um valor duplicado.",
            "email": "O campo {attribute} deve ser um endereço de e-mail válido.",
            "exists": "O campo {attribute} selecionado é inválido.",
            "file": "O campo {attribute} deve ser um arquivo.",
            "filled": "O campo {attribute} deve ter um valor.",
            "image": "O campo {attribute} deve ser uma imagem.",
            "in": "O campo {attribute} selecionado é inválido.",
            "in_array": "O campo {attribute} não existe em {other}.",
            "integer": "O campo {attribute} deve ser um número inteiro.",
            "ip": "O campo {attribute} deve ser um endereço de IP válido.",
            "ipv4": "O campo {attribute} deve ser um endereço IPv4 válido.",
            "ipv6": "O campo {attribute} deve ser um endereço IPv6 válido.",
            "json": "O campo {attribute} deve ser uma string JSON válida.",
            "max": {
                "numeric": "O campo {attribute} não pode ser superior a {max}.",
                "file": "O campo {attribute} não pode ser superior a {max} kilobytes.",
                "string": "O campo {attribute} não pode ser superior a {max} caracteres.",
                "array": "O campo {attribute} não pode ter mais do que {max} itens."
            },
            "mimes": "O campo {attribute} deve ser um arquivo do tipo: {values}.",
            "mimetypes": "O campo {attribute} deve ser um arquivo do tipo: {values}.",
            "min": {
                "numeric": "O campo {attribute} deve ser pelo menos {min}.",
                "file": "O campo {attribute} deve ter pelo menos {min} kilobytes.",
                "string": "O campo {attribute} deve ter pelo menos {min} caracteres.",
                "array": "O campo {attribute} deve ter pelo menos {min} itens."
            },
            "not_in": "O campo {attribute} selecionado é inválido.",
            "numeric": "O campo {attribute} deve ser um número.",
            "present": "O campo {attribute} deve estar presente.",
            "regex": "O campo {attribute} tem um formato inválido.",
            "required": "O campo {attribute} é obrigatório.",
            "required_if": "O campo {attribute} é obrigatório quando {other} for {value}.",
            "required_unless": "O campo {attribute} é obrigatório exceto quando {other} for {values}.",
            "required_with": "O campo {attribute} é obrigatório quando {values} está presente.",
            "required_with_all": "O campo {attribute} é obrigatório quando {values} está presente.",
            "required_without": "O campo {attribute} é obrigatório quando {values} não está presente.",
            "required_without_all": "O campo {attribute} é obrigatório quando nenhum dos {values} estão presentes.",
            "same": "Os campos {attribute} e {other} devem corresponder.",
            "size": {
                "numeric": "O campo {attribute} deve ser {size}.",
                "file": "O campo {attribute} deve ser {size} kilobytes.",
                "string": "O campo {attribute} deve ser {size} caracteres.",
                "array": "O campo {attribute} deve conter {size} itens."
            },
            "string": "O campo {attribute} deve ser uma string.",
            "timezone": "O campo {attribute} deve ser uma zona válida.",
            "unique": "O {attribute} já está sendo utilizado.",
            "uploaded": "Ocorreu uma falha no upload do campo {attribute}.",
            "url": "O campo {attribute} tem um formato inválido.",
            "white_space": "O campo {attribute} não deve conter espaços em branco",
            "reserved_in_system": "Esse nome é reservado pelo sistema.",
            "custom": {
                "already_exists": "Já existe um registro com esse valor",
                "fields": "Campos obrigatórios não preenchidos",
                "document": {
                    "unique": "Já existe um aluno com o documento cadastrado"
                },
                "email": {
                    "unique": "Já existe um aluno com o email cadastrado"
                },
                "address": {
                    "postal_code": {
                        "invalid": "O CEP informado é inválido"
                    },
                    "fields_required": "Todos os campos do endereço são obrigatórios"
                }
            },
            "attributes": {
                "document": "documento"
            }
        },
        "dashboard": {
            "courses": "Cursos",
            "content": "Conteúdo",
            "lessons": "Aulas",
            "exercises": {
                "title": "Exercícios",
                "answers": "Questões Respondidas"
            },
            "plan": {
                "change": "Alterar Plano",
                "external_status_title": "Confirmação de matrícula",
                "external_status_description": "Olá {name}, estamos ansiosos para iniciar as atividades. <br> Para confirmar a matrícula clique no botão abaixo.",
                "external_status_ok": "Confirmar matrícula",
                "unavailable_content": "Conteúdo ainda não disponível",
                "release_date": "Data de lançamento: "
            },
            "plans": "Planos",
            "in_progress": "Em Andamento",
            "no_plans": "Você não tem nenhum plano",
            "empty_message": "Adquira ao menos um plano para ter acesso ao seu conteúdo",
            "redirect_showcase": "Vitrine de Planos",
            "access": "Acessar",
            "start": "Iniciar",
            "continue": "Continuar",
            "disabled": "Desativado",
            "progress": "Progresso",
            "notifications": {
                "title": "Notificações Dashboard",
                "name": "Notificações"
            },
            "expiration_days": "Dias para expiração",
            "expiration_date": "Data de expiração",
            "tomorrow": "Amanhã",
            "today": "Hoje",
            "expired": "Expirado"
        },
        "leads": {
            "capture_title": "Acesso ao Conteúdo",
            "access_content": "Acesse o Conteúdo Exclusivo",
            "fill_form_access": "Preencha os dados abaixo para ter acesso ao conteúdo",
            "name": "Nome",
            "email": "E-mail",
            "phone": "Telefone",
            "name_placeholder": "Digite seu nome completo",
            "email_placeholder": "Digite seu melhor e-mail",
            "phone_placeholder": "Digite seu telefone",
            "access_content_btn": "Acessar Conteúdo",
            "privacy_notice": "Seus dados estão seguros e protegidos conosco",
            "not_provided": "Não informado",
            "errors": {
                "name_required": "O nome é obrigatório",
                "name_min_length": "O nome deve ter pelo menos 2 caracteres",
                "email_required": "O e-mail é obrigatório",
                "email_invalid": "Digite um e-mail válido",
                "phone_required": "O telefone é obrigatório",
                "phone_invalid": "Digite um telefone válido",
                "plan_required": "Plano é obrigatório",
                "plan_not_found": "Plano não encontrado",
                "plan_not_available": "Este plano não está disponível para captura de leads",
                "lead_config_not_found": "Configuração de leads não encontrada para este plano",
                "at_least_one_field_required": "Preencha pelo menos um campo para continuar",
                "validation_failed": "Verifique os dados informados",
                "submission_failed": "Erro ao processar seus dados. Tente novamente",
                "list_failed": "Erro ao carregar lista de leads"
            },
            "success": {
                "captured": "Dados salvos com sucesso! Redirecionando..."
            }
        }
    }
}
